import React, { Component, Fragment } from 'react'
import gql from 'graphql-tag'
import { ADD_ELOCK_CONNECTION } from '../../../../queries'
import { GET_ALL_TIMEZONES } from '../queries'
import { Mutation, withApollo, Query } from 'react-apollo'
import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import FormHelperText from '@material-ui/core/FormHelperText'
import Select from '@material-ui/core/Select'
import Switch from '@material-ui/core/Switch'

import Input from '@material-ui/core/Input'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import Typography from '@material-ui/core/Typography'
import ClientDetails from '../ClientDetails'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import Dialog from '@material-ui/core/Dialog'
import { withStyles } from '@material-ui/core/styles'
import getLoginId from '../../../../utils/getLoginId'
import normalizeFuelType from '../../../../utils/normalizeFuelType'
import ChangeVehicleStatus from './ChangeVehicleStatus'
import DecoupleDevices from './DecoupleDevices'
import withSharedSnackbar from '../../../HOCs/withSharedSnackbar'
import '../vehicle.css'
import DeleteForever from '@material-ui/icons/DeleteForever'
// import SwapHoriz from '@material-ui/icons/SwapHoriz'
import Tooltip from '@material-ui/core/Tooltip'
import SwapClient from './SwapClient'
import DeleteVehicle from './DeleteVehicle'
import CircularProgress from '@material-ui/core/CircularProgress'
import { DatePicker } from 'material-ui-pickers'
import axios from 'axios'
import FileSaver from 'file-saver'

import {
  IconButton,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Container
} from '@material-ui/core'
import TensionerRotationSensorReminder from '../TensionerRotationSensorReminder'
import InstallationImagesSection from '../InstallationImagesSection'
import { buildInitialEntries, entriesToState } from '../installationImageUtils'
import SelectReact from 'react-select'
import moment from 'moment'
import { phaseOptionsArray } from '../../../../utils/phaseOptionsArray'

const GET_UPLOAD_URL = gql`
  mutation($fileExtension: String!) {
    getPublicUploadURL(fileExtension: $fileExtension) {
      bucketName
      filename
      publicUploadURL
    }
  }
`



const SolutionTypeOption = props => {
  const { onSelect, onFocus, isSelected, option, children, className } = props
  const handleMouseDown = event => {
    event.preventDefault()
    event.stopPropagation()
    onSelect(option, event)
  }
  const handleMouseEnter = event => {
    onFocus(option, event)
  }

  return (
    <div
      className={className}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseEnter}
      title={option.title}
      style={{ display: 'flex', alignItems: 'center' }}
    >
      <Checkbox checked={!!isSelected} color="primary" />
      <span>{children}</span>
    </div>
  )
}

const GET_VLPN = gql`
  query checkVehicleNumber($vlpn: String!) {
    checkVehicleNumber(vehicleNumber: $vlpn)
  }
` /* eslint-disable */
// calling server for updation
const UPDATE_VEHICLE = gql`
  mutation updateVehicleDetail(
    $entityId: Int!
    $vehicleNumber: String!
    $engineNumber: String
    $chassisNumber: String
    $clientLoginId: Int!
    $speedSensorType: String!
    $speedLimit: Int!
    $vehicleType: String!
    $vehicleModel: String!
    $vehicleMake: String
    $vehicleModelId: String
    $vehicleMakeId: String
    $vehicleCapacity: Int
    $equipmentSerialNumber: String
    $equipmentName: String
    $commissioningDate: Int
    $invoiceDate: Int
    $department: String
    $idlingSpeed: Int
    $invoiceNumber: String
    $isActivated: Boolean
    $status: Int!
    $contractorName: String
    $engineTorque: String
    $engineLoad: String
    $fuelType: String
    $torquePower: String
    $engineSpecification: String
    $emissionRateType: String
    $grossVehicleWeight: Float
    $manufacturingYear: Int
    $vehicleSegment: String
    $equipmentTypeClass: String
    $vehicleWheeler: String
    $application: String
    $haulageType: String
    $constructionVehicleType: String
    $passengerVehicleType: String
    $transportationVehicleType: String
    $vehicleNickName: String
    $documentUpload: String
    $documentUploadNew: JSON
    $baselineDataForFE: Float
    $baselineDataForFELPH: Float
    $baselineDataType: String
    $fuelTankCapacity: String
    $adblueCapacity: String
    $baselineDistance: Float
    $immobilize: Boolean
    $solutionType: String
    $solution_type: [String]
    $zonalManager: String
    $keyAccountManager: String
    $channelPartnerName: String
    $isDualEngine: Boolean
    $eoff_voltage: Float
    $eon_voltage: Float
    $hasArm: Boolean
    $isElockConnection: Boolean
    $duplicateVehicle: Boolean
    $portedVehicle: Boolean
    $isTestingVehicle: Boolean
    $kvaRating: String
    $dgSetType: String
    $bhp: String
    $phase: String
    $engineModel: String
    $gensetController: String
    $videoTelematicsType: String
    $videoTelematicsId: String
    $inputParameter: Float
    $multiplicationFactor: Float
    $engineOnHours: String
    $odometerDistance: String
    $noOfGears: Int
    $vehicleCustomizedBodyType: String
    $isIndividualViewOrCombinedView: Boolean
    $baselineHours: Int
    $noOfWheels: Int
    $custType: String
    $custCode: String
    $clientName: String
    $vehicleClass: String
    $fuelCode: String
    $numberOfAxles: Int
    $permitCode: String
    $insurerName: String
    $insuranceUpto: String
    $permitType: String
    $permitValidUpto: String
    $permitValidFrom: String
    $permitNumber: String
    $permitIssueDate: String
    $puccUpto: String
    $registeredAt: String
    $unladenWeight: Int
    $manufacturingMonthYear: String
    $taxUpto: String
    $nationalPermitUpto: String
    $fitmentUpto: String
    $emissionNormsDescription: String
    $bodyTypeDescription: String
    $makerModel: String
    $makerDescription: String
    $vehicleClassDescription: String
    $vehicleCategoryDescription: String
    $vehicleRegistrationNumber: String
    $registrationDate: String
    $registrationValidUpto: String
    $stateCode: String
    $rtoCode: String
    $vehicleCategoryCode: String
    $gearRatio: String
    $tensionerConductorLength: Float
    $tensionerRotationSensorDirection: String
    $isRotationSensor: Boolean
    $technicianName: String
    $updatedBy: String
    $rcsSerialNumber: String
    $istachoenabled: Boolean
    $tachoidlerpm: Int
    $tachoshifthours: Int
    $tachoengineonmin: Int
    $tachoengineonmax: Int
    $timezone_offset: String
    $plant_code: String
    $owner_type: String
    $equipment_type: String
    $equipment_no: String
  ) {
    updateVehicleDetail(
      entityId: $entityId
      vehicleNumber: $vehicleNumber
      engineNumber: $engineNumber
      chassisNumber: $chassisNumber
      clientLoginId: $clientLoginId
      speedSensorType: $speedSensorType
      speedLimit: $speedLimit
      vehicleType: $vehicleType
      vehicleModel: $vehicleModel
      vehicleMake: $vehicleMake
      vehicleModelId: $vehicleModelId
      vehicleMakeId: $vehicleMakeId
      vehicleCapacity: $vehicleCapacity
      equipmentSerialNumber: $equipmentSerialNumber
      equipmentName: $equipmentName
      commissioningDate: $commissioningDate
      invoiceDate: $invoiceDate
      department: $department
      idlingSpeed: $idlingSpeed
      invoiceNumber: $invoiceNumber
      isActivated: $isActivated
      immobilize: $immobilize
      status: $status
      contractorName: $contractorName
      engineTorque: $engineTorque
      engineLoad: $engineLoad
      fuelType: $fuelType
      torquePower: $torquePower
      engineSpecification: $engineSpecification
      emissionRateType: $emissionRateType
      engineOnHours: $engineOnHours
      odometerDistance: $odometerDistance
      grossVehicleWeight: $grossVehicleWeight
      manufacturingYear: $manufacturingYear
      vehicleSegment: $vehicleSegment
      equipmentTypeClass: $equipmentTypeClass
      vehicleWheeler: $vehicleWheeler
      application: $application
      haulageType: $haulageType
      constructionVehicleType: $constructionVehicleType
      passengerVehicleType: $passengerVehicleType
      transportationVehicleType: $transportationVehicleType
      vehicleNickName: $vehicleNickName
      documentUpload: $documentUpload
      documentUploadNew: $documentUploadNew
      baselineDataForFE: $baselineDataForFE
      baselineDataForFELPH: $baselineDataForFELPH
      baselineDataType: $baselineDataType
      fuelTankCapacity: $fuelTankCapacity
      adblueCapacity: $adblueCapacity
      baselineDistance: $baselineDistance
      solutionType: $solutionType
      solution_type: $solution_type
      zonalManager: $zonalManager
      keyAccountManager: $keyAccountManager
      channelPartnerName: $channelPartnerName
      isDualEngine: $isDualEngine
      eoff_voltage: $eoff_voltage
      eon_voltage: $eon_voltage
      hasArm: $hasArm
      isElockConnection: $isElockConnection
      duplicateVehicle: $duplicateVehicle
      portedVehicle: $portedVehicle
      isTestingVehicle: $isTestingVehicle

      kvaRating: $kvaRating
      dgSetType: $dgSetType
      bhp: $bhp
      phase: $phase
      engineModel: $engineModel
      gensetController: $gensetController
      videoTelematicsType: $videoTelematicsType
      inputParameter: $inputParameter
      multiplicationFactor: $multiplicationFactor
      videoTelematicsId: $videoTelematicsId

      rcsSerialNumber: $rcsSerialNumber

      technicianName: $technicianName
      updatedBy: $updatedBy

      noOfGears: $noOfGears

      vehicleCustomizedBodyType: $vehicleCustomizedBodyType

      isIndividualViewOrCombinedView: $isIndividualViewOrCombinedView

      baselineHours: $baselineHours

      noOfWheels: $noOfWheels

      custType: $custType

      custCode: $custCode

      clientName: $clientName

      vehicleClass: $vehicleClass

      fuelCode: $fuelCode

      numberOfAxles: $numberOfAxles

      permitCode: $permitCode

      insurerName: $insurerName

      insuranceUpto: $insuranceUpto

      permitType: $permitType

      permitValidUpto: $permitValidUpto

      permitValidFrom: $permitValidFrom

      permitNumber: $permitNumber

      permitIssueDate: $permitIssueDate

      puccUpto: $puccUpto

      registeredAt: $registeredAt

      unladenWeight: $unladenWeight

      manufacturingMonthYear: $manufacturingMonthYear

      taxUpto: $taxUpto

      nationalPermitUpto: $nationalPermitUpto

      fitmentUpto: $fitmentUpto

      emissionNormsDescription: $emissionNormsDescription

      bodyTypeDescription: $bodyTypeDescription

      makerModel: $makerModel

      makerDescription: $makerDescription

      vehicleClassDescription: $vehicleClassDescription

      vehicleCategoryDescription: $vehicleCategoryDescription

      vehicleRegistrationNumber: $vehicleRegistrationNumber

      registrationDate: $registrationDate

      registrationValidUpto: $registrationValidUpto

      stateCode: $stateCode

      rtoCode: $rtoCode

      vehicleCategoryCode: $vehicleCategoryCode

      gearRatio: $gearRatio

      tensionerConductorLength: $tensionerConductorLength
      tensionerRotationSensorDirection: $tensionerRotationSensorDirection
      isRotationSensor: $isRotationSensor
      istachoenabled: $istachoenabled
      tachoidlerpm: $tachoidlerpm
      tachoengineonmin: $tachoengineonmin
      tachoengineonmax: $tachoengineonmax
      tachoshifthours: $tachoshifthours
      timezone_offset: $timezone_offset
      plant_code: $plant_code
      owner_type: $owner_type
      equipment_type: $equipment_type
      equipment_no: $equipment_no
    )
  }
`

const GET_VEHICLE_TYPE = gql`
  query getAllVehicleType {
    getAllVehicleType {
      vehicleTypeId
      vehicleType
    }
  }
`
const GET_VEHICLE_DETAIL = gql`
  query getVehicleDetail($entityId: Int) {
    getVehicleDetail(entityId: $entityId) {
      vehicleNumber
      speedSensorType
      speedLimit
      vehicleType
      vehicleModel
      vehicleMake
      vehicleCapacity
      engineNumber
      chassisNumber
      status
      equipmentSerialNumber
      commissioningDate
      invoiceNumber
      invoiceDate
      idlingSpeed
      department
      contractorName
      equipmentName
      certificatePath
      client {
        id
        clientName
        contactPerson
        address
        city
        email
        contactNumber
        loginId
      }
      device {
        serial_num
        imei_num
        uniqueDeviceId
        deviceModelId {
          model_name
          devicetype
        }
      }
      sim {
        id
        phoneNumber
        simNumber
        serviceProvider {
          name
        }
      }
      engineTorque
      engineLoad
      fuelType
      torquePower
      engineSpecification
      emissionRateType
      engineOnHours
      odometerDistance
      grossVehicleWeight
      manufacturingYear
      vehicleSegment
      equipmentTypeClass
      vehicleWheeler
      application
      documentUpload
      documentUploadNew
      baselineDataForFE
      fuelTankCapacity
      adblueCapacity

      vehicleModelId
      vehicleMakeId

      baselineDistance
      immobilize
      solutionType
      solution_type
      zonalManager
      keyAccountManager
      channelPartnerName
      isDualEngine
      eoff_voltage
      eon_voltage
      isDuplicated
      portedVehicle
      isTestingVehicle
      hasArm
      isElockConnection

      kvaRating
      dgSetType
      bhp
      phase
      engineModel
      gensetController
      videoTelematicsType
      videoTelematicsId
      rcsSerialNumber
      inputParameter
      multiplicationFactor
      createdAt
      updatedAt
      activatedAt
      constructionVehicleType
      passengerVehicleType
      transportationVehicleType
      vehicleNickName
      haulageType
      baselineDataForFELPH
      baselineDataType
      noOfGears
      gearRatio
      vehicleRegistrationNumber
      registrationDate
      registrationValidUpto
      stateCode
      rtoCode
      vehicleCategoryCode
      vehicleCategoryDescription
      vehicleClassDescription
      makerDescription
      makerModel
      bodyTypeDescription
      emissionNormsDescription
      fitmentUpto
      nationalPermitUpto
      taxUpto
      insurerName
      insuranceUpto
      manufacturingMonthYear
      unladenWeight
      registeredAt
      puccUpto
      permitNumber
      permitIssueDate
      permitValidFrom
      permitValidUpto
      permitType
      permitCode
      numberOfAxles
      fuelCode
      vehicleClass
      clientName
      custCode
      custType
      noOfWheels
      baselineHours
      isIndividualViewOrCombinedView
      vehicleCustomizedBodyType
      kvaRating
      dgSetType
      bhp
      phase
      engineModel
      gensetController
      videoTelematicsType
      videoTelematicsId
      engineOnHours
      odometerDistance
      tensionerConductorLength
      tensionerRotationSensorDirection
      isRotationSensor
      istachoenabled
      tachoidlerpm
      tachoshifthours
      tachoengineonmin
      tachoengineonmax
      timezone_offset
      timeZone
      plant_code
      owner_type
      equipment_type
      equipment_no
    }
  }
`
// portedVehicle
// isTestingVehicle
const GENERATE_CERTIFICATE = gql`
  query generatePDF($entityId: Int!) {
    generatePDF(entityId: $entityId) {
      bucketName
      filename
      filePublicDownloadURL
    }
  }
`
const SEND_MAIL = gql`
  query sendVehicleCertificate($email: String, $pdfLink: String) {
    sendVehicleCertificate(email: $email, pdfLink: $pdfLink)
  }
`

const GET_FILE_FORMAT = gql`
  query getPublicDownloadURL($bucketname: String!, $filename: String!) {
    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)
  }
`

// const DOWNLOAD_FILE = gql`
//   query getMinioFileURL($bucketName: String!, $fileName: String!) {
//     getMinioFileURL(bucketName: $bucketName, fileName: $fileName) {
//       url
//     }
//   }
// `
// const UPDATE_VEHICLE_STATUS = gql`
//   mutation addDeviceService(
//     $uniqueDeviceId: String!
//     $isActivated: Boolean!
//   ) {
//     addDeviceService(
//       uniqueDeviceId: $uniqueDeviceId
//       isActivated: $isActivated
//     )
//   }
// `

const GET_VEHICLE_MAKES = gql`
  query {
    getVehicleMakes {
      make
      id
    }
  }
`

const GET_DG_SPECS = gql`
  query GetDgSpecsDetails {
    getDgSpecsDetails {
      id
      kvaRating
      phase
    }
  }
`

const GET_ALL_DG_MAKES = gql`
  query GetDgMakes {
    getDgMakes
  }
`
const GET_DG_MODELS = gql`
  query GetDgModels($make: String!) {
    getDgModels(make: $make)
  }
`

const GET_DG_SPECS_FROM_MODEL = gql`
  query GetDgSpecsFromModel($make: String!, $model: String!) {
    getDgspecsFromModel(make: $make, model: $model) {
      id
      make
      model
      kvaRating
      dgSetType
    }
  }
`

const GET_VEHICLE_MODELS = gql`
  query GetVehicleModels($makeId: String!) {
    getVehicleModels(makeId: $makeId) {
      id
      model
    }
  }
`

const GET_VEHICLE_PARAMS = gql`
  query GetVehicleParameters($modelId: String!) {
    getVehicleParameters(modelId: $modelId) {
      id
      emission_type
      status
      model_id
      fuel_capacity
      adblue_capacity
      manufacturing_year
      fuel_type
      gross_vehicle_weight
      engine_specification
    }
  }
`

const GET_MAKE_AND_MODELS_MASTER = gql`
  query {
    getMakeAndModelMasterData {
      vehicleMake
      vehicleModel
      emissionRateType
    }
  }
`
const GET_SUBSCRIPTION_BY_PARTNERID = gql`
  query getAllPartnerSubscriptions(
    $partnerId: Int
    $deviceModelId: Int
    $status: [Int]
  ) {
    getAllPartnerSubscriptions(
      partnerLoginId: $partnerId
      deviceModelId: $deviceModelId
      status: $status
    ) {
      id
      deviceTrackingCharges
      totalSoftwareQty
    }
  }
`

const GET_CLIENT_DETAILS_BYID = gql`
  query clientDetail($clientId: Int!) {
    clientDetail(loginId: $clientId) {
      clientName
      address
      city
    }
  }
`
const GET_ZMKAM = gql`
  query getAdminUserDetailsByRole($roleName: [String]) {
    getAdminUserDetailsByRole(roleName: $roleName) {
      id
      username
      role
    }
  }
`

const GET_VEHICLE_VAHAAN_DETAILS = gql`
  query GetVehicleVahaanDetails($vehicleNumber: String!) {
    getVehicleVahaanDetails(vehicleNumber: $vehicleNumber) {
      id
      rcRegnNo
      rcRegnDt
      rcRegnUpto
      rcPurchaseDt
      rcOwnerSr
      rcOwnerName
      stateCd
      rtoCd
      rcPresentAddress
      rcPermanentAddress
      rcVchCatg
      rcVhClassDesc
      rcChasiNo
      rcEngNo
      rcMakerDesc
      rcMakerModel
      rcBodyTypeDesc
      rcFuelDesc
      rcColor
      rcNormsDesc
      rcFitUpto
      rcNpUpto
      rcNpIssuedBy
      rcTaxUpto
      rcFinancer
      rcInsuranceComp
      rcInsurancePolicyNo
      rcInsuranceUpto
      rcManuMonthYr
      rcUnldWt
      rcGvw
      rcNoCyl
      rcCubicCap
      rcSeatCap
      rcSleeperCap
      rcStandCap
      rcWheelbase
      rcRegisteredAt
      rcStatusAsOn
      rcPuccUpto
      rcPuccNo
      rcStatus
      rcNcrbStatus
      rcBlacklistStatus
      rcPermitNo
      rcPermitIssueDt
      rcPermitValidFrom
      rcPermitValidUpto
      rcPermitType
      rcPermitCode
      rcNocDetails
      rcVhType
      rcVhClass
      rcNocDt
      rcFuelCd
      rcMakerCd
      rcModelCd
      rcNormsCd
      rcSaleAmt
      rcOwnCatgDesc
      rcVchCatgDesc
      rcOwnerCdDesc
      rcCurrentaddDistrictcode
      rcNonUse
      rcPassengerTax
      rcGoodsTax
      rcNoOfAxle
      rcApprovalDate
      rcHp
      rcMandalDesc
      rcTalukCd
    }
  }
`

const GET_ALL_ASSIGNED_ROLES = gql`
  query GetAllAssignedRoles {
    getAllAssignedRoles {
      id
      uuid
      username
      email
      mobile_number
      role
      client_ids
      createdAt
      updatedAt
    }
  }
`

const GET_DROPDOWN_DETAILS = gql`
  query Query {
    getDropDownDetail
  }
`
const GET_SOLUTION_TYPES = gql`
  query GetAllMasterSolutionType {
    getAllMasterSolutionType {
      id
      solutionTypeName
    }
  }
`
const GET_CUSTOMER_TYPE_AND_CODE = gql`
  query GetCustomerTypeAndCode($clientName: String!) {
    getCustomerTypeAndCode(clientName: $clientName) {
      id
      clientName
      registrationType
      directCustomerSAPCode
      channelPartnerSAPCode
    }
  }
`

const GET_DASHCAM_REGISTRATIONS = gql`
  query GetDashcamRegistrations {
    getDashcamRegistrations {
      success
      message
      data {
        uuid
        simid
        memorycardid
        uniqueid
        vtid
        status
        createdat
        updatedat
      }
    }
  }
`

const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    flexGrow: 1
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: '200px'
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  iconSmall: {
    fontSize: 20
  }
})

const allEmissionRateType = [
  { label: 'BS3', value: 'BS3' },
  { label: 'BS4', value: 'BS4' },
  { label: 'BS6', value: 'BS6' }
]

class VehicleRegistration extends Component {
  _isMounted = false
  constructor(props) {
    super(props)
    this.entityId = this.props.match.params.entityId

    // Dynamically generate manufacturing year options
    const currentYear = new Date().getFullYear()
    const manufacturingYearOptions = []

    for (let i = 0; i <= 30; i++) {
      manufacturingYearOptions.push({
        value: currentYear - i,
        label: `${currentYear - i}`
      })
    }

  // allow admin to edit fields that are otherwise disabled
  this.isAdmin = () => {
    try {
      return (
        typeof localStorage !== 'undefined' &&
        localStorage.getItem('role') === 'admin'
      )
    } catch (e) {
      return false
    }
  }

    this.state = {
      /* eslint-disable */
      duplicateVehicle: false,
      isDuplicatedDBValue: false,
      timezone_offset: null,
      selectedTimezone: null,
      timezoneList: [],
      isSpeedLimitValid: true,
      isSeatLimitValid: false,
      speedLimit: '',
      serialNumber: '',
      rcsSerialNumber: '',
      partnerLoginId: getLoginId(),
      // partnerLoginId: 8,
      isSerialNumberValid: true,
      modelName: '',
      deviceType: '',
      status: 1,
      phoneNumber: '',
      isPhoneNoValid: true,
      simProvider: '',
      simNumber: '',
      vlpn: '',
      isVlpnValid: true,
      vlpnres: '',
      vehicleModel: '',
      vehicleModelId: '',
      vehicleMake: '',
      vehicleMakeId: '',
      vehicleModelId: '',
      isVehicleModelValid: true,
      isVehicleMakeValid: true,
      clientName: '',
      isClientNameValid: true,
      vehicleType: '',
      isVehicleTypeValid: true,
      speedSensor: '',
      isSpeedSensorValid: true,
      accessories: null,
      clientsDetails: [],
      deviceDetails: [],
      simDetails: [],
      accessoryDetails: [],
      response: false,
      failure: false,
      schoolBusEnable: false,
      clientLoginId: '',
      installStatus: false,
      immobilize: false,
      open: false,
      open2: false,
      simId: '',
      engineNumber: '',
      chassisNumber: '',
      seatLimit: '',
      swapOpen: false,
      deleteOpen: false,
      fileResponse: '',
      fileName: '',
      uploadError: '',
      subscriptionDetails: [],
      idlingSpeed: 3,
      invoiceNumber: '',
      equipmentSerialNumber: '',
      equipmentName: '',
      commissioningDate: {
        date: null,
        unix: moment()
          .unix()
          .toString()
      },
      invoiceDate: {
        date: null,
        unix: moment()
          .unix()
          .toString()
      },
      department: '',
      contractorName: '',
      plant_code: '',
      owner_type: 'Self',
      equipment_type: '',
      equipment_no: '',
      PDFLink: '',
      open3: false,
      mail: '',
      ismailValid: true,
      vehicleTypes: [],

      engineTorque: '',
      isEngineTorqueValid: true,
      engineLoad: '',
      isEngineLoadValid: true,
      fuelType: '',
      solutionType: '',
      solution_type: [],
      isDualEngine: false,
      eoff_voltage: null,
      eon_voltage: null,
      isEonVoltageValid: true,
      isEoffVoltageValid: true,
      hasArm: false,
      isElockConnection: false,
      isFuelTypeValid: true,
      torquePower: '',
      istTorquePowerValid: true,

      engineOnHours: '',
      odometerDistance: '',
      isengineOnHoursValid: true,
      isOdometerDistanceValid: true,
      isEngineSpecificationValid: true,
      emissionRateType: '',

      engineSpecificationFromApi: false,
      emissionRateTypeFromApi: false,
      grossVehicleWeightFromApi: false,
      fuelTankCapacityFromApi: false,
      adblueCapacityFromApi: false,
      manufacturingYearFromApi: false,
      fuelTypeFromApi: false,

      makesList: [],
      kvaRatingOptions: [],
      phaseOptions: phaseOptionsArray,
      modelsList: [],
      emissionList: [],
      makeModelsMainList: [],

      grossVehicleWeight: '',
      manufacturingYear: '',
      vehicleSegment: '',
      selectedVTM: '',
      videoTelematicsId: '',
      equipmentTypeClass: '',
      vehicleWheeler: '',
      application: '',
      documentUpload: null,
      baselineDataForFE: '',
      baselineDistance: '',
      baselineHours: null,
      fuelTankCapacity: '',
      adblueCapacity: '',
      isAdblueCapacityValid: true,
      errorMessage: null,
      errorMessageNew: null,
      errorMessageFuelTank: null,
      vtValidationError: null,
      fileNames: '',
      documentUploadNewData: {}, // Map fileName to { solutionType, label }
      uploadProgress: {}, // Initialize uploadProgress state

      equipmentTypeClassOptions: [],
      vehicleWheelerOptions: [],
      applicationOptions: [],
      equipmentTypeClassText: '', // For EVs free text input
      isBaselineDataForFEValid: true, // Assume valid by default

      isBaselineDistanceValid: true,
      isBaselineHoursValid: true,
      isDepartmentValid: true,
      isContractorNameValid: true,
      iseoff_voltageValid: true,
      iseon_voltageValid: true,
      isEquipmentNameValid: true,
      isEquipmentValid: true,
      isInvoiceNoValid: true,

      manufacturingYearOptions,
      segmentOptions: [
        { value: 'Transportation', label: 'Transportation' },
        { value: 'Construction', label: 'Construction' },
        { value: 'EVs', label: 'EVs' },
        { value: 'Passenger Vehicles', label: 'Passenger Vehicles' },
        { value: 'LMs', label: 'LMs' },
        { value: 'DG Set', label: 'DG Set' }
      ],
      videoTelematicsType: [
        { label: 'LocoNav', value: 'loconav' },
        { label: 'MettaX', value: 'mettax' }
      ],
      dashcamRegistrations: [],
      dashcamRegistrationsLoading: false,
      // Technician dropdowns and updatedBy
      assignedTechniciansTaabi: [],
      assignedTechniciansFreelancer: [],
      technicianCategory: null,
      selectedTaabiTechnician: null,
      selectedFreelancerTechnician: null,
      technicianName: '',
      updatedBy:
        typeof localStorage !== 'undefined'
          ? localStorage.getItem('username') || ''
          : '',
      vtidOptions: [],
      selectedVtid: null,
      selectedSimId: '',
      selectedMemoryCardId: '',
      originalVtid: null,

      // states for handling file upload response
      fileName: '',
      bucketName: '',
      publicUploadURL: '',
      downloadUrl: '',
      isUploading: false, // To track upload status
      vehicleDetails: {},
      throughChannelPartner: false,
      zmDetails: [],
      kamDetails: [],
      zmId: '',
      kamId: '',
      channelPartnerName: '',
      portedVehicle: null,
      isTestingVehicle: null,
      inputParameter: null,
      multiplicationFactor: null,
      kvaRating: '',
      dgSetType: '',
      bhp: '',
      phase: '',
      engineModel: '',
      gensetController: '',

      custCode: '',
      custType: '',
      vehicleData: '',
      rcRegnNo: '',
      rcRegnDt: '',
      rcRegnUpto: '',
      rcPurchaseDt: '',
      rcOwnerSr: '',
      rcOwnerName: '',
      stateCd: '',
      rtoCd: '',
      rcPresentAddress: '',
      rcPermanentAddress: '',
      rcVchCatg: '',
      rcVhClassDesc: '',
      rcChasiNo: '',
      rcEngNo: '',
      rcMakerDesc: '',
      rcMakerModel: '',
      rcBodyTypeDesc: '',
      rcFuelDesc: '',
      rcColor: '',
      rcNormsDesc: '',
      rcFitUpto: '',
      rcNpUpto: '',
      rcNpIssuedBy: '',
      rcTaxUpto: '',
      rcFinancer: '',
      rcInsuranceComp: '',
      rcInsurancePolicyNo: '',
      rcInsuranceUpto: '',
      rcManuMonthYr: '',
      rcUnldWt: null,
      rcGvw: '',
      rcNoCyl: '',
      rcCubicCap: '',
      rcSeatCap: '',
      rcSleeperCap: '',
      rcStandCap: '',
      rcWheelbase: '',
      rcRegisteredAt: '',
      rcStatusAsOn: '',
      rcPuccUpto: '',
      rcPuccNo: '',
      rcStatus: '',
      rcNcrbStatus: '',
      rcBlacklistStatus: '',
      rcPermitNo: '',
      rcPermitIssueDt: '',
      rcPermitValidFrom: '',
      rcPermitValidUpto: '',
      rcPermitType: '',
      rcPermitCode: '',
      rcNocDetails: '',
      rcVhType: '',
      rcVhClass: '',
      rcNocDt: '',
      rcFuelCd: '',
      rcMakerCd: '',
      rcModelCd: '',
      rcNormsCd: '',
      rcSaleAmt: '',
      rcOwnCatgDesc: '',
      rcVchCatgDesc: '',
      rcOwnerCdDesc: '',
      rcCurrentaddDistrictcode: '',
      rcNonUse: '',
      rcPassengerTax: '',
      rcGoodsTax: '',
      rcNoOfAxle: null,
      rcApprovalDate: '',
      rcHp: '',
      rcMandalDesc: '',
      rcTalukCd: '',
      noOfWheels: null,
      noOfGears: null,

      vehicleData: '',
      vehicleRegistrationNumber: '',

      registrationDate: '',
      registrationValidUpto: '',
      stateCode: '',
      rtoCode: '',
      vehicleCategoryCode: '',
      vehicleCategoryDescription: '',
      vehicleClassDescription: '',
      makerDescription: '',
      makerModel: '',
      bodyTypeDescription: '',
      emissionNormsDescription: '',
      fitmentUpto: '',
      nationalPermitUpto: '',
      taxUpto: '',
      insurerName: '',
      insuranceUpto: '',
      manufacturingMonthYear: '',
      unladenWeight: '',
      registeredAt: '',
      puccUpto: '',
      permitNumber: '',
      permitIssueDate: '',
      permitValidFrom: '',
      permitValidUpto: '',
      permitType: '',
      permitCode: '',
      numberOfAxles: '',
      fuelCode: '',
      vehicleClass: '',
      isIndividualViewOrCombinedView: false,
      tensionerConductorLength: null,
      tensionerRotationSensorDirection: '',
      isRotationSensor: false,
      istachoenabled: false,
      tachoidlerpm: '',
      tachoshifthours: '',
      tachoengineonmin: '',
      tachoengineonmax: ''
    }

    if (this.props.location.state) {
      this.setState({ clientName: this.props.location.state.clientId })
    } else {
      this.setState({ clientName: '' })
    }
  }

  clearDate = () => {
    this.setState({
      commissioningDate: {
        date: null,
        unix: moment()
          .unix()
          .toString()
      }
    })
  }
  handleChangeIdlingSpeed = event => {
    if (event) {
      this.setState({ idlingSpeed: event.value })
    } else {
      this.setState({ idlingSpeed: 3 })
    }
  }
  handleToggleChange = event => {
    this.setState({ throughChannelPartner: event.target.checked })
  }
  handleDateChange = name => date => {
    let tempDate = this.state[name]
    tempDate.date = date
    tempDate.unix = moment(date)
      .unix()
      .toString()
    this.setState({ [name]: tempDate })
  }
  getVehicleType = async () => {
    const { data } = await this.props.client.query({
      query: GET_VEHICLE_TYPE
      // fetchPolicy: 'network-only'
    })
    const vehicleTypes = data.getAllVehicleType.map(item => item.vehicleType)
    this.setState({ vehicleTypes })
  }
  getTimezones = async () => {
    try {
      const { data } = await this.props.client.query({
        query: GET_ALL_TIMEZONES
      })
      if (data && data.getAllTimezones) {
        this.setState({ timezoneList: data.getAllTimezones }, () => {
          if (this.state.timezone_offset) {
            const selectedTimezone = data.getAllTimezones.find(
              item => item.value === this.state.timezone_offset
            )
            if (selectedTimezone) {
              this.setState({ selectedTimezone })
            }
          }
        })
      }
    } catch (error) {
      console.error('Error fetching timezones:', error)
    }
  }
  getVehicleDetails = async () => {
    const { data } = await this.props.client.query({
      query: GET_VEHICLE_DETAIL,
      variables: {
        entityId: parseInt(this.entityId, 10)
      }
      // fetchPolicy: 'network-only'
    })
    this.setDetails(data.getVehicleDetail)
    this.fetchCustomerTypeAndCode()
  }
  getFormattedDate = timestamp => {
    return moment(timestamp * 1000).format('MMM Do YYYY, h:mm a')
  }

  getZMKAMDetails = async () => {
    const zmkamDetails = await this.props.client.query({
      query: GET_ZMKAM,
      variables: {
        roleName: ['Zonal Manager(ZM)', 'Key Account Manager(KAM)']
      }
      // fetchPolicy: 'network-only'
    })
    const zmDetails = zmkamDetails.data.getAdminUserDetailsByRole
      .filter(user => user.role === 'Zonal Manager(ZM)')
      .map(user => ({
        value: user.id,
        label: user.username
      }))
    const kamDetails = zmkamDetails.data.getAdminUserDetailsByRole
      .filter(user => user.role === 'Key Account Manager(KAM)')
      .map(user => ({
        value: user.id,
        label: user.username
      }))
    this.setState({ zmDetails: zmDetails, kamDetails: kamDetails })
  }

  getAllAssignedRoles = async () => {
    try {
      const { data } = await this.props.client.query({
        query: GET_ALL_ASSIGNED_ROLES,
        fetchPolicy: 'network-only'
      })
      if (data && data.getAllAssignedRoles) {
        const taabiList = data.getAllAssignedRoles
          .filter(u => u.role === 'Technician - Taabi Personal')
          .map(u => ({
            label: u.username || u.email || u.uuid,
            value: u.username || u.uuid
          }))

        const freelancerList = data.getAllAssignedRoles
          .filter(u => u.role === 'Technician - Freelancer')
          .map(u => ({
            label: u.mobile_number || u.username || u.uuid,
            value: u.mobile_number || u.uuid
          }))

        this.setState(
          {
            assignedTechniciansTaabi: taabiList,
            assignedTechniciansFreelancer: freelancerList
          },
          () => {
            // If a technicianName was passed via navigation state, initialize selection now
            const propTech =
              this.props.location &&
              this.props.location.state &&
              this.props.location.state.technicianName
            if (propTech) {
              this.initializeTechnicianFromValue(propTech)
            }
          }
        )
      }
    } catch (error) {
      console.error('Error fetching assigned roles', error)
    }
  }

  initializeTechnicianFromValue = value => {
    if (!value) return
    const isNumeric = /^\d+$/.test(String(value))
    const category = isNumeric
      ? 'Technician - Freelancer'
      : 'Technician - Taabi Personal'
    // set basic fields
    this.setState({ technicianCategory: category, technicianName: value })

    // attempt to set the selected option from the already-fetched lists
    if (category === 'Technician - Taabi Personal') {
      const opt = this.state.assignedTechniciansTaabi.find(
        o => String(o.value) === String(value)
      )
      if (opt) this.setState({ selectedTaabiTechnician: opt })
    } else {
      const opt = this.state.assignedTechniciansFreelancer.find(
        o => String(o.value) === String(value)
      )
      if (opt) this.setState({ selectedFreelancerTechnician: opt })
    }
  }

  handleTechnicianCategoryChange = option => {
    const category = option && option.value ? option.value : null
    this.setState({
      technicianCategory: category,
      selectedTaabiTechnician: null,
      selectedFreelancerTechnician: null,
      technicianName: ''
    })
  }

  handleTaabiSelectChange = option => {
    this.setState({
      selectedTaabiTechnician: option,
      technicianName: option ? option.value : ''
    })
  }

  handleFreelancerSelectChange = option => {
    this.setState({
      selectedFreelancerTechnician: option,
      technicianName: option ? option.value : ''
    })
  }

  getDashcamRegistrations = async () => {
    this.setState({ dashcamRegistrationsLoading: true }) // Set specific loading state

    try {
      const { data } = await this.props.client.query({
        query: GET_DASHCAM_REGISTRATIONS,
        fetchPolicy: 'network-only'
      })

      if (data.getDashcamRegistrations.success) {
        // Keep the full set of registrations (including non-available) so we can
        // still show the originalVtid in edit mode even if its status isn't
        // 'available'. The SelectReact options will later filter to show only
        // available ones or the originalVtid.
        const registrations = data.getDashcamRegistrations.data

        const vtidOptions = registrations.map(item => ({
          value: item.vtid,
          label: item.vtid,
          simid: item.simid,
          memorycardid: item.memorycardid,
          status: item.status
        }))

        this.setState({
          dashcamRegistrations: registrations,
          vtidOptions,
          dashcamRegistrationsLoading: false
        })
      } else {
        this.setState({ dashcamRegistrationsLoading: false })
      }
    } catch (error) {
      console.error('Error fetching dashcam registrations:', error)
      this.setState({ dashcamRegistrationsLoading: false })
    }
  }

  handleVtidChange = selectedOption => {
    if (selectedOption && selectedOption.value) {
      this.setState({
        selectedVtid: selectedOption,
        selectedSimId: selectedOption.simid,
        selectedMemoryCardId: selectedOption.memorycardid,
        videoTelematicsId: selectedOption.value
      })
    } else {
      this.setState({
        selectedVtid: null,
        selectedSimId: null,
        selectedMemoryCardId: null,
        videoTelematicsId: null
      })
    }
  }

  handleChangeInputParameter = event => {
    const value = event.target.value
    this.setState({ inputParameter: value ? parseFloat(value) : null })
  }

  handleChangeMultiplicationFactor = event => {
    const value = event.target.value
    this.setState({ multiplicationFactor: value ? parseFloat(value) : null })
  }

  handleChangeAccessories = event => {
    if (!event) {
      this.setState({ accessories: '' })
    } else {
      this.setState({ accessories: event.value })
    }
  }
  handleChangeSubscription = event => {
    if (!event) {
      this.setState({ subscriptionId: '' })
    } else {
      this.setState({ subscriptionId: event.value })
    }
  }

  setDetails = vehicleDetail => {
    if (!vehicleDetail) return
    let commissioningDate = {
      date: null,
      unix: moment().unix()
    }
    if (vehicleDetail.commissioningDate) {
      commissioningDate = {
        date: moment.unix(vehicleDetail.commissioningDate).format('YYYY-MM-DD'),
        unix: vehicleDetail.commissioningDate
      }
    }

    let invoiceDate = {
      date: null,
      unix: moment().unix()
    }
    if (vehicleDetail.invoiceDate) {
      invoiceDate = {
        date: moment.unix(vehicleDetail.invoiceDate).format('YYYY-MM-DD'),
        unix: vehicleDetail.invoiceDate
      }
    }
    if (this.state.makeModelsMainList) {
      let filtertedModels = this.state.makeModelsMainList.filter(item => {
        if (item.vehicleMake == vehicleDetail.vehicleMake)
          return item.vehicleModel
      })
      const allModels = filtertedModels.map(item => ({
        value: item.vehicleModel,
        label: item.vehicleModel
      }))
      this.setState({ modelsList: allModels })
    }

    let fuelType = vehicleDetail.fuelType ? vehicleDetail.fuelType : ''
    // Normalize so it matches the fuel-type option values (petrol, diesel, ev,
    // cng, lng) regardless of the casing or combo value the API returns.
    fuelType = fuelType ? normalizeFuelType(fuelType.toLowerCase()) : ''

    let isArmVal = false
    if (vehicleDetail.hasArm) {
      isArmVal = vehicleDetail.hasArm ? vehicleDetail.hasArm : false
    }
    let isElock = false
    if (vehicleDetail.isElockConnection) {
      isElock = vehicleDetail.isElockConnection
        ? vehicleDetail.isElockConnection
        : false
    }

    let kvaRatingVal = ''
    let dgSetTypeVal = ''
    let bhpVal = ''
    let phaseVal = ''
    let engineModelVal = ''
    let gensetControllerVal = ''

    if (vehicleDetail.kvaRating) {
      kvaRatingVal = vehicleDetail.kvaRating
    }
    if (vehicleDetail.dgSetType) {
      dgSetTypeVal = vehicleDetail.dgSetType
    }

    if (vehicleDetail.bhp) {
      bhpVal = vehicleDetail.bhp
    }

    if (vehicleDetail.phase) {
      phaseVal = vehicleDetail.phase
    }

    if (vehicleDetail.engineModel) {
      engineModelVal = vehicleDetail.engineModel
    }

    if (vehicleDetail.gensetController) {
      gensetControllerVal = vehicleDetail.gensetController
    }

    // console.log(this.state.portedVehicle, 'ported Vehicle1')
    this.setState({
      vehicleDetails: vehicleDetail,
      address: vehicleDetail.client.address,
      city: vehicleDetail.client.city,
      clientName: vehicleDetail.client.clientName,
      contactPerson: vehicleDetail.client.contactPerson,
      email: vehicleDetail.client.email,
      id: vehicleDetail.client.id,
      contactNumber: vehicleDetail.client.contactNumber,
      existingVehicleNumber: vehicleDetail.vehicleNumber,
      vlpn: vehicleDetail.vehicleNumber,
      speedSensor: vehicleDetail.speedSensorType,
      speedLimit: vehicleDetail.speedLimit,
      vehicleType: vehicleDetail.vehicleType,
      vehicleModel: vehicleDetail.vehicleModel,
      vehicleMake: vehicleDetail.vehicleMake,
      // vehicleMakeId: vehicleDetail.vehicleMakeId,
      vehicleMakeId:
        vehicleDetail.vehicleSegment == 'DG Set'
          ? vehicleDetail.vehicleMake
          : vehicleDetail.vehicleMakeId,
      // vehicleModelId: vehicleDetail.vehicleModelId,
      vehicleModelId:
        vehicleDetail.vehicleSegment == 'DG Set'
          ? vehicleDetail.vehicleModel
          : vehicleDetail.vehicleModelId,
      vehicleCapacity: vehicleDetail.vehicleCapacity,
      status: vehicleDetail.status,
      serialNumber: vehicleDetail.device.serial_num,
      modelName: vehicleDetail.device.deviceModelId.model_name,
      deviceType: vehicleDetail.device.deviceModelId.devicetype,
      phoneNumber: vehicleDetail.sim.phoneNumber,
      simProvider: vehicleDetail.sim.serviceProvider.name,
      simNumber: vehicleDetail.sim.simNumber,
      uniqueDeviceId: vehicleDetail.device.uniqueDeviceId,
      clientLoginId: vehicleDetail.client.loginId,
      engineNumber: vehicleDetail.engineNumber,
      chassisNumber: vehicleDetail.chassisNumber,
      simId: vehicleDetail.sim.id,

      equipmentSerialNumber: vehicleDetail.equipmentSerialNumber
        ? vehicleDetail.equipmentSerialNumber
        : null,
      commissioningDate: commissioningDate,
      invoiceDate: invoiceDate,
      invoiceNumber: vehicleDetail.invoiceNumber
        ? vehicleDetail.invoiceNumber
        : null,
      idlingSpeed: vehicleDetail.idlingSpeed,
      department: vehicleDetail.department ? vehicleDetail.department : '',
      equipmentName: vehicleDetail.equipmentName
        ? vehicleDetail.equipmentName
        : null,
      contractorName: vehicleDetail.contractorName
        ? vehicleDetail.contractorName
        : '',
      engineTorque: vehicleDetail.engineTorque
        ? vehicleDetail.engineTorque
        : '',
      engineLoad: vehicleDetail.engineLoad ? vehicleDetail.engineLoad : '',
      fuelType: fuelType,
      // Seed rcFuelDesc with the saved fuel type so the dropdown reflects the
      // persisted value (e.g. CNG) instead of falling back to the RC/VAHAN
      // descriptor, which would otherwise mask a manually edited fuel type.
      rcFuelDesc: fuelType,
      solutionType: vehicleDetail.solutionType
        ? vehicleDetail.solutionType
        : '',
      solution_type: vehicleDetail.solution_type ? vehicleDetail.solution_type : [],
      isDualEngine: vehicleDetail.isDualEngine
        ? vehicleDetail.isDualEngine
        : false,
      // FIXED: was missing from this populate-on-load block, so the toggle always fell back to
      // the constructor's default (false) after a refresh even when the saved value was true.
      isIndividualViewOrCombinedView: vehicleDetail.isIndividualViewOrCombinedView
        ? vehicleDetail.isIndividualViewOrCombinedView
        : false,

      eon_voltage: vehicleDetail.eon_voltage ? vehicleDetail.eon_voltage : null,
      eoff_voltage: vehicleDetail.eoff_voltage
        ? vehicleDetail.eoff_voltage
        : null,

      hasArm: isArmVal,
      isElockConnection: isElock,
      portedVehicle: vehicleDetail.portedVehicle,
      isTestingVehicle: vehicleDetail.isTestingVehicle,
      isDuplicatedDBValue: vehicleDetail.isDuplicated
        ? vehicleDetail.isDuplicated
        : false,
      duplicateVehicle: vehicleDetail.isDuplicated
        ? vehicleDetail.isDuplicated
        : false,
      torquePower: vehicleDetail.torquePower ? vehicleDetail.torquePower : '',
      engineOnHours: vehicleDetail.engineOnHours
        ? vehicleDetail.engineOnHours
        : '',
      odometerDistance: vehicleDetail.odometerDistance
        ? vehicleDetail.odometerDistance
        : '',
      engineSpecification: vehicleDetail.engineSpecification
        ? vehicleDetail.engineSpecification
        : '',
      emissionRateType: vehicleDetail.emissionRateType
        ? vehicleDetail.emissionRateType
        : '',

      grossVehicleWeight: vehicleDetail.grossVehicleWeight
        ? vehicleDetail.grossVehicleWeight
        : '',
      manufacturingYear: vehicleDetail.manufacturingYear
        ? vehicleDetail.manufacturingYear
        : '',
      vehicleSegment: vehicleDetail.vehicleSegment
        ? vehicleDetail.vehicleSegment
        : '',
      equipmentTypeClass: vehicleDetail.equipmentTypeClass
        ? vehicleDetail.equipmentTypeClass
        : '',
      vehicleWheeler: vehicleDetail.vehicleWheeler
        ? vehicleDetail.vehicleWheeler
        : '',
      selectedApplication: vehicleDetail.application
        ? vehicleDetail.application
        : '',
      haulageType: vehicleDetail.haulageType ? vehicleDetail.haulageType : '',
      constructionVehicleType: vehicleDetail.constructionVehicleType
        ? vehicleDetail.constructionVehicleType
        : '',
      tensionerConductorLength: vehicleDetail.tensionerConductorLength,
      tensionerRotationSensorDirection:
        vehicleDetail.tensionerRotationSensorDirection || '',
      isRotationSensor: vehicleDetail.isRotationSensor
        ? vehicleDetail.isRotationSensor
        : false,
      timezone_offset: vehicleDetail.timezone_offset || null,
      selectedTimezone:
        (this.state.timezoneList &&
          this.state.timezoneList.find(
            item => item.value === vehicleDetail.timezone_offset
          )) ||
        (vehicleDetail.timezone_offset
          ? {
              label: vehicleDetail.timeZone
                ? `${vehicleDetail.timeZone} (${vehicleDetail.timezone_offset})`
                : vehicleDetail.timezone_offset,
              value: vehicleDetail.timezone_offset,
              timezone: vehicleDetail.timeZone
            }
          : null),
      passengerVehicleType: vehicleDetail.passengerVehicleType
        ? vehicleDetail.passengerVehicleType
        : '',
      transportationVehicleType: vehicleDetail.transportationVehicleType
        ? vehicleDetail.transportationVehicleType
        : '',
      vehicleNickName: vehicleDetail.vehicleNickName
        ? vehicleDetail.vehicleNickName
        : '',
      baselineDataForFE: vehicleDetail.baselineDataForFE
        ? vehicleDetail.baselineDataForFE
        : '',

      baselineDistance: vehicleDetail.baselineDistance
        ? vehicleDetail.baselineDistance
        : '',

      baselineHours: vehicleDetail.baselineHours
        ? vehicleDetail.baselineHours
        : '',

      fuelTankCapacity: vehicleDetail.fuelTankCapacity
        ? vehicleDetail.fuelTankCapacity
        : '',
      adblueCapacity: vehicleDetail.adblueCapacity
        ? vehicleDetail.adblueCapacity
        : '',

      equipmentTypeClassText: vehicleDetail.equipmentTypeClassText
        ? vehicleDetail.equipmentTypeClassText
        : '',
      vehicleWheeler: vehicleDetail.vehicleWheeler
        ? vehicleDetail.vehicleWheeler
        : '',
      // application: vehicleDetail.application ? vehicleDetail.application : '',
      vehicleType: vehicleDetail.vehicleType ? vehicleDetail.vehicleType : '',
      subscriptionId: vehicleDetail.subscriptionId
        ? vehicleDetail.subscriptionId
        : '',
      immobilize: vehicleDetail.immobilize ? vehicleDetail.immobilize : false,
      zmId: vehicleDetail.zonalManager,
      kamId: vehicleDetail.keyAccountManager,
      channelPartnerName: vehicleDetail.channelPartnerName,
      throughChannelPartner: vehicleDetail.channelPartnerName ? true : false,

      kvaRating: kvaRatingVal,
      dgSetType: dgSetTypeVal,
      bhp: bhpVal,
      phase: phaseVal,
      engineModel: engineModelVal,
      gensetController: gensetControllerVal,
      selectedVTM: vehicleDetail.videoTelematicsType
        ? vehicleDetail.videoTelematicsType
        : null,
      videoTelematicsId: vehicleDetail.videoTelematicsId
        ? vehicleDetail.videoTelematicsId
        : null,
      selectedVtid: vehicleDetail.videoTelematicsId
        ? vehicleDetail.videoTelematicsId
        : null,
      originalVtid:
        vehicleDetail.videoTelematicsType &&
        vehicleDetail.videoTelematicsType === 'mettax' &&
        vehicleDetail.videoTelematicsId
          ? vehicleDetail.videoTelematicsId
          : null,
      inputParameter: vehicleDetail.inputParameter
        ? vehicleDetail.inputParameter
        : null,
      multiplicationFactor: vehicleDetail.multiplicationFactor
        ? vehicleDetail.multiplicationFactor
        : null,

      vehicleRegistrationNumber: vehicleDetail.vehicleRegistrationNumber
        ? vehicleDetail.vehicleRegistrationNumber
        : '',
      rcsSerialNumber: vehicleDetail.rcsSerialNumber ? vehicleDetail.rcsSerialNumber : '',
      registrationDate: vehicleDetail.registrationDate
        ? vehicleDetail.registrationDate
        : '',
      registrationValidUpto: vehicleDetail.registrationValidUpto
        ? vehicleDetail.registrationValidUpto
        : '',
      stateCode: vehicleDetail.stateCode ? vehicleDetail.stateCode : '',
      rtoCode: vehicleDetail.rtoCode ? vehicleDetail.rtoCode : '',
      vehicleCategoryCode: vehicleDetail.vehicleCategoryCode
        ? vehicleDetail.vehicleCategoryCode
        : '',
      vehicleClassDescription: vehicleDetail.vehicleClassDescription
        ? vehicleDetail.vehicleClassDescription
        : '',
      makerDescription: vehicleDetail.makerDescription
        ? vehicleDetail.makerDescription
        : '',
      makerModel: vehicleDetail.makerModel ? vehicleDetail.makerModel : '',
      bodyTypeDescription: vehicleDetail.bodyTypeDescription
        ? vehicleDetail.bodyTypeDescription
        : '',
      // fuelType: vehicleDetail.fuelType
      //     ? vehicleDetail.fuelType
      //     : '',
      emissionNormsDescription: vehicleDetail.emissionNormsDescription
        ? vehicleDetail.emissionNormsDescription
        : '',
      fitmentUpto: vehicleDetail.fitmentUpto ? vehicleDetail.fitmentUpto : '',
      nationalPermitUpto: vehicleDetail.nationalPermitUpto
        ? vehicleDetail.nationalPermitUpto
        : '',
      taxUpto: vehicleDetail.taxUpto ? vehicleDetail.taxUpto : '',
      insurerName: vehicleDetail.insurerName ? vehicleDetail.insurerName : '',
      insuranceUpto: vehicleDetail.insuranceUpto
        ? vehicleDetail.insuranceUpto
        : '',
      manufacturingMonthYear: vehicleDetail.manufacturingMonthYear
        ? vehicleDetail.manufacturingMonthYear
        : '',
      unladenWeight: vehicleDetail.unladenWeight
        ? vehicleDetail.unladenWeight
        : '',
      registeredAt: vehicleDetail.registeredAt
        ? vehicleDetail.registeredAt
        : '',
      puccUpto: vehicleDetail.puccUpto ? vehicleDetail.puccUpto : '',
      permitNumber: vehicleDetail.permitNumber
        ? vehicleDetail.permitNumber
        : '',
      permitIssueDate: vehicleDetail.permitIssueDate
        ? vehicleDetail.permitIssueDate
        : '',
      permitValidFrom: vehicleDetail.permitValidFrom
        ? vehicleDetail.permitValidFrom
        : '',
      permitValidUpto: vehicleDetail.permitValidUpto
        ? vehicleDetail.permitValidUpto
        : '',
      permitType: vehicleDetail.permitType ? vehicleDetail.permitType : '',
      permitCode: vehicleDetail.permitCode ? vehicleDetail.permitCode : '',
      numberOfAxles: vehicleDetail.numberOfAxles
        ? vehicleDetail.numberOfAxles
        : null,
      fuelCode: vehicleDetail.fuelCode ? vehicleDetail.fuelCode : '',
      vehicleClass: vehicleDetail.vehicleClass
        ? vehicleDetail.vehicleClass
        : '',
      noOfWheels: vehicleDetail.noOfWheels ? vehicleDetail.noOfWheels : null,
      vehicleCustomizedBodyType: vehicleDetail.vehicleCustomizedBodyType
        ? vehicleDetail.vehicleCustomizedBodyType
        : null,
      baselineDataType: vehicleDetail.baselineDataType
        ? vehicleDetail.baselineDataType.toLowerCase()
        : null,
      noOfGears: vehicleDetail.noOfGears ? vehicleDetail.noOfGears : null,
      gearRatio: vehicleDetail.gearRatio ? vehicleDetail.gearRatio : null,
      istachoenabled: vehicleDetail.istachoenabled || false,
      tachoidlerpm: vehicleDetail.tachoidlerpm || '',
      tachoshifthours: vehicleDetail.tachoshifthours || '',
      tachoengineonmin: vehicleDetail.tachoengineonmin || '',
      tachoengineonmax: vehicleDetail.tachoengineonmax || '',
      plant_code: vehicleDetail.plant_code ? vehicleDetail.plant_code : '',
      owner_type: vehicleDetail.owner_type ? vehicleDetail.owner_type : 'Self',
      equipment_type: vehicleDetail.equipment_type ? vehicleDetail.equipment_type : '',
      equipment_no: vehicleDetail.equipment_no ? vehicleDetail.equipment_no : ''
    })
    // If technicianName was passed via navigation state, initialize category/selection
    const propTech =
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.technicianName
    if (propTech) {
      // initialize but don't depend on assigned lists being available yet
      const isNumeric = /^\d+$/.test(String(propTech))
      const category = isNumeric
        ? 'Technician - Freelancer'
        : 'Technician - Taabi Personal'
      this.setState({ technicianCategory: category, technicianName: propTech })
    }
    try {
      // Every stored image (documentUploadNew as received + legacy-only names) is loaded,
      // so an update sends them back unchanged unless the user removes one.
      const storedEntries = buildInitialEntries(vehicleDetail.documentUploadNew, vehicleDetail.documentUpload)
      if (storedEntries.length) {
        this.setState({
          documentUpload: vehicleDetail.documentUpload,
          ...entriesToState(storedEntries)
        })
      }
    } catch (error) {}

    try {
      if (this.state.vehicleMakeId) {
        let eventObj = {
          label: this.state.vehicleMake ? this.state.vehicleMake : null,
          value: this.state.vehicleMakeId ? this.state.vehicleMakeId : null
        }
        this.handleChangeMake(eventObj)
      }
    } catch (error) {}

    try {
      if (this.state.vehicleModelId) {
        let eventObj = {
          label: this.state.vehicleModel ? this.state.vehicleModel : null,
          value: this.state.vehicleModelId ? this.state.vehicleModelId : null
        }
        this.fetchModelDetails(eventObj)
      }
      if (this.state.vehicleMakeId && this.state.vehicleModelId) {
        this.getDgspecsFromModel(
          this.state.vehicleMakeId,
          this.state.vehicleModelId
        )
      }
    } catch (error) {}

    if (this.state.uniqueDeviceId) {
      this.fetchAllPartnerSubscriptions()
    }

    if (this.state.vehicleSegment) {
      this.updateDependentFieldsBasedOnSegment(this.state.vehicleSegment)

      if (this.state.vehicleSegment == 'DG Set') {
        this.updateDGSetData()
      }
    }

    if (vehicleDetail.certificatePath) {
      let x = vehicleDetail.certificatePath.split('/')
      let len = x.length
      this.setState({ fileName: x[len - 1] })
    }

    if (vehicleDetail.status !== 2) {
      this.setState({ installStatus: true })
    }
    if (this.state.vehicleCapacity !== null) {
      this.setState({
        isSeatLimitValid: true,
        seatLimit: this.state.vehicleCapacity
      })
    } else {
      this.setState({
        // isSeatLimitValid: false,
        seatLimit: null
      })
    }
  }

  checkBaselineDistanceValidity = () => {
    const { baselineDistance } = this.state
    // Consider an empty string as valid to reset validation state when input is cleared
    const isValid =
      baselineDistance === '' ||
      (/^\d+$/.test(baselineDistance) && // Check if the input is a positive integer
        parseInt(baselineDistance) > 0 &&
        parseInt(baselineDistance) <= 2000000)

    this.setState({ isBaselineDistanceValid: isValid })
  }

  checkBaselineHoursValidity = () => {
    const { baselineHours } = this.state
    // Consider an empty string as valid to reset validation state when input is cleared
    const isValid =
      baselineHours === '' ||
      (/\d+/.test(baselineHours) && // Check if the input contains at least one digit
      /^\d+$/.test(baselineHours) && // Check if the input is a positive integer
        parseInt(baselineHours) > 0 &&
        parseInt(baselineHours) <= 24)

    this.setState({ isBaselineHoursValid: isValid })
  }

  checkeoff_voltageValidity = () => {
    const regex = new RegExp(/^\d+(\.\d{1,2})?$/) // Allows any number of digits with optional decimal
    this.setState({
      iseoff_voltageValid:
        regex.test(this.state.eoff_voltage) || this.state.eoff_voltage === ''
    })
  }

  checkeon_voltageValidity = () => {
    const regex = new RegExp(/^\d+(\.\d{1,2})?$/) // Same pattern for eon voltage
    this.setState({
      iseon_voltageValid:
        regex.test(this.state.eon_voltage) || this.state.eon_voltage === ''
    })
  }

  checkBaselineDataForFEValidity = () => {
    const { baselineDataForFE } = this.state
    // Consider an empty string as valid to reset validation state when input is cleared
    const isValid =
      baselineDataForFE === '' ||
      (!isNaN(parseFloat(baselineDataForFE)) &&
        parseFloat(baselineDataForFE) >= 0.5 &&
        parseFloat(baselineDataForFE) <= 20 &&
        /^(\d+(\.\d{0,2})?|\.?\d{1,2})$/.test(baselineDataForFE))

    this.setState({ isBaselineDataForFEValid: isValid })
  }

  // Method to update dependent fields based on segment selection
  updateDependentFieldsBasedOnSegment = selectedSegment => {
    // Reset options first
    this.setState({
      equipmentTypeClassOptions: [],
      vehicleWheelerOptions: [],
      applicationOptions: []
    })

    if (selectedSegment === 'Transportation') {
      this.setState({
        equipmentTypeClassOptions: ['M&HCV', 'LM', 'PC', '2W', '3W', 'LCV'].map(
          value => ({ value, label: value })
        ),
        vehicleWheelerOptions: [
          '6W',
          '10W',
          '12W',
          '14W',
          '16W',
          '18W',
          '22W',
          '22W+'
        ].map(value => ({ value, label: value })),
        applicationOptions: [
          'E-Com',
          'Cement',
          'General Goods',
          'Dumper',
          'Trailers (Flat Bed)',
          'Buses',
          'Automobile Carrier',
          'Tipper'
        ].map(value => ({ value, label: value }))
      })
    } else if (selectedSegment === 'Construction') {
      this.setState({
        equipmentTypeClassOptions: [
          'Excavator',
          'Crane',
          'Gantry',
          'Grader'
        ].map(value => ({ value, label: value }))
      })
    } else if (selectedSegment === 'EVs') {
      // Handle EVs segment with a free text input
      this.setState({
        equipmentTypeClassText: '' // Reset or handle as needed
      })
    }
    // Add additional conditions for other segments if necessary
  }

  handleSegmentChange = option => {
    try {
      if (option.value) {
        this.setState({ vehicleSegment: option.value }, () => {
          this.updateDependentFieldsBasedOnSegment(option.value)
        })
      } else {
        this.setState({ vehicleSegment: '' }, () => {
          this.updateDependentFieldsBasedOnSegment('')
        })
      }
    } catch (error) {
      this.setState({ vehicleSegment: '' }, () => {
        this.updateDependentFieldsBasedOnSegment('')
      })
    }

    setTimeout(() => {
      if (this.state.vehicleSegment == 'DG Set') {
        this.updateDGSetData()
      }
    }, 500)

    if (this.state.vehicleSegment == 'DG Set') {
      this.setState({
        vehicleRegistrationNumberAvailableStatus: false,
        enteredVehicleRegistrationNumber: ''
      })
      this.flushVahaanValues()
    }
  }

  updateDGSetData() {
    this.getAllDGMakes()
    this.setState({ vehicleType: 'DG Set' }, () => {
      this.checkVehicleTypeValidity()
    })

    if (!this.state.portedVehicle) {
      this.setState({ portedVehicle: true })
    }
    if (!this.state.isTestingVehicle) {
      this.setState({ isTestingVehicle: true })
    }
    if (!this.state.speedSensor) {
      this.setState({ speedSensor: 'GPS SPEED SENSOR' })
    }
    if (!this.state.idlingSpeed) {
      this.setState({ idlingSpeed: 3 })
    }
    if (!this.state.speedLimit) {
      this.setState({ speedLimit: 40 })
    }
    if (!this.state.solutionType) {
      this.setState({ solutionType: 'fuel_solution' })
    }
    if (!this.state.solution_type) {
      this.setState({ solution_type: ['fuel'] })
    }
  }

  handleEquipmentTypeClassTextChange = event => {
    this.setState({ equipmentTypeClassText: event.target.value })
  }
  // handleVideoTelematicsMenuChange = selectedOption => {
  //   if (selectedOption && selectedOption.value) {
  //     this.setState({ selectedVTM: selectedOption.value });
  //   } else {
  //     this.setState({ selectedVTM: null });
  //   }
  // }

  handleVideoTelematicsMenuChange = selectedOption => {
    if (selectedOption && selectedOption.value) {
      this.setState({
        selectedVTM: selectedOption.value,
        selectedVtid: null,
        selectedSimId: null,
        selectedMemoryCardId: null,
        videoTelematicsId: ''
      })
    } else {
      this.setState({
        selectedVTM: null,
        selectedVtid: null,
        selectedSimId: null,
        selectedMemoryCardId: null,
        videoTelematicsId: ''
      })
    }
  }

  handleVideoTelematicsIdChange = event => {
    this.setState({ videoTelematicsId: event.target.value })
  }

  handleInputChangeNew = inputName => event => {
    try {
      const value = event.value
      this.setState({ [inputName]: value }, () => {
        if (inputName === 'vehicleSegment') {
          this.updateDependentFieldsBasedOnSegment()
        }
      })
    } catch (error) {
      const value = ''
      this.setState({ [inputName]: value }, () => {
        if (inputName === 'vehicleSegment') {
          this.updateDependentFieldsBasedOnSegment()
        }
      })
    }
  }

  fetchAllPartnerSubscriptions = async () => {
    const {
      data: subscription,
      error: subscriptionError
    } = await this.props.client.query({
      query: GET_SUBSCRIPTION_BY_PARTNERID,
      variables: {
        partnerId: getLoginId(),
        deviceModelId: this.state.deviceModelId,
        status: [2, 4, 5]
      },
      errorPolicy: 'all'
      // fetchPolicy: 'network-only'
    })
    const allSubscriptions = subscription.getAllPartnerSubscriptions.map(
      // (lab = subscription.mmtc + ',' + subscription.noOfDevices),
      subscription => ({
        value: subscription.id,
        label: `${subscription.totalSoftwareQty} - ${
          subscription.deviceTrackingCharges
        }`
      })
    )
    if (subscriptionError) {
      this.setState({ subscriptionDetails: [] })
    } else {
      this.setState(
        {
          subscriptionDetails: allSubscriptions
        },
        () => console.log('subscriptionDetails', this.state.subscriptionDetails)
      )
    }
  }
  handleChangeDevice = client => async event => {
    if (event) {
      this.setState({ serialNumber: event.value })
      const response = await client
        .query({
          query: GET_SELECT_DEV_DETAILS,
          variables: { uniqueId: event.value }
          // fetchPolicy: 'network-only'
        })
        .catch(error => {})

      if (response && response.data) {
        const { data } = response
        this.setState(
          {
            modelName: data.devicePartnerAssignDetail.deviceModel.model_name,
            deviceType: data.devicePartnerAssignDetail.deviceModel.devicetype,
            uniqueId: this.state.serialNumber,
            deviceModelId: data.devicePartnerAssignDetail.deviceModel.id
          },
          () => {
            this.fetchAllPartnerSubscriptions()
          }
        )
      }
    } else {
      this.setState({
        modelName: '',
        deviceType: '',
        uniqueId: '',
        serialNumber: '',
        subscriptionDetails: [],
        subscriptionId: ''
      })
    }

    // await this.onCountryFetched(data.allStatesByCountryId)
  }

  handleRemove(fileName) {
    try {
      const { uploadProgress, fileNames } = this.state

      // Remove the file from uploadProgress
      delete uploadProgress[fileName]

      // Remove the fileName from the fileNames array
      const updatedFileNames = fileNames
        .split(',')
        .filter(name => name !== fileName)
        .join(',')

      // Update the state with the modified uploadProgress and fileNames
      this.setState({ uploadProgress, fileNames: updatedFileNames })
    } catch (error) {}
  }

  handleDocumentUploadNewDataChange = (fileName, field, value) => {
    this.setState(prevState => ({
      documentUploadNewData: {
        ...prevState.documentUploadNewData,
        [fileName]: {
          ...prevState.documentUploadNewData[fileName],
          [field]: value
        }
      }
    }))
  }

  handleFileChange = async event => {
    const files = event.target.files // Access all uploaded files
    const maxSize = 30 * 1024 * 1024 // 30MB in bytes
    const maxFiles = 50 // Maximum number of files allowed
    let fileNames = this.state.fileNames || '' // Initialize fileNames to an empty string if undefined
    fileNames = fileNames ? fileNames.split(',') : []
    let uploadProgress = { ...this.state.uploadProgress } // Copy existing upload progress
    const uploadPromises = [] // Array to store upload promises
    let totalSize = 0 // Variable to track total size of files

    this.setState({ errorMessage: null, isUploading: true })

    if (files.length <= 50) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i]

        const fileExtension = file.name.substring(
          file.name.lastIndexOf('.') + 1
        ).toLowerCase()

        const allowedTypes = ['jpeg', 'jpg', 'png', 'pdf']
        if (!allowedTypes.includes(fileExtension)) {
          this.setState({
            errorMessage: `File ${i + 1} type is not supported. Please upload JPEG, JPG, PNG, or PDF files.`,
            isUploading: false
          })
          continue
        }

        if (file.size > maxSize) {
          this.setState({
            errorMessage: `File ${i + 1} size exceeds the limit of 30MB.`
          })
        } else {
          totalSize += file.size

          try {
            const response = await this.props.client.mutate({
              mutation: GET_UPLOAD_URL,
              variables: {
                fileExtension
              }
            })

            if (response.data && response.data.getPublicUploadURL) {
              const {
                publicUploadURL,
                filename
              } = response.data.getPublicUploadURL

              uploadProgress[filename] = 0 // Initialize progress for this filename

              const uploadPromise = axios.put(publicUploadURL, file, {
                headers: {
                  'x-ms-blob-type': 'BlockBlob',
                  'Content-Type': file.type || 'application/octet-stream'
                },
                onUploadProgress: progressEvent => {
                  const progress =
                    (progressEvent.loaded / progressEvent.total) * 100
                  // Update progress for the filename obtained from the response
                  this.setState(prevState => ({
                    uploadProgress: {
                      ...prevState.uploadProgress,
                      [filename]: progress
                    }
                  }))
                }
              })

              uploadPromises.push(uploadPromise)
              fileNames.push(filename) // Store filename in fileNames state
            }
          } catch (error) {
            console.error('Upload error:', error)
          }
        }
      }

      // Update fileNames state after processing all files
      const updatedFileNames = fileNames.slice(0, maxFiles).join(',')
      this.setState({ fileNames: updatedFileNames })

      // Wait for all upload promises to resolve
      try {
        await Promise.all(uploadPromises)
        this.setState({
          isUploading: false
        })
      } catch (error) {
        console.error('Upload error:', error)
        // Handle upload error
      }
    } else {
      this.setState({
        errorMessage: `Maximum 50 files can be selected`,
        isUploading: false
      })
    }
  }

  handleDownload = async fileName => {
    const bucketName = 'aquila-track-uploads'

    const { data } = await this.props.client.query({
      query: GET_FILE_FORMAT,
      variables: {
        bucketname: bucketName,
        filename: fileName
      },
      errorPolicy: 'all'
    })

    const res = await axios({
      url: data.getPublicDownloadURL,
      method: 'GET',
      headers: { Accept: 'application/vnd.ms-excel' },
      responseType: 'blob' // important
    })

    FileSaver.saveAs(new Blob([res.data]), fileName)
  }

  // Compute legacy solutionType string from the multi-select solution_type array codes - ported
  // verbatim from Vehicle Registration (VehicleRegistartion/index.jsx computeLegacySolutionType)
  // so editing a vehicle's solution_type keeps solutionType in sync the same way registration does,
  // instead of the two fields drifting apart.
  computeLegacySolutionType(solutionCodes) {
    const codeToMaster = {
      fuel: 'fuel_solution',
      obd: 'obd_solution',
      vt: 'video_telematics',
      obdanalogsolution: 'obd_analog_solution',
      basic_tracking: 'basic_tracking',
      ais_140: 'ais_140',
      asset_tracking: 'Asset Tracking',
      control_tower: 'control_tower',
      testing_vehicle: 'testing_vehicle',
      'fuel+vt': 'fuel+vt',
      'obd+vt': 'obd+vt',
      'fuel+obd+vt': 'fuel+obd+vt',
      reverse_camera_screen: 'reverse_camera_screen'
    }

    if (!solutionCodes || solutionCodes.length === 0) {
      return ''
    }

    if (solutionCodes.length === 1) {
      const code = solutionCodes[0]
      return codeToMaster[code] || code
    }

    const hasFuel = solutionCodes.includes('fuel_solution')
    const hasObd = solutionCodes.includes('obd_solution')
    const hasVt = solutionCodes.includes('video_telematics')

    if (hasFuel && hasObd && hasVt) {
      return 'fuel+obd+vt'
    }
    if (hasFuel && hasVt) {
      return 'fuel+vt'
    }
    if (hasObd && hasVt) {
      return 'obd+vt'
    }
    if (hasFuel && hasObd) {
      return 'obd_fuel+fuel_solution'
    }
    if (hasVt) {
      if (hasFuel) return 'fuel+vt'
      if (hasObd) return 'obd+vt'
    }

    const firstCode = solutionCodes[0]
    return codeToMaster[firstCode] || firstCode
  }

  handleInputChange = key => e => {
    if (key === 'fuelType') {
      if (!e) {
        this.setState({ [key]: '' })
        return
      }
      this.setState({ [key]: e.value })
    } else if (key === 'owner_type') {
      if (!e) {
        this.setState({ [key]: 'Self' })
        return
      }
      this.setState({ [key]: e.value !== undefined ? e.value : (e.target ? e.target.value : e) })
    } else if (key === 'portedVehicle') {
      if (!e) {
        this.setState({ [key]: '' })
        return
      }
      this.setState({ [key]: e.value })
    } else if (key === 'isTestingVehicle') {
      if (!e) {
        this.setState({ [key]: '' })
        return
      }
      this.setState({ [key]: e.value })
    } else if (key === 'solutionType') {
      if (!e) {
        this.setState({ [key]: '' })
        return
      }
      this.setState({ [key]: e.value })
    } else if (key === 'solution_type') {
  if (!e) {
    this.setState({ [key]: [], solutionType: '' })
    return
  }

  // ✅ FIXED: use value instead of code
  const selectedValues = e.map(option => option.value)

  // Keep solutionType (legacy string) in sync with solution_type (array) the same way Vehicle
  // Registration does, instead of leaving the legacy field stale/inconsistent.
  const legacySolutionType = this.computeLegacySolutionType(selectedValues)

  this.setState({
    [key]: selectedValues,
    solutionType: legacySolutionType
  })
}else if (key == 'adblueCapacity' || key == 'fuelTankCapacity') {
      var value = parseFloat(e.target.value)
      if (isNaN(value)) {
        this.setState({ [key]: e.target.value })
        if (key == 'adblueCapacity') {
          this.setState({ errorMessageNew: null })
        } else {
          this.setState({ errorMessageFuelTank: null })
        }
        return false
      }
      if (!Number.isInteger(value)) {
        if (key == 'adblueCapacity') {
          this.setState({ errorMessageNew: 'Decimal values are not allowed.' })
        } else {
          this.setState({
            errorMessageFuelTank: 'Decimal values are not allowed.'
          })
        }
      } else {
        if (key == 'adblueCapacity') {
          this.setState({ errorMessageNew: null })
        } else {
          this.setState({ errorMessageFuelTank: null })
        }
      }

      this.setState({ [key]: e.target.value })
    } else if (
      key == 'department' ||
      key == 'contractorName' ||
      key == 'equipmentName' ||
      key == 'invoiceNumber' ||
      key == 'equipmentSerialNumber' ||
      key == 'isDualEngine' ||
      key == 'hasArm' ||
      key == 'isElockConnection' ||
      key == 'isIndividualViewOrCombinedView' ||
      key == 'duplicateVehicle' ||
      key == 'istachoenabled'
    ) {
      // Check if the input length exceeds 90 characters only if the field is not empty

      if (key == 'department') {
        if (e.target.value.length > 90 && e.target.value.trim() !== '') {
          this.setState({ [key]: e.target.value, isDepartmentValid: false })
        } else {
          this.setState({ [key]: e.target.value, isDepartmentValid: true })
        }
      }

      if (key == 'contractorName') {
        if (e.target.value.length > 90 && e.target.value.trim() !== '') {
          this.setState({ [key]: e.target.value, isContractorNameValid: false })
        } else {
          this.setState({ [key]: e.target.value, isContractorNameValid: true })
        }
      }

      if (key == 'equipmentName') {
        if (e.target.value.length > 90 && e.target.value.trim() !== '') {
          this.setState({ [key]: e.target.value, isEquipmentNameValid: false })
        } else {
          this.setState({ [key]: e.target.value, isEquipmentNameValid: true })
        }
      }

      if (key == 'equipmentSerialNumber') {
        if (e.target.value.length > 90 && e.target.value.trim() !== '') {
          this.setState({ [key]: e.target.value, isEquipmentValid: false })
        } else {
          this.setState({ [key]: e.target.value, isEquipmentValid: true })
        }
      }

      if (key == 'invoiceNumber') {
        if (e.target.value.length > 90 && e.target.value.trim() !== '') {
          this.setState({ [key]: e.target.value, isInvoiceNoValid: false })
        } else {
          this.setState({ [key]: e.target.value, isInvoiceNoValid: true })
        }
      }

      if (key == 'isDualEngine') {
        const isChecked = e.target.checked
        this.setState({ isDualEngine: isChecked }, () => {})
      }

      if (key == 'isElockConnection') {
        const isChecked = e.target.checked
        this.setState({ isElockConnection: isChecked }, () => {})
      }

      if (key == 'hasArm') {
        const isChecked = e.target.checked
        this.setState({ hasArm: isChecked }, () => {})
      }

      if (key == 'duplicateVehicle') {
        const isChecked = e.target.checked
        this.setState({ duplicateVehicle: isChecked }, () => {})
      }

      if (key == 'isIndividualViewOrCombinedView') {
        const isChecked = e.target.checked
        this.setState({ isIndividualViewOrCombinedView: isChecked }, () => {})
      }
      if (key == 'istachoenabled') {
        const isChecked = e.target.checked
        this.setState({ istachoenabled: isChecked }, () => {})
      }
    } else if (key === 'phase' || key === 'kvaRating' || key === 'dgSetType') {
      if (!e) {
        this.setState({ [key]: '' })
        return
      }
      this.setState({ [key]: e.value })
    } else {
      this.setState({ [key]: e.target.value })
    }
  }

  handleChangeType = event => {
    const selectedVehicleType = event ? event.value : null
    this.setState({ vehicleType: selectedVehicleType }, () => {
      this.checkVehicleTypeValidity()
    })
  }

  handleChangeSpeedSensor = event => {
    if (event) {
      this.setState({ speedSensor: event.value })
    } else {
      this.setState({ speedSensor: '' })
    }
  }

  handleTimezoneChange = selectedOption => {
    this.setState({
      selectedTimezone: selectedOption,
      timezone_offset: selectedOption ? selectedOption.value : null
    })
  }
  handleMailChange = event => {
    this.setState({ mail: event.target.value })
  }
  checkMail = () => {
    const regex = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)
    this.setState({
      ismailValid: regex.test(this.state.mail) && this.state.mail !== ''
    })
  }
  checkVehicleModelValidity = () => {
    const regex = /^[a-zA-Z][a-zA-Z0-9 -]*$/
    this.setState({
      isVehicleModelValid:
        regex.test(this.state.vehicleModel) &&
        this.state.vehicleModel !== '' &&
        this.state.vehicleModel.length > 1 &&
        this.state.vehicleModel.length < 21
    })
  }

  checkVehicleMakeValidity = () => {
    const regex = /^[a-zA-Z][a-zA-Z0-9 -]*$/
    if (this.state.vehicleMake !== '')
      this.setState({
        isVehicleMakeValid:
          regex.test(this.state.vehicleMake) &&
          this.state.vehicleMake !== '' &&
          this.state.vehicleMake.length > 1 &&
          this.state.vehicleMake.length < 70
      })
  }

  checkSpeedLimitValidity = () => {
    const regex = new RegExp(/^[1-9][0-9]{0,2}$/)
    this.setState({
      isSpeedLimitValid:
        regex.test(this.state.speedLimit) &&
        this.state.speedLimit !== '' &&
        this.state.speedLimit <= 160 &&
        this.state.speedLimit >= 10
    })
  }
  checkSeatLimitValidity = () => {
    const regex = new RegExp(/^[1-9][0-9]$/)
    this.setState({
      isSeatLimitValid:
        regex.test(this.state.seatLimit) && this.state.seatLimit !== ''
    })
  }
  checkVlpnValidity = client => async event => {
    if (this.state.vlpn === this.state.existingVehicleNumber) return
    await client.query({
      query: GET_VLPN,
      variables: { vlpn: this.state.vlpn }
    })

    this.setState({
      isVlpnValid:
        this.state.vlpn !== '' &&
        this.state.vlpn.length > 4 &&
        this.state.vlpn.length < 33
    })

    if (this.state.vlpn !== '') {
      if (this.state.vlpn.length < 5 || this.state.vlpn.length > 32) {
        this.setState({ vlpnres: 'Max character length is between 5 to 32' })
      } else {
        this.setState({ vlpnres: 'Invalid Vehicle Number' })
      }
    }
  }

  checkVehicleTypeValidity = () => {
    const isSchoolBus = this.state.vehicleType === 'School Bus'
    this.setState({
      isVehicleTypeValid: this.state.vehicleType !== '',
      isSeatLimitValid: isSchoolBus // Update isSeatLimitValid based on selected vehicle type
    })
  }

  checkItemValidity = key => e => {
    if (e.target.value !== '') {
      const regex = /^[a-zA-Z0-9 .-@,]*$/
      switch (key) {
        case 'engineTorque':
          this.setState({
            isEngineTorqueValid:
              regex.test(e.target.value) && e.target.value !== ''
          })
          break
        case 'engineLoad':
          this.setState({
            isEngineLoadValid:
              regex.test(e.target.value) && e.target.value !== ''
          })
          break
        case 'fuelType':
          this.setState({
            isFuelTypeValid: e.target.value !== ''
          })
          break
        case 'torquePower':
          this.setState({
            istTorquePowerValid:
              regex.test(e.target.value) && e.target.value !== ''
          })
          break
        case 'engineOnHours':
          this.setState({
            isengineOnHoursValid:
              regex.test(e.target.value) && e.target.value !== ''
          })
          break
        case 'odometerDistance':
          this.setState({
            isOdometerDistanceValid:
              regex.test(e.target.value) && e.target.value !== ''
          })
          break
        case 'engineSpecification':
          this.setState({
            isEngineSpecificationValid: e.target.value !== ''
          })
          break
        default:
          break
      }
    }
  }

  checkSpeedSensorValidity = () => {
    this.setState({
      isSpeedSensorValid: this.state.speedSensor !== ''
    })
  }

  checkAdblueCapacityValidity = () => {
    const { deviceType, adblueCapacity } = this.state
    let isValid = true
    if (deviceType && deviceType.toLowerCase() === 'obd') {
      isValid = !!adblueCapacity && adblueCapacity.toString().trim() !== ''
    }
    this.setState({ isAdblueCapacityValid: isValid })
    return isValid
  }

  checkDualEngineVoltageValidity = () => {
    const { isDualEngine, eon_voltage, eoff_voltage } = this.state
    let isEonVoltageValid = true
    let isEoffVoltageValid = true
    if (isDualEngine) {
      isEonVoltageValid =
        eon_voltage !== null && eon_voltage !== '' && !isNaN(eon_voltage)
      isEoffVoltageValid =
        eoff_voltage !== null && eoff_voltage !== '' && !isNaN(eoff_voltage)
    }
    this.setState({ isEonVoltageValid, isEoffVoltageValid })
    return isEonVoltageValid && isEoffVoltageValid
  }

  handleSubmit = client => async event => {
    if (this.state.seatLimit === '') {
      this.setState({ seatLimit: null })
    }
    event.preventDefault()

    // Determine if vehicle initially had ONLY 'vt' solution_type
    const initialSolution =
      this.state.vehicleDetails && this.state.vehicleDetails.solution_type
        ? this.state.vehicleDetails.solution_type
        : []
    const isOnlyVtInitial =
      initialSolution.length === 1 && initialSolution.includes('vt')

    // Check if the user has mutated it away from purely 'vt'
    const hasChangedFromVtOnly =
      isOnlyVtInitial &&
      (!this.state.solution_type ||
        this.state.solution_type.length !== 1 ||
        !this.state.solution_type.includes('vt'))

    if (hasChangedFromVtOnly) {
      this.setState({
        vtValidationError: 'you cant edit more solution_type as you have vt instattled only remove that and submit...'
      })
      return
    }

    // VT validation: if solution_type includes 'vt', videoTelematicsId is required
    if (
      this.state.solution_type &&
      this.state.solution_type.includes('vt') &&
      !this.state.videoTelematicsId
    ) {
      this.setState({
        vtValidationError:
          'Please select a Video Telematics ID before submitting.'
      })
      return
    }
    this.setState({ vtValidationError: null })
    let installationStatus
    if (this.state.installStatus && this.state.status === 2) {
      installationStatus = 1
    } else {
      installationStatus = this.state.status
    }
    if (this.state.engineNumber === '') {
      this.setState({ engineNumber: null })
    }
    if (this.state.chassisNumber === '') {
      this.setState({ chassisNumber: null })
    }
    let commissioningDate =
      this.state.commissioningDate.date === null
        ? null
        : parseInt(this.state.commissioningDate.unix)

    let invoiceDate =
      this.state.invoiceDate.date === null
        ? null
        : parseInt(this.state.invoiceDate.unix)

    let formattedFileNames = ''

    try {
      formattedFileNames = this.state.fileNames
        .split(',')
        .map(fileName => fileName.trim())
        .join(',') // Split file names by comma, trim whitespace, and join back with commas
    } catch (error) {}

    const { data, errors } = await client.mutate({
      mutation: UPDATE_VEHICLE,
      variables: {
        vehicleNumber: this.state.vehicleNickName
          ? this.state.vehicleNickName
          : this.state.vehicleSegment == 'DG Set'
            ? this.state.vlpn
            : this.state.rcRegnNo ||
              (this.state.vehicleData && this.state.vehicleData.rcRegnNo) ||
              this.state.vehicleRegistrationNumber ||
              this.state.vlpn,
        entityId: parseInt(this.entityId, 10),
        clientLoginId: parseInt(this.state.clientLoginId, 10),
        speedSensorType: this.state.speedSensor,
        speedLimit: parseInt(this.state.speedLimit, 10),
        // vehicleType: this.state.vehicleSegment == 'DG Set' ? this.state.vehicleSegment : this.state.rcVhType || (this.state.vehicleData && this.state.vehicleData.rcVhType) || this.state.vehicleType || 'N/A',
        vehicleType: (() => {
          const {
            vehicleSegment,
            transportationVehicleType,
            constructionVehicleType,
            passengerVehicleType,
            vehicleData,
            rcVhType
          } = this.state

          if (vehicleSegment === 'Transportation')
            return transportationVehicleType || 'N/A'
          if (vehicleSegment === 'Construction')
            return constructionVehicleType || 'N/A'
          if (vehicleSegment === 'Passenger')
            return passengerVehicleType || 'N/A'

          let vehicleType = (vehicleData && vehicleData.rcVhType) || rcVhType
          vehicleType = vehicleType === 'T' ? 'Truck' : vehicleType || 'N/A'
          return vehicleSegment || vehicleType
        })(),
        rcsSerialNumber: this.state.rcsSerialNumber,
        vehicleModel:
          this.state.vehicleSegment == 'DG Set' ||
          this.state.deviceType == 'obd' ||
          this.state.deviceType == 'OBD'
            ? this.state.vehicleModel
            : this.state.rcMakerModel ||
              (this.state.vehicleData && this.state.vehicleData.rcMakerModel) ||
              this.state.makerModel,

        vehicleModelId:
          this.state.vehicleSegment == 'DG Set' ||
          this.state.deviceType == 'obd' ||
          this.state.deviceType == 'OBD'
            ? this.state.vehicleModelId
            : null,
        vehicleMakeId:
          this.state.vehicleSegment == 'DG Set' ||
          this.state.deviceType == 'obd' ||
          this.state.deviceType == 'OBD'
            ? this.state.vehicleMakeId
            : null,

        vehicleCapacity: parseInt(this.state.seatLimit, 10),
        isActivated: this.state.installStatus,
        immobilize: this.state.immobilize,
        status: parseInt(installationStatus, 10),
        engineNumber: this.state.engineNumber,
        chassisNumber: this.state.chassisNumber,
        equipmentSerialNumber: this.state.equipmentSerialNumber,
        commissioningDate: commissioningDate,
        invoiceDate: invoiceDate,
        idlingSpeed: this.state.idlingSpeed,
        equipmentName: this.state.equipmentName,
        invoiceNumber: this.state.invoiceNumber,
        department: this.state.department,
        contractorName: this.state.contractorName,
        vehicleMake:
          this.state.vehicleSegment == 'DG Set' ||
          this.state.deviceType == 'obd' ||
          this.state.deviceType == 'OBD'
            ? this.state.vehicleMake
            : this.state.rcMakerDesc ||
              (this.state.vehicleData && this.state.vehicleData.rcMakerDesc) ||
              this.state.makerDescription,
        engineTorque: this.state.engineTorque,
        engineLoad: this.state.engineLoad,
        // fuelType: this.state.fuelType,
        solutionType: this.state.solutionType,
        solution_type: this.state.solution_type,

        duplicateVehicle: this.state.isDuplicatedDBValue
          ? false
          : this.state.duplicateVehicle,
        torquePower: this.state.torquePower,
        engineOnHours: this.state.engineOnHours,
        odometerDistance: this.state.odometerDistance,
        engineSpecification: this.state.engineSpecification,
        emissionRateType: this.state.emissionRateType,

        grossVehicleWeight: parseFloat(this.state.grossVehicleWeight),
        manufacturingYear: parseInt(this.state.manufacturingYear),
        vehicleSegment: this.state.vehicleSegment,
        equipmentTypeClass: this.state.equipmentTypeClass,
        vehicleWheeler: this.state.vehicleWheeler,
        application:
          this.state.vehicleSegment === 'Transportation'
            ? this.state.selectedApplication
            : '',
        haulageType:
          this.state.vehicleSegment === 'Transportation'
            ? this.state.haulageType
            : '',
        transportationVehicleType:
          this.state.vehicleSegment === 'Transportation'
            ? this.state.transportationVehicleType
            : '',
        constructionVehicleType:
          this.state.vehicleSegment === 'Construction'
            ? this.state.constructionVehicleType
            : '',
        passengerVehicleType:
          this.state.vehicleSegment === 'Passenger'
            ? this.state.passengerVehicleType
            : '',
        isDualEngine: this.state.isDualEngine,
        eoff_voltage: parseFloat(this.state.eoff_voltage),
        eon_voltage: parseFloat(this.state.eon_voltage),
        hasArm: this.state.hasArm,
        isElockConnection: this.state.isElockConnection,
        vehicleNickName: this.state.vehicleNickName,
        documentUpload: formattedFileNames,
        documentUploadNew: this.state.fileNames ? this.state.fileNames.split(',').filter(Boolean).map(fileName => ({
          fileName: fileName.trim(),
          ...(this.state.documentUploadNewData[fileName.trim()] || { solutionType: '', label: '' })
        })) : [],
        baselineDataType: this.state.baselineDataType,
        baselineDataForFE: parseFloat(this.state.baselineDataForFE),
        baselineDistance: parseInt(this.state.baselineDistance),
        fuelTankCapacity: this.state.fuelTankCapacity
          ? this.state.fuelTankCapacity.toString()
          : null,
        adblueCapacity: this.state.adblueCapacity
          ? this.state.adblueCapacity.toString()
          : null,
        zonalManager: this.state.zmId ? this.state.zmId : null,
        keyAccountManager: this.state.kamId ? this.state.kamId : null,
        channelPartnerName:
          this.state.throughChannelPartner && this.state.channelPartnerName
            ? this.state.channelPartnerName
            : null,
        portedVehicle: this.state.portedVehicle,
        isTestingVehicle: this.state.isTestingVehicle,

        kvaRating: this.state.kvaRating,
        dgSetType: this.state.dgSetType,
        bhp: this.state.bhp,
        phase: this.state.phase,
        engineModel: this.state.engineModel,
        gensetController: this.state.gensetController,
        videoTelematicsType: this.state.selectedVTM
          ? this.state.selectedVTM
          : null,
        videoTelematicsId:
          this.state.selectedVTM && this.state.videoTelematicsId
            ? this.state.videoTelematicsId
            : null,
        inputParameter: this.state.inputParameter
          ? this.state.inputParameter
          : null,
        multiplicationFactor: this.state.multiplicationFactor
          ? this.state.multiplicationFactor
          : null,

        vehicleRegistrationNumber:
          this.state.rcRegnNo ||
          (this.state.vehicleData && this.state.vehicleData.rcRegnNo) ||
          this.state.vehicleRegistrationNumber ||
          this.state.vlpn,
        registrationDate:
          this.state.rcRegnDt ||
          (this.state.vehicleData && this.state.vehicleData.rcRegnDt) ||
          this.state.registrationDate ||
          '',
        registrationValidUpto:
          this.state.rcRegnUpto ||
          (this.state.vehicleData && this.state.vehicleData.rcRegnUpto) ||
          this.state.registrationValidUpto ||
          '',
        stateCode:
          this.state.stateCd ||
          (this.state.vehicleData && this.state.vehicleData.stateCd) ||
          this.state.stateCode ||
          '',
        rtoCode:
          this.state.rtoCd ||
          (this.state.vehicleData && this.state.vehicleData.rtoCd) ||
          this.state.rtoCode ||
          '',
        vehicleCategoryCode:
          this.state.rcVchCatg ||
          (this.state.vehicleData && this.state.vehicleData.rcVchCatg) ||
          this.state.vehicleCategoryCode ||
          '',
        vehicleClassDescription:
          this.state.rcVhClassDesc ||
          (this.state.vehicleData && this.state.vehicleData.rcVhClassDesc) ||
          this.state.vehicleClassDescription ||
          '',
        chassisNumber:
          this.state.rcChasiNo ||
          (this.state.vehicleData && this.state.vehicleData.rcChasiNo) ||
          this.state.chassisNumber ||
          '',
        engineNumber:
          this.state.rcEngNo ||
          (this.state.vehicleData && this.state.vehicleData.rcEngNo) ||
          this.state.engineNumber ||
          '',
        makerDescription:
          this.state.rcMakerDesc ||
          (this.state.vehicleData && this.state.vehicleData.rcMakerDesc) ||
          this.state.makerDescription,
        makerModel:
          this.state.rcMakerModel ||
          (this.state.vehicleData && this.state.vehicleData.rcMakerModel) ||
          this.state.makerModel,
        bodyTypeDescription:
          this.state.rcBodyTypeDesc ||
          (this.state.vehicleData && this.state.vehicleData.rcBodyTypeDesc) ||
          this.state.bodyTypeDescription ||
          '',
        // fuelType: (this.state.rcFuelDesc || (this.state.vehicleData && this.state.vehicleData.rcFuelDesc) || this.state.fuelType).toLowerCase() || '',
        fuelType:
          this.state.rcFuelDesc ||
          (this.state.vehicleData && this.state.vehicleData.rcFuelDesc) ||
          this.state.fuelType
            ? this.state.rcFuelDesc ||
              (this.state.vehicleData && this.state.vehicleData.rcFuelDesc) ||
              this.state.fuelType
            : '',
        emissionNormsDescription:
          this.state.rcNormsDesc ||
          (this.state.vehicleData && this.state.vehicleData.rcNormsDesc) ||
          this.state.emissionNormsDescription ||
          '',
        fitmentUpto:
          this.state.rcFitUpto ||
          (this.state.vehicleData && this.state.vehicleData.rcFitUpto) ||
          this.state.fitmentUpto ||
          '',
        nationalPermitUpto:
          this.state.rcNpUpto ||
          (this.state.vehicleData && this.state.vehicleData.rcNpUpto) ||
          this.state.nationalPermitUpto ||
          '',
        taxUpto:
          this.state.rcTaxUpto ||
          (this.state.vehicleData && this.state.vehicleData.rcTaxUpto) ||
          this.state.taxUpto ||
          '',
        insurerName:
          this.state.rcInsuranceComp ||
          (this.state.vehicleData && this.state.vehicleData.rcInsuranceComp) ||
          this.state.insurerName ||
          '',
        insuranceUpto:
          this.state.rcInsuranceComp ||
          (this.state.vehicleData && this.state.vehicleData.rcInsuranceComp) ||
          this.state.insuranceUpto ||
          '',
        manufacturingMonthYear:
          this.state.rcManuMonthYr ||
          (this.state.vehicleData && this.state.vehicleData.rcManuMonthYr) ||
          this.state.manufacturingMonthYear ||
          '',
        unladenWeight:
          this.state.rcUnldWt ||
          (this.state.vehicleData && this.state.vehicleData.rcUnldWt) ||
          this.state.unladenWeight ||
          null,
        grossVehicleWeight: parseFloat(
          this.state.rcGvw ||
            (this.state.vehicleData && this.state.vehicleData.rcGvw) ||
            this.state.grossVehicleWeight
        ),
        registeredAt:
          this.state.rcRegisteredAt ||
          (this.state.vehicleData && this.state.vehicleData.rcRegisteredAt) ||
          this.state.registeredAt ||
          '',
        puccUpto:
          this.state.rcPuccUpto ||
          (this.state.vehicleData && this.state.vehicleData.rcPuccUpto) ||
          this.state.puccUpto ||
          '',
        permitNumber:
          this.state.rcPermitNo ||
          (this.state.vehicleData && this.state.vehicleData.rcPermitNo) ||
          this.state.permitNumber ||
          '',
        permitIssueDate:
          this.state.rcPermitIssueDt ||
          (this.state.vehicleData && this.state.vehicleData.rcPermitIssueDt) ||
          this.state.permitIssueDate ||
          '',
        permitValidFrom:
          this.state.rcPermitValidFrom ||
          (this.state.vehicleData &&
            this.state.vehicleData.rcPermitValidFrom) ||
          this.state.permitValidFrom ||
          '',
        permitValidUpto:
          this.state.rcPermitValidUpto ||
          (this.state.vehicleData &&
            this.state.vehicleData.rcPermitValidUpto) ||
          this.state.permitValidUpto ||
          '',
        permitType:
          this.state.rcPermitType ||
          (this.state.vehicleData && this.state.vehicleData.rcPermitType) ||
          this.state.permitType ||
          '',
        permitCode:
          this.state.rcPermitCode ||
          (this.state.vehicleData && this.state.vehicleData.rcPermitCode) ||
          this.state.permitCode ||
          '',
        numberOfAxles:
          this.state.rcNoOfAxle ||
          (this.state.vehicleData && this.state.vehicleData.rcNoOfAxle) ||
          this.state.numberOfAxles ||
          null,
        fuelCode:
          this.state.rcFuelCd ||
          (this.state.vehicleData && this.state.vehicleData.rcFuelCd) ||
          this.state.fuelCode ||
          '',
        // vehicleType: (this.state.rcVhType || (this.state.vehicleData && this.state.vehicleData.rcVhType) || this.state.vehicleType) == 'T' ? "Truck" :this.state.rcVhType || (this.state.vehicleData && this.state.vehicleData.rcVhType) || this.state.vehicleType ,
        vehicleType:
          this.state.vehicleSegment === 'DG Set'
            ? 'DG Set'
            : this.state.vehicleSegment === 'Transportation'
              ? this.state.transportationVehicleType
              : this.state.vehicleSegment === 'Construction'
                ? this.state.constructionVehicleType
                : this.state.vehicleSegment === 'Passenger'
                  ? this.state.passengerVehicleType
                  : this.state.vehicleData && this.state.vehicleData.rcVhType
                    ? this.state.vehicleData.rcVhType === 'T'
                      ? 'Truck'
                      : this.state.vehicleData.rcVhType
                    : this.state.rcVhType || 'N/A',
        vehicleClass:
          this.state.rcVhClass ||
          (this.state.vehicleData && this.state.vehicleData.rcVhClass) ||
          this.state.vehicleClass ||
          '',

        clientName: this.state.client,
        custCode: this.state.customerCode,
        custType: this.state.customerType,
        noOfWheels: this.state.noOfWheels ? parseInt(this.state.noOfWheels) : null,
        baselineHours: parseInt(this.state.baselineHours),
        vehicleCustomizedBodyType: this.state.vehicleCustomizedBodyType,
        // vehicleModel: this.state.rcMakerModel || (this.state.vehicleData && this.state.vehicleData.rcMakerModel) || this.state.makerModel,
        noOfGears: parseInt(this.state.noOfGears),
        gearRatio: this.state.gearRatio,
        isIndividualViewOrCombinedView: this.state
          .isIndividualViewOrCombinedView,
        tensionerConductorLength: this.state.tensionerConductorLength,
        tensionerRotationSensorDirection:
          this.state.tensionerRotationSensorDirection || '',
        isRotationSensor: this.state.isRotationSensor,
        istachoenabled: this.state.istachoenabled,
        tachoidlerpm: this.state.tachoidlerpm ? parseInt(this.state.tachoidlerpm) : null,
        tachoengineonmin:
          this.state.tachoengineonmin !== '' && this.state.tachoengineonmin !== null
            ? parseInt(this.state.tachoengineonmin, 10)
            : null,
        tachoengineonmax:
          this.state.tachoengineonmax !== '' && this.state.tachoengineonmax !== null
            ? parseInt(this.state.tachoengineonmax, 10)
            : null,
        tachoshifthours: this.state.tachoshifthours ? parseInt(this.state.tachoshifthours) : null,
        technicianName: this.state.technicianName || null,
        updatedBy: this.state.updatedBy || null,
        timezone_offset: this.state.timezone_offset || null,
        plant_code: this.state.plant_code || null,
        owner_type: this.state.owner_type || null,
        equipment_type: this.state.equipment_type || null,
        equipment_no: this.state.equipment_no || null
      },
      errorPolicy: 'all'
    })

    if (data) {
      await client.clearStore()

      try {
        await client.mutate({
          mutation: ADD_ELOCK_CONNECTION,
          variables: {
            uniqueId: this.state.uniqueDeviceId,
            status: this.state.isElockConnection ? 1 : 0,
            deviceType: this.state.deviceType
          }
        })
      } catch (error) {
        console.log('Error adding elock connection', error)
      }

      this.setState({ response: data.addVehicleDetail })
      this.props.openSnackbar('Vehicle Details Updated Successfully')
      this.props.history.goBack()
    } else {
      this.setState({ failure: true })
      this.props.openSnackbar(errors[0].message)
    }
  }
  handleChange = name => event => {
    this.setState(
      { [name]: event.target.checked, installStatus: event.target.checked },
      () => {
        console.log('int', this.state.installStatus)
      }
    )
  }

  flushVahaanValues = async () => {
    if (this.state.vehicleSegment == 'DG Set') {
      this.setState({
        loading: false,
        vehicleData: null,
        rcRegnNo: '',
        rcRegnDt: '',
        rcRegnUpto: '',
        rcPurchaseDt: '',
        rcOwnerSr: '',
        rcOwnerName: '',
        stateCd: '',
        rtoCd: '',
        rcPresentAddress: '',
        rcPermanentAddress: '',
        rcVchCatg: '',
        rcVhClassDesc: '',
        rcChasiNo: '',
        rcEngNo: '',
        rcMakerDesc: '',
        rcMakerModel: '',
        rcBodyTypeDesc: '',
        rcFuelDesc: '',
        rcColor: '',
        rcNormsDesc: '',
        rcFitUpto: '',
        rcNpUpto: '',
        rcNpIssuedBy: '',
        rcTaxUpto: '',
        rcFinancer: '',
        rcInsuranceComp: '',
        rcInsurancePolicyNo: '',
        rcInsuranceUpto: '',
        rcManuMonthYr: '',
        rcUnldWt: '',
        rcGvw: '',
        rcNoCyl: '',
        rcCubicCap: '',
        rcSeatCap: '',
        rcSleeperCap: '',
        rcStandCap: '',
        rcWheelbase: '',
        rcRegisteredAt: '',
        rcStatusAsOn: '',
        rcPuccUpto: '',
        rcPuccNo: '',
        rcStatus: '',
        rcNcrbStatus: '',
        rcBlacklistStatus: '',
        rcPermitNo: '',
        rcPermitIssueDt: '',
        rcPermitValidFrom: '',
        rcPermitValidUpto: '',
        rcPermitType: '',
        rcPermitCode: '',
        rcNocDetails: '',
        rcVhType: '',
        rcVhClass: '',
        rcNocDt: '',
        rcFuelCd: '',
        rcMakerCd: '',
        rcModelCd: '',
        rcNormsCd: '',
        rcSaleAmt: '',
        rcOwnCatgDesc: '',
        rcVhClassDesc: '',
        rcOwnerCdDesc: '',
        rcCurrentaddDistrictcode: '',
        rcNonUse: '',
        rcPassengerTax: '',
        rcGoodsTax: '',
        rcNoOfAxle: '',
        rcApprovalDate: '',
        rcHp: '',
        rcMandalDesc: '',
        rcTalukCd: ''
      })
    }
  }

  handleVehicleRegistrationNumberAvailableChange = name => event => {
    const enteredVehicleRegistrationNumber = null

    this.setState({ [name]: event.target.checked }, () => {
      if (this.state.vehicleRegistrationNumberAvailableStatus) {
        console.log('Vehicle Registration Number Available')
      } else {
        console.log('Vehicle Registration Number Unavailable')
        this.setState({
          loading: false,
          vehicleData: null,
          rcRegnNo: '',
          rcRegnDt: '',
          rcRegnUpto: '',
          rcPurchaseDt: '',
          rcOwnerSr: '',
          rcOwnerName: '',
          stateCd: '',
          rtoCd: '',
          rcPresentAddress: '',
          rcPermanentAddress: '',
          rcVchCatg: '',
          rcVhClassDesc: '',
          rcChasiNo: '',
          rcEngNo: '',
          rcMakerDesc: '',
          rcMakerModel: '',
          rcBodyTypeDesc: '',
          rcFuelDesc: '',
          rcColor: '',
          rcNormsDesc: '',
          rcFitUpto: '',
          rcNpUpto: '',
          rcNpIssuedBy: '',
          rcTaxUpto: '',
          rcFinancer: '',
          rcInsuranceComp: '',
          rcInsurancePolicyNo: '',
          rcInsuranceUpto: '',
          rcManuMonthYr: '',
          rcUnldWt: '',
          rcGvw: '',
          rcNoCyl: '',
          rcCubicCap: '',
          rcSeatCap: '',
          rcSleeperCap: '',
          rcStandCap: '',
          rcWheelbase: '',
          rcRegisteredAt: '',
          rcStatusAsOn: '',
          rcPuccUpto: '',
          rcPuccNo: '',
          rcStatus: '',
          rcNcrbStatus: '',
          rcBlacklistStatus: '',
          rcPermitNo: '',
          rcPermitIssueDt: '',
          rcPermitValidFrom: '',
          rcPermitValidUpto: '',
          rcPermitType: '',
          rcPermitCode: '',
          rcNocDetails: '',
          rcVhType: '',
          rcVhClass: '',
          rcNocDt: '',
          rcFuelCd: '',
          rcMakerCd: '',
          rcModelCd: '',
          rcNormsCd: '',
          rcSaleAmt: '',
          rcOwnCatgDesc: '',
          rcVchCatgDesc: '',
          rcOwnerCdDesc: '',
          rcCurrentaddDistrictcode: '',
          rcNonUse: '',
          rcPassengerTax: '',
          rcGoodsTax: '',
          rcNoOfAxle: '',
          rcApprovalDate: '',
          rcHp: '',
          rcMandalDesc: '',
          rcTalukCd: ''
        })
      }
    })
  }

  getDataByVehicleNumber = async () => {
    const { enteredVehicleRegistrationNumber } = this.state
    this.setState({ vehicleData: null, vlpnres: '', loading: false })

    if (
      !enteredVehicleRegistrationNumber ||
      enteredVehicleRegistrationNumber.length < 5 ||
      enteredVehicleRegistrationNumber.length > 32
    ) {
      this.setState({
        vlpnres:
          'Vehicle Registration Number must be between 5 to 32 characters.'
      })
      return
    }

    try {
      // const { data } = await this.props.client.query({
      //   query: GET_VLPN,
      //   variables: { vlpn: enteredVehicleRegistrationNumber }
      // })

      // if (data.checkVehicleNumber === 'AVAILABLE') {this.setState({ vlpnres: 'Data not available for the entered Vehicle Number' })};

      this.setState({
        loading: true
      })

      const response = await this.props.client.query({
        query: GET_VEHICLE_VAHAAN_DETAILS,
        variables: { vehicleNumber: enteredVehicleRegistrationNumber }
      })

      if (
        response.data &&
        response.data.getVehicleVahaanDetails &&
        response.data.getVehicleVahaanDetails.length > 0
      ) {
        const vahaanDetails = response.data.getVehicleVahaanDetails[0]
        // Vahan fuel descriptions are inconsistent (e.g. "DIESEL/HYBRID"); map
        // them to the fuel-type option values so the dropdown auto-selects.
        const vehicleData = {
          ...vahaanDetails,
          rcFuelDesc: normalizeFuelType(vahaanDetails.rcFuelDesc)
        }
        this.setState({ vehicleData: vehicleData })
        console.log('Fetched vehicle details:', vehicleData)
      } else {
        console.log('No vehicle details found.')
        {
          this.setState({
            vlpnres:
              'Data not available currently for the entered Vehicle Number. Please check the Vehicle Number and try again after some time.'
          })
        }
      }
    } catch (error) {
      console.error('Error fetching vehicle details:', error)
      {
        this.setState({
          vlpnres:
            'Error occurred while fetching vehicle details. Please try again after some time.'
        })
      }
    } finally {
      this.setState({ loading: false })
    }

    if (this.state.vlpnres) {
      this.setState({
        rcRegnNo: '',
        rcRegnDt: '',
        rcRegnUpto: '',
        rcPurchaseDt: '',
        rcOwnerSr: '',
        rcOwnerName: '',
        stateCd: '',
        rtoCd: '',
        rcPresentAddress: '',
        rcPermanentAddress: '',
        rcVchCatg: '',
        rcVhClassDesc: '',
        rcChasiNo: '',
        rcEngNo: '',
        rcMakerDesc: '',
        rcMakerModel: '',
        rcBodyTypeDesc: '',
        rcFuelDesc: '',
        rcColor: '',
        rcNormsDesc: '',
        rcFitUpto: '',
        rcNpUpto: '',
        rcNpIssuedBy: '',
        rcTaxUpto: '',
        rcFinancer: '',
        rcInsuranceComp: '',
        rcInsurancePolicyNo: '',
        rcInsuranceUpto: '',
        rcManuMonthYr: '',
        rcUnldWt: '',
        rcGvw: '',
        rcNoCyl: '',
        rcCubicCap: '',
        rcSeatCap: '',
        rcSleeperCap: '',
        rcStandCap: '',
        rcWheelbase: '',
        rcRegisteredAt: '',
        rcStatusAsOn: '',
        rcPuccUpto: '',
        rcPuccNo: '',
        rcStatus: '',
        rcNcrbStatus: '',
        rcBlacklistStatus: '',
        rcPermitNo: '',
        rcPermitIssueDt: '',
        rcPermitValidFrom: '',
        rcPermitValidUpto: '',
        rcPermitType: '',
        rcPermitCode: '',
        rcNocDetails: '',
        rcVhType: '',
        rcVhClass: '',
        rcNocDt: '',
        rcFuelCd: '',
        rcMakerCd: '',
        rcModelCd: '',
        rcNormsCd: '',
        rcSaleAmt: '',
        rcOwnCatgDesc: '',
        rcVchCatgDesc: '',
        rcOwnerCdDesc: '',
        rcCurrentaddDistrictcode: '',
        rcNonUse: '',
        rcPassengerTax: '',
        rcGoodsTax: '',
        rcNoOfAxle: '',
        rcApprovalDate: '',
        rcHp: '',
        rcMandalDesc: '',
        rcTalukCd: ''
      })
    }
  }
  handleImmobilizeChange = status => eve => {
    this.setState(
      { [status]: eve.target.checked, immobilize: eve.target.checked },
      () => {
        console.log('immobilizeStatus', this.state.immobilize)
      }
    )
  }

  handleEmissionType = event => {
    if (event) this.setState({ emissionRateType: event.target.value })
    else this.setState({ emissionRateType: '' })
  }
  handleChangeMake = async event => {
    this.setState({
      vehicleMake: event ? event.label : null,
      vehicleMakeId: event ? event.value : null,
      kvaRating: '',
      dgSetType: ''
    })
    if (event && this.state.vehicleSegment == 'DG Set') {
      const makemodellist = await this.props.client.query({
        query: GET_DG_MODELS,
        variables: { make: event.value }
        // fetchPolicy: 'network-only'
      })
      const models = makemodellist.data.getDgModels
      const modelsList =
        models &&
        models.map(model => {
          return {
            id: model,
            model
          }
        })
      this.setState({ modelsList })
      return
    }
    if (event) {
      const makemodellist = await this.props.client.query({
        query: GET_VEHICLE_MODELS,
        variables: { makeId: event.value }
        // fetchPolicy: 'network-only'
      })
      this.setState({ modelsList: makemodellist.data.getVehicleModels })
    } else {
      this.setState({ modelsList: [] })
      this.setState({ emissionRateType: '' })
    }
  }

  handleChangeModelNew = async event => {
    let vehicleModel = event ? event.label : null
    let vehicleModelId = event ? event.value : null

    this.setState({
      vehicleModel: vehicleModel,
      vehicleModelId: vehicleModelId
    })
  }

  fetchModelDetails = async event => {
    this.setState({
      vehicleModel: event ? event.label : null,
      vehicleModelId: event ? event.value : null,
      emissionRateType: this.state.emissionRateType,
      grossVehicleWeight: this.state.grossVehicleWeight,
      fuelTankCapacity: this.state.fuelTankCapacity,
      adblueCapacity: this.state.adblueCapacity,
      manufacturingYear: this.state.manufacturingYear,
      fuelType: this.state.fuelType,
      engineSpecification: this.state.engineSpecification,
      engineSpecificationFromApi: false,
      emissionRateTypeFromApi: false,
      grossVehicleWeightFromApi: false,
      fuelTankCapacityFromApi: false,
      adblueCapacityFromApi: false,
      manufacturingYearFromApi: false,
      fuelTypeFromApi: false
    })
    if (event && this.state.vehicleSegment == 'DG Set') {
      return
    }

    if (event) {
      try {
        var makemodellistDetails = await this.props.client.query({
          query: GET_VEHICLE_PARAMS,
          variables: { modelId: event.value }
          // fetchPolicy: 'network-only'
        })

        console.log(makemodellistDetails.data, 'heyyy')

        if (makemodellistDetails && makemodellistDetails.data) {
          if (makemodellistDetails.data.getVehicleParameters.length > 0) {
            let fuelType = makemodellistDetails.data.getVehicleParameters[0][
              'fuel_type'
            ]
              ? makemodellistDetails.data.getVehicleParameters[0]['fuel_type']
              : this.state.fuelType
            if (
              fuelType === 'Diesel' ||
              fuelType === 'diesel' ||
              fuelType === 'DIESEL'
            ) {
              fuelType = 'diesel'
            }

            if (
              fuelType === 'Petrol' ||
              fuelType === 'petrol' ||
              fuelType === 'PETROL'
            ) {
              fuelType = 'petrol'
            }
            this.setState({
              emissionRateType: makemodellistDetails.data
                .getVehicleParameters[0]['emission_type']
                ? makemodellistDetails.data.getVehicleParameters[0][
                    'emission_type'
                  ]
                : this.state.emissionRateType,
              grossVehicleWeight: makemodellistDetails.data
                .getVehicleParameters[0]['gross_vehicle_weight']
                ? makemodellistDetails.data.getVehicleParameters[0][
                    'gross_vehicle_weight'
                  ]
                : this.state.grossVehicleWeight,
              fuelTankCapacity: makemodellistDetails.data
                .getVehicleParameters[0]['fuel_capacity']
                ? makemodellistDetails.data.getVehicleParameters[0][
                    'fuel_capacity'
                  ]
                : this.state.fuelTankCapacity,
              adblueCapacity: this.state.adblueCapacity
                ? this.state.adblueCapacity
                : makemodellistDetails.data.getVehicleParameters[0][
                    'adblue_capacity'
                  ], //added
              // ? makemodellistDetails.data.getVehicleParameters[0][
              //     'adblue_capacity'
              //   ]
              // : this.state.adblueCapacity,
              manufacturingYear: makemodellistDetails.data
                .getVehicleParameters[0]['manufacturing_year']
                ? makemodellistDetails.data.getVehicleParameters[0][
                    'manufacturing_year'
                  ]
                : this.state.manufacturingYear,
              fuelType: fuelType,
              engineSpecification: makemodellistDetails.data
                .getVehicleParameters[0]['engine_specification']
                ? makemodellistDetails.data.getVehicleParameters[0][
                    'engine_specification'
                  ]
                : this.state.engineSpecification
            })

            // Set the corresponding flags to true only if data is not null
            if (
              makemodellistDetails.data.getVehicleParameters[0]['emission_type']
            ) {
              this.setState({ emissionRateTypeFromApi: true })
            }
            if (
              makemodellistDetails.data.getVehicleParameters[0][
                'gross_vehicle_weight'
              ]
            ) {
              this.setState({ grossVehicleWeightFromApi: true })
            }
            if (
              makemodellistDetails.data.getVehicleParameters[0]['fuel_capacity']
            ) {
              this.setState({ fuelTankCapacityFromApi: true })
            }
            if (
              makemodellistDetails.data.getVehicleParameters[0][
                'adblue_capacity'
              ]
            ) {
              this.setState({ adblueCapacityFromApi: true })
            }
            if (
              makemodellistDetails.data.getVehicleParameters[0][
                'manufacturing_year'
              ]
            ) {
              this.setState({ manufacturingYearFromApi: true })
            }
            if (
              makemodellistDetails.data.getVehicleParameters[0]['fuel_type']
            ) {
              this.setState({ fuelTypeFromApi: true })
            }
            if (
              makemodellistDetails.data.getVehicleParameters[0][
                'engine_specification'
              ]
            ) {
              this.setState({ engineSpecificationFromApi: true })
            }
          }
        }
      } catch (error) {
        this.setState({
          emissionRateType: '',
          // grossVehicleWeight: '',
          fuelTankCapacity: '',
          adblueCapacity: '',
          manufacturingYear: '',
          // fuelType: '',
          engineSpecification: '',
          engineSpecificationFromApi: false,
          emissionRateTypeFromApi: false,
          grossVehicleWeightFromApi: false,
          fuelTankCapacityFromApi: false,
          adblueCapacityFromApi: false,
          manufacturingYearFromApi: false,
          fuelTypeFromApi: false
        })
      }
    }
  }

  handleChangeModel = async event => {
    let tempId = this.state.vehicleDetails.vehicleModelId
    const vehicleDetails = this.state.vehicleDetails

    let vehicleModel = event ? event.label : null
    let vehicleModelId = event ? event.value : null

    this.setState({
      vehicleModel: vehicleModel,
      vehicleModelId: vehicleModelId
    })

    let fuelType =
      tempId === vehicleModelId && vehicleDetails.fuelType
        ? vehicleDetails.fuelType
        : ''

    if (
      fuelType === 'Diesel' ||
      fuelType === 'diesel' ||
      fuelType === 'DIESEL'
    ) {
      fuelType = 'diesel'
    }

    if (
      fuelType === 'Petrol' ||
      fuelType === 'petrol' ||
      fuelType === 'PETROL'
    ) {
      fuelType = 'petrol'
    }

    if (event && this.state.vehicleSegment == 'DG Set') {
      // console.log('state in handleChangeModel',this.state);
      const make = this.state.vehicleMakeId
      const dgSpecsResponse = await this.props.client.query({
        query: GET_DG_SPECS_FROM_MODEL,
        variables: { make: make, model: event.value }
        // fetchPolicy: 'network-only'
      })
      const dgSpecs = dgSpecsResponse.data.getDgspecsFromModel

      const kvaRatingOptions =
        dgSpecs &&
        dgSpecs.map(row => {
          return {
            value: row.kvaRating,
            label: row.kvaRating
          }
        })
      if (kvaRatingOptions.length === 1) {
        this.setState({ kvaRating: kvaRatingOptions[0].value })
      }
      const dgSetTypeOptions =
        dgSpecs &&
        dgSpecs.map(row => {
          return {
            value: row.dgSetType,
            label: row.dgSetType
          }
        })
      if (dgSetTypeOptions.length === 1) {
        this.setState({ dgSetType: dgSetTypeOptions[0].value })
      }
      this.setState({ kvaRatingOptions, dgSetTypeOptions })
      return
    }

    this.setState({
      emissionRateType:
        tempId === vehicleModelId && vehicleDetails.emissionRateType
          ? vehicleDetails.emissionRateType
          : '',
      grossVehicleWeight:
        tempId === vehicleModelId && vehicleDetails.grossVehicleWeight
          ? vehicleDetails.grossVehicleWeight
          : '',
      fuelTankCapacity:
        tempId === vehicleModelId && vehicleDetails.fuelTankCapacity
          ? vehicleDetails.fuelTankCapacity
          : '',
      adblueCapacity:
        tempId === vehicleModelId && vehicleDetails.adblueCapacity
          ? vehicleDetails.adblueCapacity
          : '',
      manufacturingYear:
        tempId === vehicleModelId && vehicleDetails.manufacturingYear
          ? vehicleDetails.manufacturingYear
          : '',
      fuelType: fuelType,
      engineSpecification:
        tempId === vehicleModelId && vehicleDetails.engineSpecification
          ? vehicleDetails.engineSpecification
          : '',
      engineSpecificationFromApi: false,
      emissionRateTypeFromApi: false,
      grossVehicleWeightFromApi: false,
      fuelTankCapacityFromApi: false,
      adblueCapacityFromApi: false,
      manufacturingYearFromApi: false,
      fuelTypeFromApi: false
    })

    if (event) {
      try {
        var makemodellistDetails = await this.props.client.query({
          query: GET_VEHICLE_PARAMS,
          variables: { modelId: vehicleModelId }
          // fetchPolicy: 'network-only'
        })

        console.log(makemodellistDetails.data, 'heyyy')

        if (makemodellistDetails && makemodellistDetails.data) {
          if (makemodellistDetails.data.getVehicleParameters.length > 0) {
            const firstElement =
              makemodellistDetails.data.getVehicleParameters[0]

            let fuelType = firstElement['fuel_type']
              ? firstElement['fuel_type']
              : tempId === vehicleModelId
                ? vehicleDetails.fuelType
                : ''
            if (
              fuelType === 'Diesel' ||
              fuelType === 'diesel' ||
              fuelType === 'DIESEL'
            ) {
              fuelType = 'diesel'
            }

            if (
              fuelType === 'Petrol' ||
              fuelType === 'petrol' ||
              fuelType === 'PETROL'
            ) {
              fuelType = 'petrol'
            }

            this.setState({
              emissionRateType: firstElement['emission_type']
                ? firstElement['emission_type']
                : tempId === vehicleModelId
                  ? vehicleDetails.emissionRateType
                  : '',
              grossVehicleWeight: firstElement['gross_vehicle_weight']
                ? firstElement['gross_vehicle_weight']
                : tempId === vehicleModelId
                  ? vehicleDetails.grossVehicleWeight
                  : '',
              fuelTankCapacity: firstElement['fuel_capacity']
                ? firstElement['fuel_capacity']
                : tempId === vehicleModelId
                  ? vehicleDetails.fuelTankCapacity
                  : '',
              adblueCapacity: firstElement['adblue_capacity']
                ? firstElement['adblue_capacity']
                : tempId === vehicleModelId
                  ? vehicleDetails.adblueCapacity
                  : '',
              manufacturingYear: firstElement['manufacturing_year']
                ? firstElement['manufacturing_year']
                : tempId === vehicleModelId
                  ? vehicleDetails.manufacturingYear
                  : '',
              fuelType: fuelType,
              engineSpecification: firstElement['engine_specification']
                ? firstElement['engine_specification']
                : tempId === vehicleModelId
                  ? vehicleDetails.engineSpecification
                  : ''
            })

            // Set the corresponding flags to true only if data is not null
            if (firstElement['emission_type']) {
              this.setState({ emissionRateTypeFromApi: true })
            }
            if (firstElement['gross_vehicle_weight']) {
              this.setState({ grossVehicleWeightFromApi: true })
            }
            if (firstElement['fuel_capacity']) {
              this.setState({ fuelTankCapacityFromApi: true })
            }
            if (firstElement['adblue_capacity']) {
              this.setState({ adblueCapacityFromApi: true })
            }
            if (firstElement['manufacturing_year']) {
              this.setState({ manufacturingYearFromApi: true })
            }
            if (firstElement['fuel_type']) {
              this.setState({ fuelTypeFromApi: true })
            }
            if (firstElement['engine_specification']) {
              this.setState({ engineSpecificationFromApi: true })
            }
          }
        }
      } catch (error) {
        this.setState({
          emissionRateType: '',
          grossVehicleWeight: '',
          fuelTankCapacity: '',
          adblueCapacity: '',
          manufacturingYear: '',
          fuelType: '',
          engineSpecification: '',
          engineSpecificationFromApi: false,
          emissionRateTypeFromApi: false,
          grossVehicleWeightFromApi: false,
          fuelTankCapacityFromApi: false,
          adblueCapacityFromApi: false,
          manufacturingYearFromApi: false,
          fuelTypeFromApi: false
        })
      }
    }
  }

  getMakeAndModels = async () => {
    const makemodellist = await this.props.client.query({
      query: GET_VEHICLE_MAKES,
      variables: {}
      // fetchPolicy: 'network-only'
    })

    this.setState({ makesList: makemodellist.data.getVehicleMakes })
  }

  getAllDGMakes = async () => {
    const responce = await this.props.client.query({
      query: GET_ALL_DG_MAKES,
      variables: {}
      // fetchPolicy: 'network-only'
    })
    const makes = responce.data.getDgMakes
    // console.log('makes',makes);
    const makesList =
      makes &&
      makes.map(make => {
        return {
          make,
          id: make
        }
      })
    // console.log('makesList',makesList);
    this.setState({ makesList: makesList })
  }

  getDgspecsFromModel = async (make, model) => {
    try {
      const dgSpecsResponse = await this.props.client.query({
        query: GET_DG_SPECS_FROM_MODEL,
        variables: { make, model }
        // fetchPolicy: 'network-only'
      })
      const dgSpecs = dgSpecsResponse.data.getDgspecsFromModel

      const kvaRatingOptions =
        dgSpecs &&
        dgSpecs.map(row => {
          return {
            value: row.kvaRating,
            label: row.kvaRating
          }
        })
      if (kvaRatingOptions.length === 1) {
        this.setState({ kvaRating: kvaRatingOptions[0].value })
      }
      const dgSetTypeOptions =
        dgSpecs &&
        dgSpecs.map(row => {
          return {
            value: row.dgSetType,
            label: row.dgSetType
          }
        })
      if (dgSetTypeOptions.length === 1) {
        this.setState({ dgSetType: dgSetTypeOptions[0].value })
      }
      this.setState({ kvaRatingOptions, dgSetTypeOptions })
      return
    } catch (error) {
      console.log('error in getDgspecsFromModel', error)
    }
  }

  isNumericalArray = array => {
    return array.every(item => !isNaN(item))
  }

  sortNumericalArray = array => {
    return array.sort((a, b) => parseInt(a) - parseInt(b))
  }
  fetchDropdownDetails = async () => {
    try {
      const response = await this.props.client.query({
        query: GET_DROPDOWN_DETAILS
      })

      console.log('Raw response:', response)

      const dropdownData = JSON.parse(response.data.getDropDownDetail)

      console.log('Parsed dropdown data:', dropdownData)

      const dropdownValues = {}

      Object.keys(dropdownData).forEach(key => {
        if (Array.isArray(dropdownData[key])) {
          dropdownValues[key] = dropdownData[key].filter(
            option => option !== null
          )
        }
        if (this.isNumericalArray(dropdownValues[key])) {
          dropdownValues[key] = this.sortNumericalArray(dropdownValues[key])
        }
      })

      this.setState({
        ...dropdownValues
        // selectedApplication: this.state.application
      })
    } catch (error) {
      console.error('Error fetching dropdown details:', error)
    }
  }
  fetchCustomerTypeAndCode = async () => {
    try {
      const response = await this.props.client.query({
        query: GET_CUSTOMER_TYPE_AND_CODE,
        variables: { clientName: this.state.clientName }
      })

      console.log('Raw response:', response)

      const customerData = response.data.getCustomerTypeAndCode

      console.log('Parsed customer data:', customerData)

      const customerValues = {
        id: customerData.id,
        clientName: customerData.clientName,
        registrationType: customerData.registrationType,
        directCustomerSAPCode: customerData.directCustomerSAPCode,
        channelPartnerSAPCode: customerData.channelPartnerSAPCode
      }

      const customerCode =
        customerData.directCustomerSAPCode ||
        customerData.channelPartnerSAPCode ||
        ''

      this.setState({
        ...customerValues,
        customerType: customerData.registrationType,
        customerCode: customerCode
      })
    } catch (error) {
      console.error('Error fetching customer type and code:', error)
    }
  }

  componentDidMount() {
    this.getTimezones()
    this.getDashcamRegistrations()
    this.getMakeAndModels()
    this.getVehicleDetails()
    this.getZMKAMDetails()
    this.getAllAssignedRoles()
    // this.getDGSpecifications()
    // this.handleClickOpen()
    this.getVehicleType()
    this.fetchDropdownDetails()
    this._isMounted = true
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      dashcamRegistrations,
      selectedVtid,
      selectedSimId,
      selectedMemoryCardId
    } = this.state

    // Ensure we wait for both API responses
    if (dashcamRegistrations.length > 0 && selectedVtid) {
      // Only proceed if data changed
      if (
        prevState.dashcamRegistrations !== dashcamRegistrations ||
        prevState.selectedVtid !== selectedVtid
      ) {
        const matchedDashcam = dashcamRegistrations.find(
          el => el.vtid === selectedVtid
        )

        if (
          matchedDashcam &&
          this._isMounted &&
          (prevState.selectedVtid !== matchedDashcam.vtid ||
            prevState.selectedSimId !== matchedDashcam.simid ||
            prevState.selectedMemoryCardId !== matchedDashcam.memorycardid)
        ) {
          this.setState({
            selectedVtid: matchedDashcam.vtid,
            selectedSimId: matchedDashcam.simid,
            selectedMemoryCardId: matchedDashcam.memorycardid
          })
        }
      }
    }
  }

  handleClickOpen = () => {
    this.setState({ open: true })
  }
  handleClose = status => {
    this.setState({ open: false })
  }
  handleDecoupleOpen = () => {
    this.setState({ open2: true })
  }
  handleDecoupleClose = () => {
    this.setState({ open2: false })
  }
  handleChannelPartnerNameChange = event => {
    this.setState({ channelPartnerName: event.target.value })
  }
  handleChangeZM = async event => {
    if (event) {
      this.setState({ zmId: event.value })
    } else {
      this.setState({ zmId: '' })
    }
  }
  handleChangeKAM = async event => {
    if (event) {
      this.setState({ kamId: event.value })
    } else {
      this.setState({ kamId: '' })
    }
  }

  handleMailClose = () => {
    this.setState({
      open3: false,
      ismailValid: true,
      mail: ''
    })
  }
  handleSwapClose = () => {
    this.setState({ swapOpen: false })
  }
  handleDeleteClose = () => {
    this.setState({ deleteOpen: false })
  }
  handleSucessDeleteClose = () => {
    this.setState({ deleteOpen: false })
    this.props.history.push({
      pathname: '/home/VehcileDashboard/Dashboard'
    })
  }

  swapClient = () => {
    this.setState({ swapOpen: true })
  }
  deleteVehicle = () => {
    this.setState({ deleteOpen: true })
  }

  // Activate deactivate function
  // handleClickButtonAction = client => async currentStatus => {
  //   let updateStatus
  //   if (currentStatus === 0) {
  //     updateStatus = true
  //   } else {
  //     updateStatus = false
  //   }
  //   const { data, Error } = await client.mutate({
  //     mutation: UPDATE_VEHICLE_STATUS,
  //     variables: {
  //       uniqueDeviceId: this.state.uniqueDeviceId,
  //       isActivated: updateStatus
  //     },
  //     errorPolicy: 'all'
  //   })
  //   this.setState({
  //     currentStatus: ''
  //   })
  // }

  // onUpload = async ({
  //   target: {
  //     validity,
  //     files: [file]
  //   }
  // }) => {
  //   /* eslint-disable */

  //   // TODO: Handle upload errors
  //   this.setState({ isUploading: true })
  //   if (validity.valid) {
  //     this.setState({ fileName: file.name })
  //     var formdata = new FormData()
  //     formdata.append('certificateFile', file, file.name)
  //     formdata.append('vehicleNumber', this.state.vlpn)

  //     var requestOptions = {
  //       method: 'POST',
  //       body: formdata,
  //       redirect: 'follow'
  //     }

  //     fetch(process.env.REACT_APP_FILE_UPLOAD_URL, requestOptions)
  //       .then(response => response.text())
  //       .then(result => this.setState({ fileResponse: result }))
  //       .catch(error => this.setState({ uploadError: error }))
  //   }
  //   this.setState({ isUploading: false })
  // }

  // Todo function for generate PDF
  handleGenerate = async event => {
    const { data } = await this.props.client.query({
      query: GENERATE_CERTIFICATE,
      variables: {
        entityId: parseInt(this.entityId, 10)
      },
      fetchPolicy: 'network-only'
    })

    if (data.generatePDF) {
      this.setState({ PDFLink: data.generatePDF.filePublicDownloadURL })

      this.setState({ open3: true })
    } else {
      this.props.openSnackbar('Error in generating Certificate')
    }
  }

  handleSendMail = async event => {
    const responce = await this.props.client.query({
      query: SEND_MAIL,
      variables: {
        email: this.state.mail,
        pdfLink: this.state.PDFLink
      },
      fetchPolicy: 'network-only'
    })
    if (responce.data) {
      this.setState({
        open3: false,
        ismailValid: true,
        mail: ''
      })
      this.props.openSnackbar('Link Sent to email Address')
    } else {
      this.props.openSnackbar(responce.error)
    }
  }

  downloadCertificate = async event => {
    const { data } = await this.props.client.query({
      query: GENERATE_CERTIFICATE,
      variables: {
        entityId: parseInt(this.entityId, 10)
      },
      fetchPolicy: 'network-only'
    })
    if (data.generatePDF) {
      this.setState({ PDFLink: data.generatePDF.filePublicDownloadURL })
      let link = document.createElement('a')
      link.href = this.state.PDFLink
      link.click()
      URL.revokeObjectURL(link.href)
    } else {
      this.props.openSnackbar('Error in Downloading Certificate')
    }
  }

  isSubmitFormInvalid() {
    const {
      errorMessage,
      errorMessageNew,
      errorMessageFuelTank,
      isUploading,
      // isBaselineDataForFEValid,
      // baselineDataType,
      // baselineDataForFE,
      // isBaselineDistanceValid,
      // isBaselineHoursValid,
      // baselineDistance,
      // baselineHours,
      isInvoiceNoValid,
      invoiceNumber,
      invoiceDate,
      isSerialNumberValid,
      isPhoneNoValid,
      isClientNameValid,
      isSpeedLimitValid,
      isSpeedSensorValid,
      speedLimit,
      speedSensor,
      showClientDetails,
      subscriptionId,
      vehicleData,
      rcMakerDesc,
      rcMakerModel,
      portedVehicle,
      isTestingVehicle,
      solutionType,
      solution_type,
      vehicleSegment,
      fuelTankCapacity,
      kvaRating,
      dgSetType,
      rcRegnNo,
      noOfWheels,
      selectedApplication,
      haulageType,
      constructionVehicleType,
      passengerVehicleType,
      transportationVehicleType,
      customerType,
      selectedVTM,
      videoTelematicsId,
      vehicleMakeId,
      vehicleModelId,
      serialNumber,
      phoneNumber,
      deviceType,
      vehicleMake,
      vehicleModel,
      adblueCapacity,
      isAdblueCapacityValid,
      isDualEngine,
      eon_voltage,
      eoff_voltage,
      isEonVoltageValid,
      isEoffVoltageValid
    } = this.state

    return (
      errorMessage ||
      errorMessageNew ||
      errorMessageFuelTank ||
      isUploading ||
      ((customerType == 'Paid' || vehicleSegment == 'DG Set') &&
        (!isInvoiceNoValid ||
          !invoiceNumber ||
          !(invoiceDate && invoiceDate.date))) ||
      !isSerialNumberValid ||
      !isPhoneNoValid ||
      !isClientNameValid ||
      !vehicleSegment ||
      !serialNumber ||
      !phoneNumber ||
      !solutionType ||
      !solution_type.length > 0 ||
      (selectedVTM && !videoTelematicsId) ||
      (vehicleSegment != 'DG Set' &&
        // !baselineDataType ||
        // !isBaselineDataForFEValid ||
        // !baselineDataForFE ||
        // (baselineDataType == 'kmpl' && (!baselineDistance || !isBaselineDistanceValid)) ||
        // (baselineDataType == 'lph' && (!baselineHours || !isBaselineHoursValid)) ||
        (!isSpeedLimitValid ||
          !isSpeedSensorValid ||
          !speedLimit ||
          !speedSensor ||
          // !subscriptionId ||
          !(
            this.state.rcRegnNo ||
            (this.state.vehicleData && this.state.vehicleData.rcRegnNo) ||
            this.state.vehicleRegistrationNumber ||
            this.state.vlpn
          ) ||
          !(
            this.state.rcMakerDesc ||
            (this.state.vehicleData && this.state.vehicleData.rcMakerDesc) ||
            this.state.makerDescription
          ) ||
          !(
            this.state.rcMakerModel ||
            (this.state.vehicleData && this.state.vehicleData.rcMakerModel) ||
            this.state.makerModel
          ) ||
          portedVehicle === '' ||
          isTestingVehicle === '' ||
          (vehicleSegment == 'Transportation' &&
            (!selectedApplication ||
              !haulageType ||
              !transportationVehicleType)) ||
          (vehicleSegment == 'Construction' && !constructionVehicleType) ||
          (vehicleSegment == 'Passenger' && !passengerVehicleType) ||
          !(
            this.state.rcVhType ||
            (this.state.vehicleData && this.state.vehicleData.rcVhType) ||
            this.state.vehicleType
          ))) ||
      (vehicleSegment == 'DG Set' &&
        (!vehicleMakeId ||
          !vehicleModelId ||
          !fuelTankCapacity ||
          !kvaRating ||
          !dgSetType)) ||
      ((deviceType == 'obd' || deviceType == 'OBD') &&
        (!vehicleMakeId || !vehicleModelId || !vehicleMake || !vehicleModel)) ||
      (deviceType &&
        deviceType.toLowerCase() === 'obd' &&
        (!adblueCapacity || !isAdblueCapacityValid)) ||
      (isDualEngine &&
        (!eon_voltage ||
          !eoff_voltage ||
          !isEonVoltageValid ||
          !isEoffVoltageValid)) ||
      (this.state.vehicleSegment === 'Construction' &&
        this.state.constructionVehicleType === 'Tensioner' &&
        (!this.state.tensionerConductorLength ||
          !this.state.tensionerRotationSensorDirection))
    )
  }

  render() {
    const classes = this.props
    let allSpeedSensor = []
    allSpeedSensor[0] = {
      value: 'GPS SPEED SENSOR',
      label: 'Gps speed sensor'
    }
    allSpeedSensor[1] = {
      value: 'DELTA_DISTANCE_CALCULATION',
      label: 'Delta Distance'
    }
    allSpeedSensor[2] = {
      value: 'ODOMETRIC',
      label: 'Odometric'
    }
    let allIdlingSpeed = [
      {
        value: 0,
        label: 0
      },
      {
        value: 1,
        label: 1
      },
      {
        value: 2,
        label: 2
      },
      {
        value: 3,
        label: 3
      }
    ]

    // let vehiclearr = [
    //   'Car',
    //   'Truck',
    //   'Ambulance',
    //   'School Bus',
    //   'Bike',
    //   'Sixseater',
    //   'Stacker',
    //   'Tow',
    //   'Tug',
    //   'Tractor',
    //   'Excavator',
    //   '3-Wheeler',
    //   'GeneratorTanker'
    // ]

    let allvehicleTypes = this.state.vehicleTypes.map(vehicle => ({
      value: vehicle,
      label: vehicle
    }))

    if (this.state.vehicleSegment == 'DG Set') {
      allvehicleTypes = [
        ...this.state.vehicleTypes.map(vehicle => ({
          value: vehicle,
          label: vehicle
        })),
        {
          value: 'DG Set',
          label: 'DG Set'
        }
      ]
    }

    return (
      <div className="Landing">
        <Grid item>
          <Button
            variant="outlined"
            color="primary"
            className="btn"
            onClick={() => this.props.history.goBack()}
          >
            Back
          </Button>
          {/* Delete Vehicle button removed: deAssignVehicleAndSImFromCLient does not write to
              vehicle_device_installation, so deletions from here were untraceable and bypassed
              no status checks. Use the Vehicle Unregistration feature instead, which logs
              properly to vehicle_device_installation. */}
          {/* <Button
            variant="outlined"
            color="secondary"
            className={classes.button}
            // href="/home/customers"
            // onClick={() => this.allCustomer(this.backUrl)}
            onClick={this.deleteVehicle}
          >
            <Tooltip title="Delete Vehicle">
              <DeleteForever className={classes.icon} />
            </Tooltip>
          </Button>{' '} */}
          <Grid
            container
            justify="center"
            className="full-screen"
            alignItems="flex-end"
          />
          <Grid item xs={12}>
            {/* <ItemCard className="form_layout"> */}
            <h3 className="Formheader">Edit Vehicle Detail</h3>
            <form>
              <div className="formouter">
                <Grid container>
                  <Grid item xs={12} sm={12}>
                    <Grid xs={12} sm={12}>
                      <h3>Customer Details</h3>
                    </Grid>

                    <Grid container className="searchdiv" spacing="8">
                      <ClientDetails
                        clientName={this.state.clientName}
                        address={this.state.address}
                        city={this.state.city}
                        loginId={this.state.id}
                      />
                    </Grid>
                    {/* <Grid item xs={12} sm={12} justify="center">
                      <label style={{ marginRight: '20px' }}>
                        Through Channel Partner :{' '}
                      </label>
                      <FormControl style={{ minWidth: '50%' }}>
                        <FormGroup className="form-input">
                          <FormControlLabel
                            control={
                              <Switch
                                checked={this.state.throughChannelPartner}
                                onChange={this.handleToggleChange}
                                name="throughChannelPartner"
                                color="primary"
                              />
                            }
                          />
                          <FormHelperText
                            id="name-error-text"
                            className="Error_msg"
                          >
                            {!this.state.isClientNameValid
                              ? 'Invalid Selection'
                              : ''}
                          </FormHelperText>
                        </FormGroup>
                      </FormControl>
                    </Grid>
                    {this.state.throughChannelPartner && (
                      <Grid item xs={12} sm={12} justify="center">
                        <label style={{ marginRight: '20px' }}>
                          Channel Partner Name *{' '}
                        </label>
                        <FormControl style={{ minWidth: '50%' }}>
                          <FormGroup className="form-input">
                            <TextField
                              variant="outlined"
                              fullWidth
                              margin="normal"
                              value={this.state.channelPartnerName}
                              onChange={this.handleChannelPartnerNameChange}
                              placeholder="Enter Channel Patner Name *"
                              name="channelPartnerName"
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isClientNameValid
                                ? 'Invalid Selection'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>
                    )}
                    <React.Fragment>
                      <Grid item xs={12} sm={12} justify="center">
                        <label style={{ marginRight: '20px' }}>
                          Zonal Manager *{' '}
                        </label>
                        <FormControl style={{ minWidth: '50%' }}>
                          <FormGroup className="form-input">
                            <SelectReact
                              options={this.state.zmDetails}
                              value={this.state.zmId}
                              onChange={this.handleChangeZM}
                              placeholder="Select Zonal Manager *"
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isClientNameValid
                                ? 'Invalid Selection'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={12} justify="center">
                        <label style={{ marginRight: '20px' }}>
                          Key Account Manager *{' '}
                        </label>
                        <FormControl style={{ minWidth: '50%' }}>
                          <FormGroup className="form-input">
                            <SelectReact
                              options={this.state.kamDetails}
                              value={this.state.kamId}
                              onChange={this.handleChangeKAM}
                              placeholder="Select Key Account Manager *"
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isClientNameValid
                                ? 'Invalid Selection'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid> */}
                    <React.Fragment>
                      <Grid item xs={12} sm={12} justify="center">
                        <label style={{ marginRight: '20px' }}>
                          Video Telematics
                        </label>
                        <FormControl
                          style={{ minWidth: '50%', marginTop: '20px' }}
                        >
                          <FormGroup className="form-input">
                            <SelectReact
                              options={this.state.videoTelematicsType}
                              value={this.state.selectedVTM}
                              disabled={!this.isAdmin()}
                              onChange={this.handleVideoTelematicsMenuChange}
                              placeholder="Select Video Telematics Type"
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isClientNameValid
                                ? 'Invalid Selection'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>

                      {/* {this.state.selectedVTM && <Grid item xs={12} sm={12} justify="center" style={{ width: '50%' }}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              className="textfield"
                              margin="dense"
                              label={`Video Telematics Id${this.state.selectedVTM?"*":""}`}
                              value={this.state.videoTelematicsId}
                              onChange={this.handleVideoTelematicsIdChange}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>} */}

                      {this.state.selectedVTM ? (
                        this.state.selectedVTM === 'mettax' ? (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            justify="center"
                            style={{ width: '50%' }}
                          >
                            {this.state.dashcamRegistrationsLoading ? (
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  padding: '20px'
                                }}
                              >
                                <CircularProgress size={40} />
                              </div>
                            ) : (
                              <React.Fragment>
                                <label style={{ marginRight: '20px' }}>
                                  Mettax VT ID *
                                </label>
                                <FormControl className="selectbox">
                                  <FormGroup>
                                    <SelectReact
                                      // show available options, and also include the
                                      // originalVtid (if present) so it appears in
                                      // edit mode even when it's not 'available'
                                      options={this.state.vtidOptions.filter(el =>
                                        el.status === 'available' ||
                                        (this.state.originalVtid && el.value == this.state.originalVtid)
                                      )}
                                      value={this.state.selectedVtid}
                                      onChange={this.handleVtidChange}
                                      placeholder="Select Video Telematics ID"
                                      className="select-input"
                                      disabled={!this.isAdmin()}
                                    />
                                  </FormGroup>
                                </FormControl>
                                {this.state.originalVtid &&
                                  !this.state.vtidOptions.some(
                                    el => el.value == this.state.originalVtid
                                  ) && (
                                    <React.Fragment>
                                      <p
                                        style={{
                                          color: 'red',
                                          fontSize: '12px',
                                          marginTop: '5px'
                                        }}
                                      >
                                        VT ID{' '}
                                        <strong>
                                          {this.state.originalVtid}
                                        </strong>{' '}
                                        is not registered in Dashcam
                                        Registration Page.
                                      </p>
                                      <TextField
                                        id="simId"
                                        className="textfield"
                                        margin="dense"
                                        label="Unregistered VT ID"
                                        type="text"
                                        disabled={!this.isAdmin()}
                                        value={this.state.originalVtid}
                                      />
                                    </React.Fragment>
                                  )}

                                {this.state.selectedVtid && (
                                  <Grid
                                    container
                                    spacing={2}
                                    style={{ marginTop: '10px' }}
                                  >
                                    <Grid item xs={6}>
                                      <FormControl className="selectbox">
                                        <FormGroup>
                                          <TextField
                                            id="simId"
                                            className="textfield"
                                            margin="dense"
                                            label="SIM ID"
                                            type="text"
                                            disabled={!this.isAdmin()}
                                            value={this.state.selectedSimId}
                                          />
                                        </FormGroup>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={6}>
                                      <FormControl className="selectbox">
                                        <FormGroup>
                                          <TextField
                                            id="memoryCardId"
                                            className="textfield"
                                            margin="dense"
                                            label="Memory Card Memory"
                                            type="text"
                                            disabled={!this.isAdmin()}
                                            value={
                                              this.state.selectedMemoryCardId
                                            }
                                          />
                                        </FormGroup>
                                      </FormControl>
                                    </Grid>
                                  </Grid>
                                )}
                              </React.Fragment>
                            )}
                          </Grid>
                        ) : (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            justify="center"
                            style={{ width: '50%' }}
                          >
                            <FormControl className="selectbox">
                              <FormGroup>
                                {this.state.dashcamRegistrationsLoading ? (
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      padding: '10px'
                                    }}
                                  >
                                    <CircularProgress size={30} />
                                  </div>
                                ) : (
                                  <TextField
                                    className="textfield"
                                    margin="dense"
                                    label={`Video Telematics Id${
                                      this.state.selectedVTM ? '*' : ''
                                    }`}
                                    value={this.state.videoTelematicsId}
                                    onChange={
                                      this.handleVideoTelematicsIdChange
                                    }
                                  />
                                )}
                              </FormGroup>
                            </FormControl>
                          </Grid>
                        )
                      ) : null}
                    </React.Fragment>

                    <FormControl
                      className="selectbox"
                      style={{ marginTop: '20px' }}
                    >
                      <FormGroup className="form-input">
                        <InputLabel
                          htmlFor="custCode"
                          style={{ marginTop: '-10px' }}
                          shrink={!!this.state.customerCode}
                        >
                          Customer Code
                        </InputLabel>
                        <TextField
                          style={{ maxWidth: '50%' }}
                          id="custCode"
                          name="custCode"
                          className="textfield"
                          margin="dense"
                          type="text"
                          value={this.state.customerCode}
                          onChange={this.handleInputChange('customerCode')}
                          InputProps={{ readOnly: !this.isAdmin() }}
                          //error={!this.state.isrcRegnDtValid}
                        />
                        {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                      </FormGroup>
                    </FormControl>

                    <FormControl
                      className="selectbox"
                      style={{ marginTop: '20px' }}
                    >
                      <FormGroup className="form-input">
                        <InputLabel
                          htmlFor="custType"
                          style={{ marginTop: '-10px' }}
                          shrink={!!this.state.customerType}
                        >
                          Customer Type
                        </InputLabel>
                        <TextField
                          style={{ maxWidth: '50%' }}
                          id="custType"
                          name="custType"
                          className="textfield"
                          margin="dense"
                          type="text"
                          value={this.state.customerType}
                          onChange={this.handleInputChange('customerType')}
                          InputProps={{ readOnly: !this.isAdmin() }}
                          //error={!this.state.isrcRegnDtValid}
                        />
                        {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                      </FormGroup>
                    </FormControl>
                  </Grid>

                  <Grid
                    container
                    fullwidth
                    style={{
                      marginTop: '20px'
                    }}
                  >
                    {/* Segment Dropdown */}
                    <Grid item xs={6} sm={6} style={{ marginTop: '2px' }}>
                      <FormControl className="selectbox">
                        <FormGroup className="form-input">
                          <label>Segment *</label>
                          <SelectReact
                            // options={this.state.segmentOptions}
                            options={
                              Array.isArray(this.state.vehiclesegment) &&
                              this.state.vehiclesegment.map(option => ({
                                label: option,
                                value: option
                              }))
                            }
                            value={this.state.vehicleSegment}
                            onChange={this.handleSegmentChange}
                            placeholder="Segment *"
                          />
                        </FormGroup>
                      </FormControl>

                      {/* <FormControl className="selectbox">
                        <FormGroup className="form-input">
                          <label>Application *</label>
                          <SelectReact
                              // options={this.state.applicationOptions}
                              options={Array.isArray(this.state.application) && this.state.application.map(option => ({
                                label: option,
                                value: option
                              }))}
                              value={this.state.selectedApplication} 
                              onChange={selectedOption =>
                                this.setState({
                                  selectedApplication: selectedOption
                                    ? selectedOption.value
                                    : ''
                                })
                              }
                              placeholder="Select Application *"
                          />
                        </FormGroup>
                      </FormControl> */}

                      {/* {this.state.vehicleSegment &&
                        this.state.vehicleSegment !== 'LMs' &&
                        this.state.vehicleSegment !== 'Passenger Vehicles' && this.state.vehicleSegment !== 'DG Set' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '16px' }}
                          >
                            <FormGroup className="form-input">
                              <label>Equipment Type/Class *</label>
                              {this.state.vehicleSegment === 'EVs' ? (
                                <TextField
                                  variant="outlined"
                                  fullWidth
                                  margin="normal"
                                  value={this.state.equipmentTypeClassText}
                                  onChange={
                                    this.handleEquipmentTypeClassTextChange
                                  }
                                  placeholder="Enter Equipment Type/Class *"
                                  name="equipmentTypeClassText"
                                />
                              ) : (
                                <SelectReact
                                  options={this.state.equipmentTypeClassOptions}
                                  value={this.state.equipmentTypeClass} // Make sure this state variable exists and is updated correctly
                                  onChange={selectedOption =>
                                    this.setState({
                                      equipmentTypeClass: selectedOption
                                        ? selectedOption.value
                                        : ''
                                    })
                                  }
                                  placeholder="Select Equipment Type/Class *"
                                />
                              )}
                            </FormGroup>
                          </FormControl>
                        )} */}

                      {/* Vehicle Wheeler Dropdown */}
                      {/* {this.state.vehicleSegment === 'Transportation' && (
                        <FormControl
                          className="selectbox"
                          style={{ marginTop: '16px' }}
                        >
                          <FormGroup className="form-input">
                            <label>Vehicle Wheeler *</label>

                            <SelectReact
                              options={this.state.vehicleWheelerOptions}
                              value={this.state.vehicleWheeler} // Make sure this state variable exists and is updated correctly
                              onChange={selectedOption =>
                                this.setState({
                                  vehicleWheeler: selectedOption
                                    ? selectedOption.value
                                    : ''
                                })
                              }
                              placeholder="Select Vehicle Wheeler *"
                            />
                          </FormGroup>
                        </FormControl>
                      )} */}

                      {/* Application Dropdown */}
                      {/* {this.state.vehicleSegment === 'Transportation' && (
                        <FormControl
                          className="selectbox"
                          style={{ marginTop: '16px' }}
                        >
                          <FormGroup className="form-input">
                            <label>Application *</label>

                            <SelectReact
                              options={this.state.applicationOptions}
                              value={this.state.application} // Make sure this state variable exists and is updated correctly
                              onChange={selectedOption =>
                                this.setState({
                                  application: selectedOption
                                    ? selectedOption.value
                                    : ''
                                })
                              }
                              placeholder="Select Application *"
                            />
                          </FormGroup>
                        </FormControl>
                      )} */}

                      {this.state.vehicleSegment === 'Transportation' && (
                        <FormControl
                          className="selectbox"
                          style={{ marginTop: '16px' }}
                        >
                          <FormGroup className="form-input">
                            <label>Transportation Vehicle Type *</label>

                            <SelectReact
                              // options={this.state.constructionVehicleTypeOptions}
                              options={
                                Array.isArray(
                                  this.state.transportationvehicletype
                                ) &&
                                this.state.transportationvehicletype.map(
                                  option => ({
                                    label: option,
                                    value: option
                                  })
                                )
                              }
                              value={this.state.transportationVehicleType}
                              onChange={selectedOption =>
                                this.setState({
                                  transportationVehicleType: selectedOption
                                    ? selectedOption.value
                                    : ''
                                })
                              }
                              placeholder="Select Transportation Vehicle Type *"
                            />
                          </FormGroup>
                        </FormControl>
                      )}

                      {this.state.vehicleSegment === 'Transportation' && (
                        <FormControl
                          className="selectbox"
                          style={{ marginTop: '16px' }}
                        >
                          <FormGroup className="form-input">
                            <label>Application *</label>

                            <SelectReact
                              // options={this.state.applicationOptions}
                              options={
                                Array.isArray(this.state.application) &&
                                this.state.application.map(option => ({
                                  label: option,
                                  value: option
                                }))
                              }
                              value={this.state.selectedApplication}
                              onChange={selectedOption =>
                                this.setState({
                                  selectedApplication: selectedOption
                                    ? selectedOption.value
                                    : ''
                                })
                              }
                              placeholder="Select Application *"
                            />
                          </FormGroup>
                        </FormControl>
                      )}

                      {/* Haulage Type Dropdown */}

                      {this.state.vehicleSegment === 'Transportation' && (
                        <FormControl
                          className="selectbox"
                          style={{ marginTop: '16px' }}
                        >
                          <FormGroup className="form-input">
                            <label>Haulage Type *</label>

                            <SelectReact
                              // options={this.state.haulageTypeOptions}
                              options={
                                Array.isArray(this.state.haulagetype) &&
                                this.state.haulagetype.map(option => ({
                                  label: option,
                                  value: option
                                }))
                              }
                              value={this.state.haulageType}
                              onChange={selectedOption =>
                                this.setState({
                                  haulageType: selectedOption
                                    ? selectedOption.value
                                    : ''
                                })
                              }
                              placeholder="Select Haulage Type *"
                            />
                          </FormGroup>
                        </FormControl>
                      )}

                      {/* Construction Vehicle Type Dropdown */}
                      {this.state.vehicleSegment === 'Construction' && (
                        <FormControl
                          className="selectbox"
                          style={{ marginTop: '16px' }}
                        >
                          <FormGroup className="form-input">
                            <label>Construction Vehicle Type *</label>

                            <SelectReact
                              // options={this.state.constructionVehicleTypeOptions}
                              options={
                                Array.isArray(
                                  this.state.constructionvehicletype
                                ) &&
                                this.state.constructionvehicletype.map(
                                  option => ({
                                    label: option,
                                    value: option
                                  })
                                )
                              }
                              value={this.state.constructionVehicleType}
                              onChange={selectedOption =>
                                this.setState({
                                  constructionVehicleType: selectedOption
                                    ? selectedOption.value
                                    : ''
                                })
                              }
                              placeholder="Select Construction Vehicle Type *"
                            />
                          </FormGroup>
                        </FormControl>
                      )}

                      {this.state.vehicleSegment === 'Construction' &&
                        this.state.constructionVehicleType === 'Tensioner' && (
                          <TensionerRotationSensorReminder />
                        )}


                      {this.state.vehicleSegment === 'Construction' &&
                        this.state.constructionVehicleType === 'Tensioner' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '16px' }}
                          >
                            <FormGroup className="form-input">
                              <label>Conductor Length (in km) *</label>
                              <Input
                                type="number"
                                placeholder="Conductor Length (in m)"
                                value={this.state.tensionerConductorLength}
                                onChange={e => {
                                  this.setState({
                                    tensionerConductorLength:
                                      Number(e.target.value) < 0
                                        ? 0
                                        : Number(e.target.value)
                                  })
                                }}
                              />
                            </FormGroup>
                          </FormControl>
                        )}

                      {this.state.vehicleSegment === 'Construction' &&
                        this.state.constructionVehicleType === 'Tensioner' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '16px' }}
                          >
                            <FormGroup className="form-input">
                              <label>Rotation Sensor Direction *</label>
                              <SelectReact
                                options={[
                                  { value: 'clockwise', label: 'Clockwise' },
                                  {
                                    value: 'anticlockwise',
                                    label: 'Anticlockwise'
                                  }
                                ]}
                                value={
                                  this.state.tensionerRotationSensorDirection
                                    ? {
                                      value:
                                        this.state
                                          .tensionerRotationSensorDirection,
                                      label:
                                        this.state
                                          .tensionerRotationSensorDirection ===
                                          'clockwise'
                                          ? 'Clockwise'
                                          : 'Anticlockwise'
                                    }
                                    : null
                                }
                                onChange={selectedOption =>
                                  this.setState({
                                    tensionerRotationSensorDirection:
                                      selectedOption
                                        ? selectedOption.value
                                        : ''
                                  })
                                }
                                placeholder="Select Rotation Sensor Direction *"
                              />
                            </FormGroup>
                          </FormControl>
                        )}


                      {this.state.vehicleSegment === 'Passenger' && (
                        <FormControl
                          className="selectbox"
                          style={{ marginTop: '16px' }}
                        >
                          <FormGroup className="form-input">
                            <label>Passenger Vehicle Type *</label>

                            <SelectReact
                              // options={this.state.constructionVehicleTypeOptions}
                              options={
                                Array.isArray(
                                  this.state.passengervehicletype
                                ) &&
                                this.state.passengervehicletype.map(option => ({
                                  label: option,
                                  value: option
                                }))
                              }
                              value={this.state.passengerVehicleType}
                              onChange={selectedOption =>
                                this.setState({
                                  passengerVehicleType: selectedOption
                                    ? selectedOption.value
                                    : ''
                                })
                              }
                              placeholder="Select Passenger Vehicle Type *"
                            />
                          </FormGroup>
                        </FormControl>
                      )}

                      {this.state.vehicleSegment !== 'DG Set' && (
                        <FormControlLabel
                          style={{ marginTop: '20px' }}
                          label="Vehicle Registration Number Available"
                          control={
                            <Checkbox
                              checked={
                                this.state
                                  .vehicleRegistrationNumberAvailableStatus
                              }
                              onChange={this.handleVehicleRegistrationNumberAvailableChange(
                                'vehicleRegistrationNumberAvailableStatus'
                              )}
                              value="vehicleRegistrationNumberAvailableStatus"
                              color="primary"
                            />
                          }
                        />
                      )}
                    </Grid>
                  </Grid>

                  {this.state.vehicleSegment !== 'DG Set' &&
                    this.state.vehicleRegistrationNumberAvailableStatus &&
                    (this.state.loading ? (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: '100px'
                        }}
                      >
                        <CircularProgress />
                      </div>
                    ) : (
                      <Grid item xs={12} sm={12} justify="center">
                        <label style={{ marginRight: '20px' }}>
                          Vehicle Registration Number *{' '}
                        </label>
                        <FormControl style={{ minWidth: '19.5%' }}>
                          {/* <FormGroup className="form-input"> */}
                          <TextField
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={this.state.enteredVehicleRegistrationNumber}
                            // onChange={
                            //   this.checkVlpnValidity
                            // }
                            placeholder="Enter Vehicle Registration Number *"
                            name="enteredVehicleRegistrationNumber"
                            onChange={event =>
                              this.setState({
                                enteredVehicleRegistrationNumber:
                                  event.target.value
                              })
                            }
                          />
                          {/* <FormHelperText
                                    id="name-error-text"
                                    className="Error_msg"
                                  >
                                    {!this.state.isClientNameValid
                                      ? 'Invalid Selection'
                                      : ''}
                                  </FormHelperText> */}
                          {/* </FormGroup> */}
                        </FormControl>
                        <Button
                          color="default"
                          variant="outlined"
                          size="medium"
                          margin="normal"
                          className="btn"
                          onClick={this.getDataByVehicleNumber}
                        >
                          Get Data
                        </Button>
                        {this.state.vlpnres && (
                          <FormHelperText className="Error_msg">
                            {this.state.vlpnres}
                          </FormHelperText>
                        )}
                      </Grid>
                    ))}

                  <Grid container fullwidth>
                    <FormControl
                      className="selectbox"
                      style={{ marginTop: '10px' }}
                    >
                      <FormGroup className="form-input">
                        <InputLabel
                          htmlFor="vehicleNickName"
                          style={{ marginTop: '-10px' }}
                          shrink={
                            this.state.vehicleNickName ||
                            (this.state.vehicleData &&
                              this.state.vehicleData.rcRegnNo) ||
                            this.state.rcRegnNo ||
                            this.state.vehicleRegistrationNumber ||
                            this.state.vlpn
                          }
                        >
                          Vehicle Name/Number to be displayed on vehicle card
                          (ex. Hyva Truck 08)
                        </InputLabel>
                        <TextField
                          id="vehicleNickName"
                          name="vehicleNickName"
                          className="textfield"
                          margin="dense"
                          type="text"
                          value={
                            this.state.vehicleNickName ||
                            (this.state.vehicleData &&
                              this.state.vehicleData.rcRegnNo) ||
                            this.state.rcRegnNo ||
                            this.state.vehicleRegistrationNumber ||
                            this.state.vlpn
                          }
                          onChange={this.handleInputChange('vehicleNickName')}
                        />
                      </FormGroup>
                    </FormControl>
                  </Grid>

                  <Grid
                    container
                    fullwidth
                    style={{
                      marginTop: '20px'
                    }}
                  >
                    <Grid xs={6} sm={6}>
                      <h3>
                        {this.state.vehicleSegment == 'DG Set'
                          ? 'Vehicle/DG Info'
                          : 'Vehicle Info'}
                      </h3>
                    </Grid>
                    <Grid xs={6} sm={6}>
                      <h3>Device and SIM Info</h3>
                    </Grid>
                    <Grid item xs={6} sm={6}>
                      <FormControl className="selectbox">
                        <FormGroup className="form-input">
                            <TextField
                            id="vlpn"
                            name="vlpn"
                            className="textfield"
                            margin="dense"
                            disabled={!this.isAdmin()}
                            label={
                              this.state.vehicleSegment == 'DG Set'
                                ? 'Vehicle/Asset Number'
                                : 'Vehicle Number'
                            }
                            // type="Multi-line"
                            value={
                              (this.state.vehicleData &&
                                this.state.vehicleData.rcRegnNo) ||
                              this.state.vlpn
                            }
                            required
                            onChange={this.handleInputChange('vlpn')}
                            error={!this.state.isVlpnValid}
                            onBlur={this.checkVlpnValidity(this.props.client)}
                          />

                          <FormHelperText
                            id="name-error-text"
                            className="Error_msg"
                          >
                            {!this.state.isVlpnValid ? this.state.vlpnres : ''}
                          </FormHelperText>
                        </FormGroup>
                      </FormControl>

                      {/* {this.state.vehicleSegment != 'DG Set' && <Grid xs={12} sm={12} mt={4}>
                        <FormControlLabel
                          control={
                            <Switch
                              value={this.state.isDualEngine}
                              checked={this.state.isDualEngine}
                              onChange={this.handleInputChange('isDualEngine')}
                              name="dualEngineToggle"
                              color="primary"
                            />
                          }
                          label="Dual Engine"
                        />
                       {this.state.deviceType&& this.state.deviceType!="obd"&&
                        <FormControlLabel
                        control={
                          <Switch
                            value={this.state.duplicateVehicle}
                            checked={this.state.duplicateVehicle}
                            onChange={this.handleInputChange('duplicateVehicle')}
                            name="duplicateVehicleToggle"
                            color="primary"
                            disabled={this.state.isDuplicatedDBValue}
                          />
                        }
                        label="Duplicate Vehicle"
                      />
                         } 
                      </Grid>}

                      {this.state.vehicleSegment != 'DG Set' && <Grid xs={12} sm={12} mt={4}>
                        <FormControlLabel
                          control={
                            <Switch
                              value={this.state.hasArm}
                              checked={this.state.hasArm}
                              onChange={this.handleInputChange('hasArm')}
                              name="armToggle"
                              color="primary"
                            />
                          }
                          label="Arm Included?"
                        />
                      </Grid>} */}

                      <div
                        style={{
                          backgroundColor: '#f2f2f2',
                          padding: '10px',
                          borderRadius: '5px'
                        }}
                      >
                        <h4>Auto Fill Entry Section</h4>

                        {this.state.vehicleSegment != 'DG Set' && (
                          <Grid xs={12} sm={12} mt={4}>
                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '10px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcRegnNo"
                                  
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcRegnNo ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcRegnNo) ||
                                    this.state.vehicleRegistrationNumber ||
                                    this.state.vlpn
                                  }
                                >
                                  Vehicle Registration Number *
                                </InputLabel>
                                <TextField
                                  id="rcRegnNo"
                                  name="rcRegnNo"
                                  disabled={!this.isAdmin()}
                                  className="textfield"
                                  margin="dense"
                                  //label={"Vehicle Registration Number"}
                                  type="text"
                                  // type="Multi-line"
                                  // value={this.state.rcRegnNo}
                                  // value={this.state.vehicleData ? this.state.vehicleData.rcRegnNo : this.state.vehicleRegistrationNumber || this.state.vlpn}
                                  value={
                                    this.state.rcRegnNo ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcRegnNo) ||
                                    this.state.vehicleRegistrationNumber ||
                                    this.state.vlpn
                                  }
                                  required
                                  onChange={this.handleInputChange('rcRegnNo')}
                                  // onChange={this.handleInputChange('vlpn')}
                                  // error={!this.state.isVlpnValid}
                                  // onBlur={this.checkVlpnValidity(this.props.client)}
                                />

                                {/* <FormHelperText
                            id="name-error-text"
                            className="Error_msg"
                          >
                            {!this.state.isVlpnValid ? this.state.vlpnres : ''}
                          </FormHelperText> */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcRegnDt"
                                  style={{ marginTop: '-10px' }}
                                  // shrink={((this.state.vehicleData && this.state.vehicleData.rcRegnDt)|| this.state.rcRegnDt)}
                                  shrink={
                                    this.state.rcRegnDt ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcRegnDt) ||
                                    this.state.registrationDate ||
                                    ''
                                  }
                                >
                                  Registration Date
                                </InputLabel>
                                <TextField
                                  id="rcRegnDt"
                                  name="rcRegnDt"
                                  className="textfield"
                                  margin="dense"
                                  //label="Registration Date"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcRegnDt ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcRegnDt) ||
                                    this.state.registrationDate ||
                                    ''
                                  }
                                  // value={(this.state.vehicleData && this.state.vehicleData.rcRegnDt) || ''}
                                  onChange={this.handleInputChange('rcRegnDt')}
                                  //error={!this.state.isrcRegnDtValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcRegnUpto"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcRegnUpto ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcRegnUpto) ||
                                    this.state.registrationValidUpto ||
                                    ''
                                  }
                                >
                                  Registration Valid Upto
                                </InputLabel>
                                <TextField
                                  id="rcRegnUpto"
                                  name="rcRegnUpto"
                                  className="textfield"
                                  margin="dense"
                                  //label="Registration Valid Upto"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcRegnUpto ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcRegnUpto) ||
                                    this.state.registrationValidUpto ||
                                    ''
                                  }
                                  onChange={this.handleInputChange(
                                    'rcRegnUpto'
                                  )}
                                  //error={!this.state.isrcRegnUptoValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  Maximum length is 90 characters.
                                </FormHelperText>
                              )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="stateCd"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.stateCd ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.stateCd) ||
                                    this.state.stateCode ||
                                    ''
                                  }
                                >
                                  State Code
                                </InputLabel>
                                <TextField
                                  id="stateCd"
                                  name="stateCd"
                                  className="textfield"
                                  margin="dense"
                                  //label="State Code"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.stateCd ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.stateCd) ||
                                    this.state.stateCode ||
                                    ''
                                  }
                                  onChange={this.handleInputChange('stateCd')}
                                  //error={!this.state.isstateCdValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rtoCd"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rtoCd ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rtoCd) ||
                                    this.state.rtoCode ||
                                    ''
                                  }
                                >
                                  RTO Code
                                </InputLabel>
                                <TextField
                                  id="rtoCd"
                                  name="rtoCd"
                                  className="textfield"
                                  margin="dense"
                                  //label="RTO Code"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rtoCd ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rtoCd) ||
                                    this.state.rtoCode ||
                                    ''
                                  }
                                  onChange={this.handleInputChange('rtoCd')}
                                  //error={!this.state.isrtoCdValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcVchCatg"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcVchCatg ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcVchCatg) ||
                                    this.state.vehicleCategoryCode ||
                                    ''
                                  }
                                >
                                  Vehicle Category Code
                                </InputLabel>
                                <TextField
                                  id="rcVchCatg"
                                  name="rcVchCatg"
                                  className="textfield"
                                  margin="dense"
                                  //label="Vehicle Category Code"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcVchCatg ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcVchCatg) ||
                                    this.state.vehicleCategoryCode ||
                                    ''
                                  }
                                  onChange={this.handleInputChange('rcVchCatg')}
                                  //error={!this.state.isrcVchCatgValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcVhClassDesc"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcVhClassDesc ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcVhClassDesc) ||
                                    this.state.vehicleClassDescription ||
                                    ''
                                  }
                                >
                                  Vehicle Class Description
                                </InputLabel>
                                <TextField
                                  id="rcVhClassDesc"
                                  name="rcVhClassDesc"
                                  className="textfield"
                                  margin="dense"
                                  //label="Vehicle Class Description"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcVhClassDesc ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcVhClassDesc) ||
                                    this.state.vehicleClassDescription ||
                                    ''
                                  }
                                  onChange={this.handleInputChange(
                                    'rcVhClassDesc'
                                  )}
                                  //error={!this.state.isrcVhClassDescValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcChasiNo"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcChasiNo ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcChasiNo) ||
                                    this.state.chassisNumber ||
                                    ''
                                  }
                                >
                                  Chassis Number
                                </InputLabel>
                                <TextField
                                  id="rcChasiNo"
                                  name="rcChasiNo"
                                  className="textfield"
                                  margin="dense"
                                  //label="Chassis Number"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcChasiNo ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcChasiNo) ||
                                    this.state.chassisNumber ||
                                    ''
                                  }
                                  onChange={this.handleInputChange('rcChasiNo')}
                                  //error={!this.state.isrcChasiNoValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcEngNo"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcEngNo ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcEngNo) ||
                                    this.state.engineNumber ||
                                    ''
                                  }
                                >
                                  Engine Number
                                </InputLabel>
                                <TextField
                                  id="rcEngNo"
                                  name="rcEngNo"
                                  className="textfield"
                                  margin="dense"
                                  //label="Engine Number"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcEngNo ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcEngNo) ||
                                    this.state.engineNumber ||
                                    ''
                                  }
                                  onChange={this.handleInputChange('rcEngNo')}
                                  //error={!this.state.isrcEngNoValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcMakerDesc"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcMakerDesc ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcMakerDesc) ||
                                    this.state.makerDescription ||
                                    ''
                                  }
                                >
                                  Maker Description *
                                </InputLabel>
                                <TextField
                                  id="rcMakerDesc"
                                  name="rcMakerDesc"
                                  className="textfield"
                                  margin="dense"
                                  //label="Maker Description"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcMakerDesc ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcMakerDesc) ||
                                    this.state.makerDescription ||
                                    ''
                                  }
                                  onChange={this.handleInputChange(
                                    'rcMakerDesc'
                                  )}
                                  //error={!this.state.isrcMakerDescValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcMakerModel"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcMakerModel ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcMakerModel) ||
                                    this.state.makerModel ||
                                    ''
                                  }
                                >
                                  Maker Model *
                                </InputLabel>
                                <TextField
                                  id="rcMakerModel"
                                  name="rcMakerModel"
                                  className="textfield"
                                  margin="dense"
                                  //label="Maker Model"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcMakerModel ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcMakerModel) ||
                                    this.state.makerModel ||
                                    ''
                                  }
                                  onChange={this.handleInputChange(
                                    'rcMakerModel'
                                  )}
                                  //error={!this.state.isrcMakerModelValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcBodyTypeDesc"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcBodyTypeDesc ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcBodyTypeDesc) ||
                                    this.state.bodyTypeDescription ||
                                    ''
                                  }
                                >
                                  Body Type Description
                                </InputLabel>
                                <TextField
                                  id="rcBodyTypeDesc"
                                  name="rcBodyTypeDesc"
                                  className="textfield"
                                  margin="dense"
                                  //label="Body Type Description"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcBodyTypeDesc ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcBodyTypeDesc) ||
                                    this.state.bodyTypeDescription ||
                                    ''
                                  }
                                  onChange={this.handleInputChange(
                                    'rcBodyTypeDesc'
                                  )}
                                  //error={!this.state.isrcBodyTypeDescValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <Grid
                              xs={12}
                              sm={12}
                              mt={4}
                              style={{ marginTop: '20px' }}
                            >
                              Fuel Type
                            </Grid>
                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '5px' }}
                            >
                              <FormGroup className="form-input">
                                {/* <InputLabel 
                              htmlFor="rcFuelDesc" 
                              style={{ marginTop: '-20px' }} 
                              shrink={!!((this.state.vehicleData && this.state.vehicleData.rcFuelDesc)|| this.state.rcFuelDesc)}>
                                Fuel Type
                            </InputLabel> */}
                                {this.state.vehicleSegment !== 'DG Set' && (
                                  <SelectReact
                                    id="rcFuelDesc"
                                    name="rcFuelDesc"
                                    classes={classes}
                                    options={[
                                      { value: 'petrol', label: 'PETROL' },
                                      { value: 'diesel', label: 'DIESEL' },
                                      { value: 'ev', label: 'EV' },
                                      { value: 'cng', label: 'CNG' },
                                      { value: 'lng', label: 'LNG' }
                                    ]}
                                    // components={components}
                                    // value={this.state.rcFuelDesc}
                                    value={
                                      this.state.rcFuelDesc ||
                                      (this.state.vehicleData &&
                                      this.state.vehicleData.rcFuelDesc
                                        ? (
                                            this.state.vehicleData &&
                                            this.state.vehicleData.rcFuelDesc
                                          ).toLowerCase()
                                        : null) ||
                                      this.state.fuelType ||
                                      ''
                                    }
                                    onChange={selectedOption => {
                                      this.setState({
                                        rcFuelDesc: selectedOption
                                          ? selectedOption.value
                                          : ''
                                      })
                                    }}
                                    placeholder="Fuel Type"
                                    //disabled={this.state.fuelTypeFromApi}
                                  />
                                )}
                                {this.state.vehicleSegment === 'DG Set' && (
                                  <SelectReact
                                    id="rcFuelDesc"
                                    name="rcFuelDesc"
                                    classes={classes}
                                    options={[
                                      { value: 'petrol', label: 'PETROL' },
                                      { value: 'diesel', label: 'DIESEL' }
                                    ]}
                                    // components={components}
                                    //value={this.state.fuelType}
                                    value={
                                      this.state.rcFuelDesc ||
                                      (this.state.vehicleData &&
                                        this.state.vehicleData.rcFuelDesc) ||
                                      this.state.fuelType ||
                                      ''
                                    }
                                    onChange={selectedOption => {
                                      this.setState({
                                        rcFuelDesc: selectedOption
                                          ? selectedOption.value
                                          : ''
                                      })
                                    }}
                                    placeholder="Fuel Type"
                                    //disabled={this.state.fuelTypeFromApi}
                                  />
                                )}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcNormsDesc"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcNormsDesc ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcNormsDesc) ||
                                    this.state.emissionNormsDescription ||
                                    ''
                                  }
                                >
                                  Emission Norms Description
                                </InputLabel>
                                <TextField
                                  id="rcNormsDesc"
                                  name="rcNormsDesc"
                                  className="textfield"
                                  margin="dense"
                                  //label="Emission Norms Description"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcNormsDesc ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcNormsDesc) ||
                                    this.state.emissionNormsDescription ||
                                    ''
                                  }
                                  onChange={this.handleInputChange(
                                    'rcNormsDesc'
                                  )}
                                  //error={!this.state.isrcNormsDescValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcFitUpto"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcFitUpto ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcFitUpto) ||
                                    this.state.fitmentUpto ||
                                    ''
                                  }
                                >
                                  Fitment Upto
                                </InputLabel>
                                <TextField
                                  id="rcFitUpto"
                                  name="rcFitUpto"
                                  className="textfield"
                                  margin="dense"
                                  //label="Fitment Upto"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcFitUpto ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcFitUpto) ||
                                    this.state.fitmentUpto ||
                                    ''
                                  }
                                  onChange={this.handleInputChange('rcFitUpto')}
                                  //error={!this.state.isrcFitUptoValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcNpUpto"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcNpUpto ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcNpUpto) ||
                                    this.state.nationalPermitUpto ||
                                    ''
                                  }
                                >
                                  National Permit Upto
                                </InputLabel>
                                <TextField
                                  id="rcNpUpto"
                                  name="rcNpUpto"
                                  className="textfield"
                                  margin="dense"
                                  //label="National Permit Upto"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcNpUpto ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcNpUpto) ||
                                    this.state.nationalPermitUpto ||
                                    ''
                                  }
                                  onChange={this.handleInputChange('rcNpUpto')}
                                  //error={!this.state.isrcNpUptoValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcTaxUpto"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcTaxUpto ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcTaxUpto) ||
                                    this.state.taxUpto ||
                                    ''
                                  }
                                >
                                  Tax Upto
                                </InputLabel>
                                <TextField
                                  id="rcTaxUpto"
                                  name="rcTaxUpto"
                                  className="textfield"
                                  margin="dense"
                                  //label="Tax Upto"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcTaxUpto ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcTaxUpto) ||
                                    this.state.taxUpto ||
                                    ''
                                  }
                                  onChange={this.handleInputChange('rcTaxUpto')}
                                  //error={!this.state.isrcTaxUptoValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcInsuranceComp"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcInsuranceComp ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcInsuranceComp) ||
                                    this.state.insurerName ||
                                    ''
                                  }
                                >
                                  Insurer Name
                                </InputLabel>
                                <TextField
                                  id="rcInsuranceComp"
                                  name="rcInsuranceComp"
                                  className="textfield"
                                  margin="dense"
                                  //label="Insurer Name"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcInsuranceComp ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcInsuranceComp) ||
                                    this.state.insurerName ||
                                    ''
                                  }
                                  onChange={this.handleInputChange(
                                    'rcInsuranceComp'
                                  )}
                                  //error={!this.state.isrcInsuranceCompValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcInsuranceUpto"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcInsuranceComp ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcInsuranceComp) ||
                                    this.state.insuranceUpto ||
                                    ''
                                  }
                                >
                                  Insurer Upto
                                </InputLabel>
                                <TextField
                                  id="rcInsuranceUpto"
                                  name="rcInsuranceUpto"
                                  className="textfield"
                                  margin="dense"
                                  //label="Insurance Upto"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcInsuranceComp ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcInsuranceComp) ||
                                    this.state.insuranceUpto ||
                                    ''
                                  }
                                  onChange={this.handleInputChange(
                                    'rcInsuranceUpto'
                                  )}
                                  //error={!this.state.isrcInsuranceUptoValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcManuMonthYr"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcManuMonthYr ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcManuMonthYr) ||
                                    this.state.manufacturingMonthYear ||
                                    ''
                                  }
                                >
                                  Manufacturing Month/Year
                                </InputLabel>
                                <TextField
                                  id="rcManuMonthYr"
                                  name="rcManuMonthYr"
                                  className="textfield"
                                  margin="dense"
                                  //label="Manufacturing Month/Year"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcManuMonthYr ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcManuMonthYr) ||
                                    this.state.manufacturingMonthYear ||
                                    ''
                                  }
                                  onChange={this.handleInputChange(
                                    'rcManuMonthYr'
                                  )}
                                  //error={!this.state.isrcManuMonthYrValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcUnldWt"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcUnldWt ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcUnldWt) ||
                                    this.state.unladenWeight ||
                                    ''
                                  }
                                >
                                  Unladen Weight
                                </InputLabel>
                                <TextField
                                  id="rcUnldWt"
                                  name="rcUnldWt"
                                  className="textfield"
                                  margin="dense"
                                  //label="Unladen Weight"
                                  type="number"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcUnldWt ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcUnldWt) ||
                                    this.state.unladenWeight ||
                                    ''
                                  }
                                  onChange={this.handleInputChange('rcUnldWt')}
                                  //error={!this.state.isrcUnldWtValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcGvw"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcGvw ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcGvw) ||
                                    this.state.grossVehicleWeight ||
                                    ''
                                  }
                                >
                                  Gross Vehicle Weight (GVW)
                                </InputLabel>
                                <TextField
                                  id="rcGvw"
                                  name="rcGvw"
                                  className="textfield"
                                  margin="dense"
                                  //label="Gross Vehicle Weight (GVW)"
                                  //type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcGvw ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcGvw) ||
                                    this.state.grossVehicleWeight ||
                                    ''
                                  }
                                  onChange={this.handleInputChange('rcGvw')}
                                  type="number"
                                  inputProps={{ step: '0.01' }}
                                  //error={!this.state.isrcGvwValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcRegisteredAt"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcRegisteredAt ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcRegisteredAt) ||
                                    this.state.registeredAt ||
                                    ''
                                  }
                                >
                                  Registered At
                                </InputLabel>
                                <TextField
                                  id="rcRegisteredAt"
                                  name="rcRegisteredAt"
                                  className="textfield"
                                  margin="dense"
                                  //label="Registered At"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcRegisteredAt ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcRegisteredAt) ||
                                    this.state.registeredAt ||
                                    ''
                                  }
                                  onChange={this.handleInputChange(
                                    'rcRegisteredAt'
                                  )}
                                  //error={!this.state.isrcRegisteredAtValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcPuccUpto"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcPuccUpto ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcPuccUpto) ||
                                    this.state.puccUpto ||
                                    ''
                                  }
                                >
                                  Pollution Under Control Certificate (PUCC)
                                  Upto
                                </InputLabel>
                                <TextField
                                  id="rcPuccUpto"
                                  name="rcPuccUpto"
                                  className="textfield"
                                  margin="dense"
                                  //label="Pollution Under Control Certificate (PUCC) Upto"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcPuccUpto ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcPuccUpto) ||
                                    this.state.puccUpto ||
                                    ''
                                  }
                                  onChange={this.handleInputChange(
                                    'rcPuccUpto'
                                  )}
                                  //error={!this.state.isrcPuccUptoValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcPermitNo"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcPermitNo ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcPermitNo) ||
                                    this.state.permitNumber ||
                                    ''
                                  }
                                >
                                  Permit Number
                                </InputLabel>
                                <TextField
                                  id="rcPermitNo"
                                  name="rcPermitNo"
                                  className="textfield"
                                  margin="dense"
                                  //label="Permit Number"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcPermitNo ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcPermitNo) ||
                                    this.state.permitNumber ||
                                    ''
                                  }
                                  onChange={this.handleInputChange(
                                    'rcPermitNo'
                                  )}
                                  //error={!this.state.isrcPermitNoValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcPermitIssueDt"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcPermitIssueDt ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcPermitIssueDt) ||
                                    this.state.permitIssueDate ||
                                    ''
                                  }
                                >
                                  Permit Issue Date
                                </InputLabel>
                                <TextField
                                  id="rcPermitIssueDt"
                                  name="rcPermitIssueDt"
                                  className="textfield"
                                  margin="dense"
                                  //label="Permit Issue Date"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcPermitIssueDt ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcPermitIssueDt) ||
                                    this.state.permitIssueDate ||
                                    ''
                                  }
                                  onChange={this.handleInputChange(
                                    'rcPermitIssueDt'
                                  )}
                                  //error={!this.state.isrcPermitIssueDtValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcPermitValidFrom"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcPermitValidFrom ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData
                                        .rcPermitValidFrom) ||
                                    this.state.permitValidFrom ||
                                    ''
                                  }
                                >
                                  Permit Valid From
                                </InputLabel>
                                <TextField
                                  id="rcPermitValidFrom"
                                  name="rcPermitValidFrom"
                                  className="textfield"
                                  margin="dense"
                                  //label="Permit Valid From"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcPermitValidFrom ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData
                                        .rcPermitValidFrom) ||
                                    this.state.permitValidFrom ||
                                    ''
                                  }
                                  onChange={this.handleInputChange(
                                    'rcPermitValidFrom'
                                  )}
                                  //error={!this.state.isrcPermitValidFromValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcPermitValidUpto"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcPermitValidUpto ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData
                                        .rcPermitValidUpto) ||
                                    this.state.permitValidUpto ||
                                    ''
                                  }
                                >
                                  Permit Valid Upto
                                </InputLabel>
                                <TextField
                                  id="rcPermitValidUpto"
                                  name="rcPermitValidUpto"
                                  className="textfield"
                                  margin="dense"
                                  //label="Permit Valid Upto"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcPermitValidUpto ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData
                                        .rcPermitValidUpto) ||
                                    this.state.permitValidUpto ||
                                    ''
                                  }
                                  onChange={this.handleInputChange(
                                    'rcPermitValidUpto'
                                  )}
                                  //error={!this.state.isrcPermitValidUptoValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcPermitType"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcPermitType ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcPermitType) ||
                                    this.state.permitType ||
                                    ''
                                  }
                                >
                                  Permit Type
                                </InputLabel>
                                <TextField
                                  id="rcPermitType"
                                  name="rcPermitType"
                                  className="textfield"
                                  margin="dense"
                                  //label="Permit Type"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcPermitType ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcPermitType) ||
                                    this.state.permitType ||
                                    ''
                                  }
                                  onChange={this.handleInputChange(
                                    'rcPermitType'
                                  )}
                                  //error={!this.state.isrcPermitTypeValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcPermitCode"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcPermitCode ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcPermitCode) ||
                                    this.state.permitCode ||
                                    ''
                                  }
                                >
                                  Permit Code
                                </InputLabel>
                                <TextField
                                  id="rcPermitCode"
                                  name="rcPermitCode"
                                  className="textfield"
                                  margin="dense"
                                  //label="Permit Code"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcPermitCode ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcPermitCode) ||
                                    this.state.permitCode ||
                                    ''
                                  }
                                  onChange={this.handleInputChange(
                                    'rcPermitCode'
                                  )}
                                  //error={!this.state.isrcPermitCodeValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcNoOfAxle"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcNoOfAxle ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcNoOfAxle) ||
                                    this.state.numberOfAxles ||
                                    ''
                                  }
                                >
                                  Number of Axles
                                </InputLabel>
                                <TextField
                                  id="rcNoOfAxle"
                                  name="rcNoOfAxle"
                                  className="textfield"
                                  margin="dense"
                                  //label="Number of Axles"
                                  type="number"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcNoOfAxle ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcNoOfAxle) ||
                                    this.state.numberOfAxles ||
                                    ''
                                  }
                                  onChange={this.handleInputChange(
                                    'rcNoOfAxle'
                                  )}
                                  //error={!this.state.isrcNoOfAxleValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcFuelCd"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcFuelCd ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcFuelCd) ||
                                    this.state.fuelCode ||
                                    ''
                                  }
                                >
                                  Fuel Code
                                </InputLabel>
                                <TextField
                                  id="rcFuelCd"
                                  name="rcFuelCd"
                                  className="textfield"
                                  margin="dense"
                                  //label="Fuel Code"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcFuelCd ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcFuelCd) ||
                                    this.state.fuelCode ||
                                    ''
                                  }
                                  onChange={this.handleInputChange('rcFuelCd')}
                                  //error={!this.state.isrcFuelCdValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcVhType"
                                  style={{ marginTop: '-10px' }}
                                  shrink={(() => {
                                    const {
                                      vehicleSegment,
                                      transportationVehicleType,
                                      constructionVehicleType,
                                      passengerVehicleType,
                                      vehicleData,
                                      rcVhType,
                                      vehicleType
                                    } = this.state

                                    if (vehicleSegment === 'Transportation')
                                      return !!transportationVehicleType
                                    if (vehicleSegment === 'Construction')
                                      return !!constructionVehicleType
                                    if (vehicleSegment === 'Passenger')
                                      return !!passengerVehicleType

                                    return !!(
                                      vehicleSegment ||
                                      rcVhType ||
                                      (vehicleData && vehicleData.rcVhType) ||
                                      vehicleType
                                    )
                                  })()}
                                >
                                  Vehicle Type
                                </InputLabel>
                                <TextField
                                  id="rcVhType"
                                  name="rcVhType"
                                  className="textfield"
                                  margin="dense"
                                  //label="Vehicle Type"
                                  type="text"
                                  // type="Multi-line"
                                  value={(() => {
                                    const {
                                      vehicleSegment,
                                      transportationVehicleType,
                                      constructionVehicleType,
                                      passengerVehicleType,
                                      vehicleData,
                                      rcVhType,
                                      vehicleType
                                    } = this.state

                                    if (vehicleSegment === 'Transportation')
                                      return transportationVehicleType || ''
                                    if (vehicleSegment === 'Construction')
                                      return constructionVehicleType || ''
                                    if (vehicleSegment === 'Passenger')
                                      return passengerVehicleType || ''

                                    return (
                                      vehicleSegment ||
                                      rcVhType ||
                                      (vehicleData && vehicleData.rcVhType) ||
                                      vehicleType
                                    )
                                  })()}
                                  onChange={this.handleInputChange('rcVhType')}
                                  //error={!this.state.isrcVhTypeValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcVhClass"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    this.state.rcVhClass ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcVhClass) ||
                                    this.state.vehicleClass ||
                                    ''
                                  }
                                >
                                  Vehicle Class
                                </InputLabel>
                                <TextField
                                  id="rcVhClass"
                                  name="rcVhClass"
                                  className="textfield"
                                  margin="dense"
                                  //label="Vehicle Class"
                                  type="text"
                                  // type="Multi-line"
                                  value={
                                    this.state.rcVhClass ||
                                    (this.state.vehicleData &&
                                      this.state.vehicleData.rcVhClass) ||
                                    this.state.vehicleClass ||
                                    ''
                                  }
                                  onChange={this.handleInputChange('rcVhClass')}
                                  //error={!this.state.isrcVhClassValid}
                                />
                                {/* {!this.state.isRegistrationDateValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )} */}
                              </FormGroup>
                            </FormControl>
                          </Grid>
                        )}

                        {this.state.vehicleSegment == 'DG Set' && (
                          <Grid xs={12} sm={12} mt={4}>
                            {/* {this.state.vehicleSegment == 'DG Set' ? 'Vehicle/Asset Type' : 'Vehicle Type'} * */}
                            Vehicle/Asset Type *
                            <FormControl className="selectbox">
                              <FormGroup className="form-input">
                                <SelectReact
                                  classes={classes}
                                  options={allvehicleTypes}
                                  // components={components}
                                  value={this.state.vehicleType}
                                  onChange={this.handleChangeType}
                                  placeholder="Select vehicle Type *"
                                  disabled={
                                    this.state.vehicleSegment == 'DG Set'
                                      ? true
                                      : false
                                  }
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {!this.state.isClientNameValid
                                    ? 'Invalid Selection'
                                    : ''}
                                </FormHelperText>
                              </FormGroup>
                            </FormControl>
                          </Grid>
                        )}

                        {/* {this.state.isSeatLimitValid && (
                          <FormControl className="selectbox">
                            <FormGroup className="form-input">
                              <TextField
                                id="seatLimit"
                                name="seatLimit"
                                className="textfield"
                                margin="dense"
                                label="Seat Capacity"
                                // type="text"
                                // type="Multi-line"
                                value={this.state.seatLimit}
                                onChange={this.handleInputChange('seatLimit')}
                                error={!this.state.isSeatLimitValid}
                                onBlur={this.checkSeatLimitValidity}
                              />
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                {!this.state.isSeatLimitValid
                                  ? 'Invalid Seat Capacity'
                                  : ''}
                              </FormHelperText>
                            </FormGroup>
                          </FormControl>
                        )} */}

                        {this.state.vehicleSegment == 'DG Set' && (
                          <div>
                            <Grid xs={12} sm={12} mt={4}>
                              Select Make *
                            </Grid>
                            <FormControl className="selectbox">
                              <FormGroup className="form-input">
                                <SelectReact
                                  id="vehicleMake"
                                  name="vehicleMake"
                                  classes={classes}
                                  options={this.state.makesList.map(item => ({
                                    value: item.id,
                                    label: item.make
                                  }))}
                                  value={this.state.vehicleMakeId}
                                  onChange={this.handleChangeMake}
                                  placeholder="Select"
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {!this.state.isVehicleMakeValid
                                    ? 'Invalid Vehicle Make'
                                    : ''}
                                </FormHelperText>
                              </FormGroup>
                            </FormControl>
                          </div>
                        )}

                        {this.state.vehicleSegment == 'DG Set' && (
                          <div>
                            <Grid xs={12} sm={12} mt={4}>
                              Select Model *
                            </Grid>
                            <FormControl className="selectbox">
                              <FormGroup className="form-input">
                                <SelectReact
                                  id="vehicleModel"
                                  name="vehicleModel"
                                  classes={classes}
                                  options={this.state.modelsList.map(item => ({
                                    value: item.id,
                                    label: item.model
                                  }))}
                                  value={this.state.vehicleModelId}
                                  onChange={this.handleChangeModel}
                                  placeholder="Select"
                                  error={!this.state.isVehicleModelValid}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {!this.state.isVehicleModelValid
                                    ? 'Invalid Vehicle Model'
                                    : ''}
                                </FormHelperText>
                              </FormGroup>
                            </FormControl>
                          </div>
                        )}

                        {this.state.vehicleSegment == 'DG Set' && (
                          <div>
                            <Grid xs={12} sm={12} mt={4}>
                              KVA Rating *
                            </Grid>
                            <FormControl className="selectbox">
                              <FormGroup className="form-input">
                                <SelectReact
                                  id="kvaRating"
                                  name="kvaRating"
                                  classes={classes}
                                  options={this.state.kvaRatingOptions}
                                  value={this.state.kvaRating}
                                  onChange={this.handleInputChange('kvaRating')}
                                  placeholder="KVA Rating"
                                  // error={!this.state.isVehicleModelValid}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {!this.state.isVehicleModelValid
                                    ? 'Invalid Vehicle Model'
                                    : ''}
                                </FormHelperText>
                              </FormGroup>
                            </FormControl>
                          </div>
                        )}

                        {this.state.vehicleSegment == 'DG Set' && (
                          <div>
                            <Grid xs={12} sm={12} mt={4}>
                              DG Set Type *
                            </Grid>
                            <FormControl className="selectbox">
                              <FormGroup className="form-input">
                                <SelectReact
                                  id="dgSetType"
                                  name="dgSetType"
                                  classes={classes}
                                  options={this.state.dgSetTypeOptions}
                                  value={this.state.dgSetType}
                                  onChange={this.handleInputChange('dgSetType')}
                                  placeholder="DG Set Type"
                                  // error={!this.state.isVehicleModelValid}
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {!this.state.isVehicleModelValid
                                    ? 'Invalid Vehicle Model'
                                    : ''}
                                </FormHelperText>
                              </FormGroup>
                            </FormControl>
                          </div>
                        )}
                        {/* {this.state.vehicleSegment != 'DG Set' && <Grid xs={12} sm={12} mt={4}>
                          Emission Type
                        </Grid>}
                        {this.state.vehicleSegment != 'DG Set' && <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="emissionType"
                              name="emissionType"
                              className="textfield"
                              margin="dense"
                              type="text"
                              value={this.state.emissionRateType}
                                  disabled={!this.isAdmin() && this.state.emissionRateTypeFromApi}
                              onChange={this.handleInputChange(
                                'emissionRateType'
                              )}
                            />
                          </FormGroup>
                        </FormControl>} */}

                        {this.state.vehicleSegment == 'DG Set' && (
                          <div>
                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '5px' }}
                            >
                              <FormGroup className="form-input">
                                Manufacturing Year
                                <SelectReact
                                  options={this.state.manufacturingYearOptions}
                                  value={this.state.manufacturingYear}
                                  onChange={this.handleInputChangeNew(
                                    'manufacturingYear'
                                  )}
                                  placeholder="Manufacturing Year"
                                  name="manufacturingYear"
                                  disabled={!this.isAdmin() && this.state.manufacturingYearFromApi}
                                />
                              </FormGroup>
                            </FormControl>
                          </div>
                        )}

                        {/* {this.state.vehicleSegment != 'DG Set' && <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              label="Gross Vehicle Weight (Tonnage)"
                              variant="outlined"
                              fullWidth
                              margin="normal"
                              name="grossVehicleWeight"
                              value={this.state.grossVehicleWeight}
                              onChange={this.handleInputChange(
                                'grossVehicleWeight'
                              )}
                              type="number"
                              inputProps={{ step: '0.01' }} // Allow decimal values
                              disabled={!this.isAdmin() && this.state.grossVehicleWeightFromApi}
                            />
                          </FormGroup>
                        </FormControl>}

                        {this.state.vehicleSegment != 'DG Set' && <FormControl
                          className="selectbox"
                          style={{ marginTop: '10px' }}
                        >
                          <FormGroup className="form-input">
                            <TextField
                              id="engineSpecification"
                              name="engineSpecification"
                              className="textfield"
                              margin="dense"
                              label="Engine Specification"
                              value={this.state.engineSpecification}
                              onChange={this.handleInputChange(
                                'engineSpecification'
                              )}
                              error={!this.state.isEngineSpecificationValid}
                              onBlur={this.checkItemValidity(
                                'engineSpecification'
                              )}
                              disabled={!this.isAdmin() && this.state.engineSpecificationFromApi}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isEngineSpecificationValid
                                ? 'Invalid Engine Specification'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>}

                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              label={this.state.vehicleSegment == 'DG Set' ? "Fuel Tank Capacity *" : "Fuel Tank Capacity"}
                              variant="outlined"
                              fullWidth
                              margin="normal"
                              name="fuelTankCapacity"
                              value={this.state.fuelTankCapacity}
                              onChange={this.handleInputChange(
                                'fuelTankCapacity'
                              )}
                              type="number"
                              inputProps={{ step: '1' }} // Allow decimal values
                              disabled={!this.isAdmin() && (this.state.vehicleSegment == 'DG Set' ? false : this.state.fuelTankCapacityFromApi)}
                            />
                            {!this.state.isBaselineDataForFEValid && <FormHelperText
                            id="name-error-text"
                            className="Error_msg"
                          >
                            Range must be 0.5 to 20 with up to 1 decimal place
                          </FormHelperText>}
                          </FormGroup>
                        </FormControl>

                        {this.state.errorMessageFuelTank && (
                          <FormHelperText
                            id="name-error-text"
                            className="Error_msg"
                          >
                            {this.state.errorMessageFuelTank}
                          </FormHelperText>
                        )}

                        {this.state.vehicleSegment != 'DG Set' && <FormControl
                          className="selectbox"
                          style={{ marginTop: '1px' }}
                        >
                          <FormGroup className="form-input">
                            <TextField
                              label="Adblue Capacity"
                              variant="outlined"
                              fullWidth
                              margin="normal"
                              name="adblueCapacity"
                              value={this.state.adblueCapacity}
                              onChange={this.handleInputChange(
                                'adblueCapacity'
                              )}
                              type="number"
                              inputProps={{ step: '1' }} // Allow decimal values
                              disabled={!this.isAdmin() && this.state.adblueCapacityFromApi}
                            />
                          </FormGroup>
                        </FormControl>}*/}

                        {this.state.vehicleSegment == 'DG Set' && (
                          <div>
                            <Grid xs={12} sm={12} style={{ marginTop: '20px' }}>
                              Fuel Type:
                            </Grid>
                            <FormControl
                              className="selectbox"
                              // style={{ marginTop: '5px' }}
                            >
                              <FormGroup className="form-input">
                                {/* {this.state.vehicleSegment !== 'DG Set' && <SelectReact
                              id="fuelType"
                              name="fuelType"
                              classes={classes}
                              options={[
                                { value: 'Petrol', label: 'Petrol' },
                                { value: 'Diesel', label: 'Diesel' },
                                { value: 'EV', label: 'EV' },
                                { value: 'CNG', label: 'CNG' },
                                { value: 'LNG', label: 'LNG' }
                              ]}
                              // components={components}
                              value={this.state.fuelType}
                              onChange={this.handleInputChange('fuelType')}
                              placeholder="Fuel Type"
                              disabled={!this.isAdmin() && this.state.fuelTypeFromApi}
                            />} */}
                                {/* {this.state.vehicleSegment === 'DG Set' &&  */}
                                <SelectReact
                                  id="fuelType"
                                  name="fuelType"
                                  classes={classes}
                                  options={[
                                    { value: 'petrol', label: 'PETROL' },
                                    { value: 'diesel', label: 'DIESEL' }
                                  ]}
                                  // components={components}
                                  value={this.state.fuelType}
                                  onChange={this.handleInputChange('fuelType')}
                                  placeholder="Fuel Type"
                                  // disabled={this.state.fuelTypeFromApi}
                                />
                                {/* } */}
                              </FormGroup>
                            </FormControl>
                          </div>
                        )}

                        {/* <Grid xs={12} sm={12} style={{ marginTop: '5px' }}>
                          Solution Type *
                        </Grid>
                        <FormControl
                          className="selectbox"
                          style={{ marginTop: '5px' }}
                        >
                          <FormGroup className="form-input">
                            <SelectReact
                              id="solutionType"
                              name="solutionType"
                              classes={classes}
                              options={[
                                {
                                  value: 'fuel_solution',
                                  label: 'Fuel Solution'
                                },
                                {
                                  value: 'obd_solution',
                                  label: 'OBD Solution'
                                },
                                {
                                  value: 'obd_fuel+fuel_solution',
                                  label: 'OBD + Fuel Solution'
                                },
                                {
                                  value: 'basic_tracking',
                                  label: 'Basic Tracking'
                                },
                                { value: 'ais_140', label: 'AIS 140' },
                                {
                                  value: 'ais_140_obd_solution',
                                  label: 'AIS 140 OBD Solution'
                                },
                                {
                                  value: 'ported_fuel_solution',
                                  label: 'Ported Fuel Solution'
                                },
                                {
                                  value: 'control_tower',
                                  label: 'Control Tower'
                                },
                                {
                                  value: 'testing_vehicle',
                                  label: 'Testing Vehicle'
                                },
                                {
                                  value: 'dummy_vehicle',
                                  label: 'Dummy Vehicle'
                                },
                                {
                                  value: 'video_telematics',
                                  label: 'Video Telematics'
                                }
                              ]}
                              value={this.state.solutionType}
                              onChange={this.handleInputChange('solutionType')}
                              placeholder="Solution Type *"
                              // disabled={this.state.fuelTypeFromApi}
                            />
                          </FormGroup>
                        </FormControl>


                        {this.state.vehicleSegment != 'DG Set' && <Grid xs={12} sm={12} style={{ marginTop: '5px' }}>
                          Ported Vehicle *
                        </Grid>}
                        {this.state.vehicleSegment != 'DG Set' && <FormControl
                          className="selectbox"
                          style={{ marginTop: '5px' }}
                        >
                          <FormGroup className="form-input">
                            <SelectReact
                              id="portedVehicle"
                              name="portedVehicle"
                              classes={classes}
                              options={[
                                {
                                  value: true,
                                  label: 'Yes'
                                },
                                {
                                  value: false,
                                  label: 'No'
                                },
                                
                              ]}
                              // components={components}
                              // value={this.state.solutionType}
                              value={this.state.portedVehicle}
                              onChange={this.handleInputChange('portedVehicle')}
                              placeholder="Ported Vehicle *"
                              // disabled={this.state.fuelTypeFromApi}
                            />
                          </FormGroup>
                        </FormControl>}

                        {this.state.vehicleSegment != 'DG Set' && <Grid xs={12} sm={12} style={{ marginTop: '5px' }}>
                          isTesting Vehicle *
                        </Grid>}
                        {this.state.vehicleSegment != 'DG Set' && <FormControl
                          className="selectbox"
                          style={{ marginTop: '5px' }}
                        >
                          <FormGroup className="form-input">
                            <SelectReact
                              id="isTestingVehicle"
                              name="isTestingVehicle"
                              classes={classes}
                              options={[
                                {
                                  value: true,
                                  label: 'Testing'
                                },
                                {
                                  value: false,
                                  label: 'Active'
                                },
                                
                              ]}
                              // components={components}
                              // value={this.state.solutionType}
                              value={this.state.isTestingVehicle}
                              onChange={this.handleInputChange('isTestingVehicle')}
                              placeholder="isTesting Vehicle *"
                              // disabled={this.state.fuelTypeFromApi}
                            />
                          </FormGroup>
                        </FormControl>}
                        {this.state.errorMessageNew && (
                          <FormHelperText
                            id="name-error-text"
                            className="Error_msg"
                          >
                            {this.state.errorMessageNew}
                          </FormHelperText>
                        )} */}
                      </div>
                      <div
                        style={{
                          padding: '5px',
                          borderRadius: '5px',
                          border: '2px solid #f2f2f2',
                          marginTop: '10px'
                        }}
                      >
                        <h4 style={{ marginBottom: '0px' }}>
                          Manual Entry Section
                        </h4>


                        {this.state.vehicleSegment != 'DG Set' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '20px' }}
                          >
                            <FormGroup className="form-input">
                              <label>Vehicle Customized Body Type</label>
                              <SelectReact
                                style={{ marginTop: '5px' }}
                                // options={this.state.noOfGears}
                                options={
                                  Array.isArray(
                                    this.state.vehiclecustomizedbodytype
                                  ) &&
                                  this.state.vehiclecustomizedbodytype.map(
                                    option => ({
                                      label: option,
                                      value: option
                                    })
                                  )
                                }
                                value={this.state.vehicleCustomizedBodyType}
                                onChange={selectedOption => {
                                  this.setState({
                                    vehicleCustomizedBodyType: selectedOption
                                      ? selectedOption.value
                                      : ''
                                  })
                                }}
                                placeholder="Vehicle Customized Body Type"
                              />
                            </FormGroup>
                          </FormControl>
                        )}

                        {this.state.vehicleSegment == 'DG Set' && (
                          <FormControl className="selectbox">
                            <FormGroup className="form-input">
                              <TextField
                                label="BHP (Break Horse Power)"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                name="bhp"
                                type="text"
                                inputProps={{ step: '1' }} // Allow decimal values
                                value={this.state.bhp}
                                onChange={this.handleInputChange('bhp')}
                              />
                            </FormGroup>
                          </FormControl>
                        )}

                        {this.state.vehicleSegment == 'DG Set' && (
                          <FormControl className="selectbox">
                            <FormGroup
                              className="form-input"
                              style={{ marginTop: '12px' }}
                            >
                              <label>Phase</label>
                              <SelectReact
                                options={this.state.phaseOptions}
                                placeholder="Phase"
                                value={this.state.phase}
                                onChange={this.handleInputChange('phase')}
                              />
                            </FormGroup>
                          </FormControl>
                        )}

                        {this.state.vehicleSegment == 'DG Set' && (
                          <FormControl className="selectbox">
                            <FormGroup className="form-input">
                              <TextField
                                label="Engine Model"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                name="engineModel"
                                type="text"
                                value={this.state.engineModel}
                                onChange={this.handleInputChange('engineModel')}
                              />
                            </FormGroup>
                          </FormControl>
                        )}

                        {this.state.vehicleSegment == 'DG Set' && (
                          <FormControl className="selectbox">
                            <FormGroup className="form-input">
                              <TextField
                                label="Genset Controller"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                name="gensetController"
                                type="text"
                                value={this.state.gensetController}
                                onChange={this.handleInputChange(
                                  'gensetController'
                                )}
                              />
                            </FormGroup>
                          </FormControl>
                        )}

                        {/* {this.state.vehicleSegment != 'DG Set' && <FormControl
                          className="selectbox"
                          style={{ marginTop: '16px' }}
                        >
                          <FormGroup className="form-input">
                            <TextField
                              id="engineNumber"
                              name="engineNumber"
                              className="textfield"
                              margin="dense"
                              label="Engine Number"
                              // type="Multi-line"
                              value={this.state.engineNumber}
                              onChange={this.handleInputChange('engineNumber')}
                            />
                          </FormGroup>
                        </FormControl>}

                        {this.state.vehicleSegment != 'DG Set' && <FormControl
                          className="selectbox"
                          style={{ marginTop: '10px' }}
                        >
                          <FormGroup className="form-input">
                            <TextField
                              id="chassisNumber"
                              name="chassisNumber"
                              className="textfield"
                              margin="dense"
                              label="Chassis Number"
                              // type="Multi-line"
                              value={this.state.chassisNumber}
                              onChange={this.handleInputChange('chassisNumber')}
                            />
                          </FormGroup>
                        </FormControl>} */}

                        {/* {this.state.vehicleSegment != 'DG Set' && <Grid xs={12} sm={12} style={{ marginTop: '12px' }}>
                          Speed Sensor *
                        </Grid>}
                        {this.state.vehicleSegment != 'DG Set' && <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <InputLabel htmlFor="selectLabel">
                              Select Speed Sensor
                            </InputLabel>

                            <SelectReact
                              classes={classes}
                              options={allSpeedSensor}
                              // components={components}
                              value={this.state.speedSensor}
                              onChange={this.handleChangeSpeedSensor}
                              placeholder="Select Speed Sensor *"
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isSpeedSensorValid
                                ? 'Invalid Selection'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>}

                        {this.state.vehicleSegment != 'DG Set' && <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="speedLimit"
                              name="speedLimit"
                              className="textfield"
                              margin="dense"
                              label="Maximum Speed Limit"
                              value={this.state.speedLimit}
                              required
                              onChange={this.handleInputChange('speedLimit')}
                              error={!this.state.isSpeedLimitValid}
                              onBlur={this.checkSpeedLimitValidity}
                              type="number"
                              inputProps={{ pattern: '[0-9]*' }}
                              onKeyDown={e => {
                                const isCopyKeyCombination =
                                  (e.ctrlKey || e.metaKey) &&
                                  (e.key === 'c' ||
                                    e.key === 'x' ||
                                    e.key === 'v')
                                const isSelectAll =
                                  (e.ctrlKey || e.metaKey) && e.key === 'a'
                                const isTabKey = e.key === 'Tab'

                                if (
                                  !isCopyKeyCombination &&
                                  !isSelectAll &&
                                  !isTabKey
                                ) {
                                  const isNumber = /^[0-9]*$/.test(e.key)
                                  const isAllowedKey =
                                    e.key === 'Delete' ||
                                    e.key === 'Backspace' ||
                                    e.key === 'ArrowLeft' ||
                                    e.key === 'ArrowRight'
                                  if (!isNumber && !isAllowedKey) {
                                    e.preventDefault()
                                  }
                                }
                              }}
                              onPaste={e => {
                                const pastedText = e.clipboardData.getData(
                                  'text/plain'
                                )
                                if (!/^\d*$/.test(pastedText)) {
                                  e.preventDefault()
                                }
                              }}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isSpeedLimitValid
                                ? 'Maximum speed limit 10-160'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>} */}

                        {/* {this.state.vehicleSegment != 'DG Set' && <Grid xs={12} sm={12} style={{ marginTop: '8px' }}>
                          Idling Speed:
                        </Grid>}
                        {this.state.vehicleSegment != 'DG Set' && <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <InputLabel htmlFor="selectLabel">
                              Select Speed Sensor
                            </InputLabel>

                            <SelectReact
                              classes={classes}
                              options={allIdlingSpeed}
                              // components={components}
                              value={this.state.idlingSpeed}
                              onChange={this.handleChangeIdlingSpeed}
                              placeholder="Select Idling Speed "
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            />
                          </FormGroup>
                        </FormControl>}

                        <FormControl
                          className="selectbox"
                          style={{ marginTop: '10px' }}
                        >
                          <FormGroup className="form-input">
                            <TextField
                              id="invoiceNumber"
                              name="invoiceNumber"
                              className="textfield"
                              margin="dense"
                              label="Invoice Number *"
                              type="text"
                              // type="Multi-line"
                              value={this.state.invoiceNumber}
                              onChange={this.handleInputChange('invoiceNumber')}
                              error={!this.state.isInvoiceNoValid}
                            />
                            {!this.state.isInvoiceNoValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )}
                          </FormGroup>
                        </FormControl>

                        <FormControl
                          className="selectbox"
                          style={{ marginTop: '10px' }}
                        >
                          <FormGroup className="form-input">
                            <DatePicker
                              required
                              format="DD/MM/YYYY"
                              maxDate={new Date()}
                              value={this.state.invoiceDate.date}
                              onChange={this.handleDateChange(
                                'invoiceDate'
                              )}
                              label="Invoice Date"
                            />
                          </FormGroup>
                        </FormControl> */}

                        {this.state.vehicleSegment != 'DG Set' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '10px' }}
                          >
                            <FormGroup className="form-input">
                              <TextField
                                id="equipmentSerialNumber"
                                name="equipmentSerialNumber"
                                className="textfield"
                                margin="dense"
                                label="Equipment Serial Number"
                                type="text"
                                // type="Multi-line"
                                value={this.state.equipmentSerialNumber}
                                error={!this.state.isEquipmentValid}
                                onChange={this.handleInputChange(
                                  'equipmentSerialNumber'
                                )}
                              />
                              {!this.state.isEquipmentValid && (
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  Maximum length is 90 characters.
                                </FormHelperText>
                              )}
                            </FormGroup>
                          </FormControl>
                        )}

                        {this.state.vehicleSegment != 'DG Set' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '10px' }}
                          >
                            <FormGroup className="form-input">
                              <TextField
                                id="equipmentName"
                                name="equipmentName"
                                className="textfield"
                                margin="dense"
                                label="Equipment Name"
                                type="text"
                                // type="Multi-line"
                                value={this.state.equipmentName}
                                onChange={this.handleInputChange(
                                  'equipmentName'
                                )}
                                error={!this.state.isEquipmentNameValid}
                              />
                              {!this.state.isEquipmentNameValid && (
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  Maximum length is 90 characters.
                                </FormHelperText>
                              )}
                            </FormGroup>
                          </FormControl>
                        )}

                        {this.state.vehicleSegment != 'DG Set' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '10px' }}
                          >
                            <FormGroup className="form-input">
                              <DatePicker
                                format="DD/MM/YYYY"
                                maxDate={new Date()}
                                value={this.state.commissioningDate.date}
                                onChange={this.handleDateChange(
                                  'commissioningDate'
                                )}
                                label="Commissioning Date"
                              />
                            </FormGroup>
                          </FormControl>
                        )}

                        {this.state.vehicleSegment != 'DG Set' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '10px' }}
                          >
                            <FormGroup className="form-input">
                              <TextField
                                id="department"
                                name="department"
                                className="textfield"
                                margin="dense"
                                label="Department"
                                type="text"
                                // type="Multi-line"
                                value={this.state.department}
                                onChange={this.handleInputChange('department')}
                                error={!this.state.isDepartmentValid}
                              />
                              {!this.state.isDepartmentValid && (
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  Maximum length is 90 characters.
                                </FormHelperText>
                              )}
                            </FormGroup>
                          </FormControl>
                        )}

                        {this.state.vehicleSegment != 'DG Set' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '10px' }}
                          >
                            <FormGroup className="form-input">
                              <TextField
                                id="contractorName"
                                name="contractorName"
                                className="textfield"
                                margin="dense"
                                label="Contractor Name"
                                type="text"
                                // type="Multi-line"
                                value={this.state.contractorName}
                                onChange={this.handleInputChange(
                                  'contractorName'
                                )}
                                error={!this.state.isContractorNameValid}
                              />
                              {!this.state.isContractorNameValid && (
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  Maximum length is 90 characters.
                                </FormHelperText>
                              )}
                            </FormGroup>
                          </FormControl>
                        )}

                        {this.state.vehicleSegment != 'DG Set' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '10px' }}
                          >
                            <FormGroup className="form-input">
                              <TextField
                                id="plant_code"
                                name="plant_code"
                                className="textfield"
                                margin="dense"
                                label="Plant Code"
                                type="text"
                                value={this.state.plant_code}
                                onChange={this.handleInputChange('plant_code')}
                              />
                            </FormGroup>
                          </FormControl>
                        )}

                        {this.state.vehicleSegment != 'DG Set' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '10px' }}
                          >
                            <FormGroup className="form-input">
                              <label>Owner Type</label>
                              <SelectReact
                                id="owner_type"
                                name="owner_type"
                                options={[
                                  { value: 'Self', label: 'Self' },
                                  { value: 'Hired', label: 'Hired' }
                                ]}
                                value={this.state.owner_type || 'Self'}
                                onChange={this.handleInputChange('owner_type')}
                                placeholder="Owner Type"
                                clearable={false}
                              />
                            </FormGroup>
                          </FormControl>
                        )}

                        {this.state.vehicleSegment != 'DG Set' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '10px' }}
                          >
                            <FormGroup className="form-input">
                              <TextField
                                id="equipment_type"
                                name="equipment_type"
                                className="textfield"
                                margin="dense"
                                label="Equipment Type"
                                type="text"
                                value={this.state.equipment_type}
                                onChange={this.handleInputChange('equipment_type')}
                              />
                            </FormGroup>
                          </FormControl>
                        )}

                        {this.state.vehicleSegment != 'DG Set' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '10px' }}
                          >
                            <FormGroup className="form-input">
                              <TextField
                                id="equipment_no"
                                name="equipment_no"
                                className="textfield"
                                margin="dense"
                                label="Equipment Number"
                                type="text"
                                value={this.state.equipment_no}
                                onChange={this.handleInputChange('equipment_no')}
                              />
                            </FormGroup>
                          </FormControl>
                        )}

                        {/* {this.state.vehicleSegment != 'DG Set' && <FormControl
                          className="selectbox"
                          style={{ marginTop: '5px' }}
                        >
                          <FormGroup className="form-input">
                            <TextField
                              id="engineTorque"
                              name="engineTorque"
                              className="textfield"
                              margin="dense"
                              label="Engine Torque"
                              value={this.state.engineTorque}
                              onChange={this.handleInputChange('engineTorque')}
                              error={!this.state.isEngineTorqueValid}
                              onBlur={this.checkItemValidity('engineTorque')}
                              inputProps={{ pattern: '[0-9]*' }}
                              onKeyDown={e => {
                                const isCopyKeyCombination =
                                  (e.ctrlKey || e.metaKey) &&
                                  (e.key === 'c' ||
                                    e.key === 'x' ||
                                    e.key === 'v')
                                const isSelectAll =
                                  (e.ctrlKey || e.metaKey) && e.key === 'a'
                                const isTabKey = e.key === 'Tab'
                                if (
                                  !isCopyKeyCombination &&
                                  !isSelectAll &&
                                  !isTabKey
                                ) {
                                  const isNumber = /^[0-9]*$/.test(e.key)
                                  const isAllowedKey =
                                    e.key === 'Delete' ||
                                    e.key === 'Backspace' ||
                                    e.key === 'ArrowLeft' ||
                                    e.key === 'ArrowRight'
                                  if (!isNumber && !isAllowedKey) {
                                    e.preventDefault()
                                  }
                                }
                              }}
                              onPaste={e => {
                                const pastedText = e.clipboardData.getData(
                                  'text/plain'
                                )
                                if (!/^\d*$/.test(pastedText)) {
                                  e.preventDefault()
                                }
                              }}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isEngineTorqueValid
                                ? 'Invalid Engine Torque'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>}

                        {this.state.vehicleSegment != 'DG Set' && <FormControl
                          className="selectbox"
                          style={{ marginTop: '3px', marginBottom: '20px' }}
                        >
                          <FormGroup className="form-input">
                            <TextField
                              id="engineLoad"
                              name="engineLoad"
                              className="textfield"
                              margin="dense"
                              label="Engine Load"
                              value={this.state.engineLoad}
                              onChange={this.handleInputChange('engineLoad')}
                              error={!this.state.isEngineLoadValid}
                              onBlur={this.checkItemValidity('engineLoad')}
                              inputProps={{ pattern: '[0-9]*' }}
                              onKeyDown={e => {
                                const isCopyKeyCombination =
                                  (e.ctrlKey || e.metaKey) &&
                                  (e.key === 'c' ||
                                    e.key === 'x' ||
                                    e.key === 'v')
                                const isSelectAll =
                                  (e.ctrlKey || e.metaKey) && e.key === 'a'
                                const isTabKey = e.key === 'Tab'
                                if (
                                  !isCopyKeyCombination &&
                                  !isSelectAll &&
                                  !isTabKey
                                ) {
                                  const isNumber = /^[0-9]*$/.test(e.key)
                                  const isAllowedKey =
                                    e.key === 'Delete' ||
                                    e.key === 'Backspace' ||
                                    e.key === 'ArrowLeft' ||
                                    e.key === 'ArrowRight'
                                  if (!isNumber && !isAllowedKey) {
                                    e.preventDefault()
                                  }
                                }
                              }}
                              onPaste={e => {
                                const pastedText = e.clipboardData.getData(
                                  'text/plain'
                                )
                                if (!/^\d*$/.test(pastedText)) {
                                  e.preventDefault()
                                }
                              }}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isEngineLoadValid
                                ? 'Invalid Engine Load'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>}

                        {this.state.vehicleSegment != 'DG Set' && <FormControl
                          className="selectbox"
                          style={{ marginTop: '5px' }}
                        >
                          <FormGroup className="form-input">
                            <TextField
                              id="torquePower"
                              name="torquePower"
                              className="textfield"
                              margin="dense"
                              label="Torque Power"
                              value={this.state.torquePower}
                              onChange={this.handleInputChange('torquePower')}
                              error={!this.state.istTorquePowerValid}
                              onBlur={this.checkItemValidity('torquePower')}
                              inputProps={{ pattern: '[0-9]*' }}
                              onKeyDown={e => {
                                const isCopyKeyCombination =
                                  (e.ctrlKey || e.metaKey) &&
                                  (e.key === 'c' ||
                                    e.key === 'x' ||
                                    e.key === 'v')
                                const isSelectAll =
                                  (e.ctrlKey || e.metaKey) && e.key === 'a'
                                const isTabKey = e.key === 'Tab'
                                if (
                                  !isCopyKeyCombination &&
                                  !isSelectAll &&
                                  !isTabKey
                                ) {
                                  const isNumber = /^[0-9]*$/.test(e.key)
                                  const isAllowedKey =
                                    e.key === 'Delete' ||
                                    e.key === 'Backspace' ||
                                    e.key === 'ArrowLeft' ||
                                    e.key === 'ArrowRight'
                                  if (!isNumber && !isAllowedKey) {
                                    e.preventDefault()
                                  }
                                }
                              }}
                              onPaste={e => {
                                const pastedText = e.clipboardData.getData(
                                  'text/plain'
                                )
                                if (!/^\d*$/.test(pastedText)) {
                                  e.preventDefault()
                                }
                              }}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.istTorquePowerValid
                                ? 'Invalid Torque Power'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>}

                        {this.state.vehicleSegment != 'DG Set' && <FormControl
                          className="selectbox"
                          style={{ marginTop: '6px' }}
                        >
                          <FormGroup className="form-input">
                            <TextField
                              id="baselineDataForFE"
                              name="baselineDataForFE"
                              className="textfield"
                              margin="dense"
                              label="Baseline Data for FE (KMPL):"
                              value={this.state.baselineDataForFE}
                              onChange={this.handleInputChange(
                                'baselineDataForFE'
                              )}
                              onBlur={this.checkBaselineDataForFEValidity}
                              error={!this.state.isBaselineDataForFEValid}
                              type="number"
                              inputProps={{ step: '0.1' }} // Allow decimal values to one decimal place
                              onKeyDown={e => {
                                const isCopyKeyCombination =
                                  (e.ctrlKey || e.metaKey) &&
                                  (e.key === 'c' ||
                                    e.key === 'x' ||
                                    e.key === 'v')
                                const isSelectAll =
                                  (e.ctrlKey || e.metaKey) && e.key === 'a'
                                const isTabKey = e.key === 'Tab'
                                if (
                                  !isCopyKeyCombination &&
                                  !isSelectAll &&
                                  !isTabKey
                                ) {
                                  const isNumberOrDecimal = /^[0-9.]*$/.test(
                                    e.key
                                  )
                                  const isAllowedKey =
                                    e.key === 'Delete' ||
                                    e.key === 'Backspace' ||
                                    e.key === 'ArrowLeft' ||
                                    e.key === 'ArrowRight' ||
                                    e.key === '.'
                                  if (!isNumberOrDecimal && !isAllowedKey) {
                                    e.preventDefault()
                                  }
                                }
                              }}
                              onPaste={e => {
                                const pastedText = e.clipboardData.getData(
                                  'text/plain'
                                )
                                if (!/^\d*$/.test(pastedText)) {
                                  e.preventDefault()
                                }
                              }}
                            />

                            {!this.state.isBaselineDataForFEValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Range must be 0.5 to 20 with up to 2 decimal
                                place
                              </FormHelperText>
                            )}
                          </FormGroup>
                        </FormControl>}

                        {this.state.vehicleSegment != 'DG Set' && <FormControl
                          className="selectbox"
                          style={{ marginTop: '6px' }}
                        >
                          <FormGroup className="form-input">
                            <TextField
                              id="baselineDistance"
                              name="baselineDistance"
                              className="textfield"
                              margin="dense"
                              label="Baseline Distance (KM):"
                              value={this.state.baselineDistance}
                              onChange={this.handleInputChange(
                                'baselineDistance'
                              )}
                              onBlur={this.checkBaselineDistanceValidity}
                              error={!this.state.isBaselineDistanceValid}
                              type="number"
                              inputProps={{ pattern: '[0-9]*' }}
                              onKeyDown={e => {
                                const isCopyKeyCombination =
                                  (e.ctrlKey || e.metaKey) &&
                                  (e.key === 'c' ||
                                    e.key === 'x' ||
                                    e.key === 'v')
                                const isSelectAll =
                                  (e.ctrlKey || e.metaKey) && e.key === 'a'
                                const isTabKey = e.key === 'Tab'
                                if (
                                  !isCopyKeyCombination &&
                                  !isSelectAll &&
                                  !isTabKey
                                ) {
                                  const isNumber = /^[0-9]*$/.test(e.key)
                                  const isAllowedKey =
                                    e.key === 'Delete' ||
                                    e.key === 'Backspace' ||
                                    e.key === 'ArrowLeft' ||
                                    e.key === 'ArrowRight'
                                  if (!isNumber && !isAllowedKey) {
                                    e.preventDefault()
                                  }
                                }
                              }}
                              onPaste={e => {
                                const pastedText = e.clipboardData.getData(
                                  'text/plain'
                                )
                                if (!/^\d*$/.test(pastedText)) {
                                  e.preventDefault()
                                }
                              }}
                            />

                            {!this.state.isBaselineDistanceValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Baseline Distance must be a positive integer
                                between 1 and 2000000'
                              </FormHelperText>
                            )}
                          </FormGroup>
                        </FormControl>} */}

                        {this.state.vehicleSegment != 'DG Set' && (
                          <Grid
                            xs={12}
                            sm={12}
                            mt={4}
                            style={{ marginTop: '10px' }}
                          >
                            <FormControlLabel
                              control={
                                <Switch
                                  value={this.state.isDualEngine}
                                  checked={this.state.isDualEngine}
                                  onChange={this.handleInputChange(
                                    'isDualEngine'
                                  )}
                                  name="dualEngineToggle"
                                  color="primary"
                                />
                              }
                              label="Dual Engine"
                            />
                            {/* {this.state.deviceType&& this.state.deviceType!="obd"&&
                        <FormControlLabel
                        control={
                          <Switch
                            value={this.state.duplicateVehicle}
                            checked={this.state.duplicateVehicle}
                            onChange={this.handleInputChange('duplicateVehicle')}
                            name="duplicateVehicleToggle"
                            color="primary"
                          />
                        }
                        label="Duplicate Vehicle"
                      />
                         }  */}
                          </Grid>
                        )}

                        {this.state.vehicleSegment != 'DG Set' && (
                          <Grid xs={12} sm={12} mt={4}>
                            <FormControlLabel
                              control={
                                <Switch
                                  value={this.state.hasArm}
                                  checked={this.state.hasArm}
                                  onChange={this.handleInputChange('hasArm')}
                                  name="armToggle"
                                  color="primary"
                                />
                              }
                              label="Arm Included?"
                            />
                          </Grid>
                        )}

                        <Grid xs={12} sm={12} mt={4}>
                          <FormControlLabel
                            control={
                              <Switch
                                value={this.state.isElockConnection}
                                checked={this.state.isElockConnection}
                                onChange={this.handleInputChange(
                                  'isElockConnection'
                                )}
                                name="isElockConnectionToggle"
                                color="primary"
                              />
                            }
                            label="E-LOCK Connection?"
                          />
                        </Grid>

                        <Grid xs={12} sm={12} mt={4}>
                          <FormControlLabel
                            control={
                              <Switch
                                value={this.state.istachoenabled}
                                checked={this.state.istachoenabled}
                                onChange={this.handleInputChange('istachoenabled')}
                                name="istachoenabledToggle"
                                color="primary"
                              />
                            }
                            label="Is Tachometer Enabled?"
                          />
                        </Grid>

                        {this.state.istachoenabled && (
                          <Grid container spacing={2} style={{ marginTop: '10px' }}>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                label="Idle RPM *"
                                value={this.state.tachoidlerpm}
                                onChange={this.handleInputChange('tachoidlerpm')}
                                type="number"
                                fullWidth
                                margin="dense"
                                variant="outlined"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                label="Shift Hours *"
                                value={this.state.tachoshifthours}
                                onChange={this.handleInputChange('tachoshifthours')}
                                type="number"
                                fullWidth
                                margin="dense"
                                variant="outlined"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                label="Engine On Voltage (min)"
                                value={this.state.tachoengineonmin}
                                onChange={this.handleInputChange('tachoengineonmin')}
                                type="number"
                                fullWidth
                                margin="dense"
                                variant="outlined"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                label="Engine On Voltage (max)"
                                value={this.state.tachoengineonmax}
                                onChange={this.handleInputChange('tachoengineonmax')}
                                type="number"
                                fullWidth
                                margin="dense"
                                variant="outlined"
                              />
                            </Grid>
                          </Grid>
                        )}

                        {
                          // this.state.vehicleSegment != 'DG Set' &&
                          <Grid xs={12} sm={12} mt={4}>
                            <FormControlLabel
                              control={
                                <Switch
                                  value={this.state.isRotationSensor}
                                  checked={this.state.isRotationSensor}
                                  onChange={e => {
                                    this.setState({
                                      isRotationSensor: !this.state
                                        .isRotationSensor
                                    })
                                  }}
                                  name="isRotationSensor"
                                  color="primary"
                                />
                              }
                              label="Rotation Sensor Available"
                            />
                          </Grid>
                        }

                        {this.state.vehicleSegment != 'DG Set' && (
                          <Grid xs={12} sm={12} mt={4}>
                            <FormControlLabel
                              control={
                                <Switch
                                  value={
                                    this.state.isIndividualViewOrCombinedView
                                  }
                                  checked={
                                    this.state.isIndividualViewOrCombinedView
                                  }
                                  onChange={this.handleInputChange(
                                    'isIndividualViewOrCombinedView'
                                  )}
                                  name="isIndividualViewOrCombinedView"
                                  color="primary"
                                />
                              }
                              label={
                                this.state.isIndividualViewOrCombinedView
                                  ? 'Dual Tank Combined View'
                                  : 'Dual Tank Individual View'
                              }
                              //labelPlacement={this.state.isIndividualViewOrCombinedView ? 'end' : 'start'}
                            />
                          </Grid>
                        )}

                        {/* {this.state.isDualEngine && <Grid item xs={12} sm={12} fullwidth>
                        <FormControl
                          style={{
                            minWidth: '70%'
                          }}
                        >
                          <FormGroup className="form-input">
                            <TextField
                              id="eon_voltage"
                              name="eon_voltage"
                              className="textfield"
                              margin="dense"
                              label="Engine on Voltage :"
                              // type="Multi-line"
                              value={this.state.eon_voltage}
                              // required
                              onChange={this.handleInputChange('eon_voltage')}
                              error={!this.state.iseon_voltageValid}
                              onBlur={this.checkeon_voltageValidity}
                              // disabled={this.state.calibrationDataExists}
                              // InputProps={{
                              //   style: {
                              //     opacity: this.state.calibrationDataExists ? 0.6 : 1
                              //   }
                              // }}
                            />

                              <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                              error={!this.state.iseon_voltageValid}
                            >
                              {!this.state.iseon_voltageValid && 'Min capacity should be an integer or Float (Allows up to 2 digits after decimal)'}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>}
                      { this.state.isDualEngine && <Grid item xs={12} sm={12} fullwidth>
                        <FormControl
                          style={{
                            minWidth: '70%'
                          }}
                        >
                          <FormGroup className="form-input">
                            <TextField
                              id="eoff_voltage"
                              name="eoff_voltage"
                              className="textfield"
                              margin="dense"
                              label="Engine off Voltage :"
                              // type="Multi-line"
                              value={this.state.eoff_voltage}
                              // required
                              onChange={this.handleInputChange('eoff_voltage')}
                              error={!this.state.iseoff_voltageValid}
                              onBlur={this.checkeoff_voltageValidity}
                            />

                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                              error={!this.state.iseoff_voltageValid}
                            >
                              {!this.state.iseoff_voltageValid && 'Max capacity should be an integer or Float (Allows up to 2 digits after decimal)'}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>} */}

                        {/* Previously, displaying Engine On and Engine Off voltages required a dual-engine setup. However, this requirement has been removed as per the latest updates, ensuring that pullers and tensioners can utilize these fields to accurately calculate actual-engine-on hours. */}

                        <Grid item xs={12} sm={12} fullwidth>
                          <FormControl
                            style={{
                              minWidth: '70%'
                            }}
                          >
                            <FormGroup className="form-input">
                              <TextField
                                id="eon_voltage"
                                name="eon_voltage"
                                className="textfield"
                                margin="dense"
                                label="Engine on Voltage :"
                                value={
                                  this.state.eon_voltage === null
                                    ? ''
                                    : this.state.eon_voltage
                                }
                                onChange={e => {
                                  this.setState(
                                    { eon_voltage: e.target.value },
                                    this.checkDualEngineVoltageValidity
                                  )
                                }}
                                error={
                                  this.state.isDualEngine &&
                                  (!this.state.eon_voltage ||
                                    !this.state.isEonVoltageValid)
                                }
                                onBlur={this.checkeon_voltageValidity}
                                required={this.state.isDualEngine}
                              />

                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                                error={!this.state.iseon_voltageValid}
                              >
                                {!this.state.iseon_voltageValid &&
                                  'Min capacity should be an integer or Float (Allows up to 2 digits after decimal)'}
                              </FormHelperText>
                            </FormGroup>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} fullwidth>
                          <FormControl
                            style={{
                              minWidth: '70%'
                            }}
                          >
                            <FormGroup className="form-input">
                              <TextField
                                id="eoff_voltage"
                                name="eoff_voltage"
                                className="textfield"
                                margin="dense"
                                label="Engine off Voltage :"
                                value={
                                  this.state.eoff_voltage === null
                                    ? ''
                                    : this.state.eoff_voltage
                                }
                                onChange={e => {
                                  this.setState(
                                    { eoff_voltage: e.target.value },
                                    this.checkDualEngineVoltageValidity
                                  )
                                }}
                                error={
                                  this.state.isDualEngine &&
                                  (!this.state.eoff_voltage ||
                                    !this.state.isEoffVoltageValid)
                                }
                                onBlur={this.checkeoff_voltageValidity}
                                required={this.state.isDualEngine}
                              />

                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                                error={!this.state.iseoff_voltageValid}
                              >
                                {!this.state.iseoff_voltageValid &&
                                  'Max capacity should be an integer or Float (Allows up to 2 digits after decimal)'}
                              </FormHelperText>
                            </FormGroup>
                          </FormControl>
                        </Grid>

                        <FormControl
                          className="selectbox"
                          style={{ marginTop: '-10px' }}
                        >
                          <FormGroup className="form-input">
                            <TextField
                              label="Fuel Tank Capacity"
                              variant="outlined"
                              fullWidth
                              margin="normal"
                              name="fuelTankCapacity"
                              value={this.state.fuelTankCapacity}
                              onChange={this.handleInputChange(
                                'fuelTankCapacity'
                              )}
                              type="number"
                              inputProps={{ step: '1' }} // Allow decimal values
                              // disabled={this.state.vehicleSegment == 'DG Set' ? false : this.state.fuelTankCapacityFromApi}
                              required={
                                this.state.vehicleSegment == 'DG Set'
                                  ? true
                                  : false
                              }
                            />
                            {/* {!this.state.isBaselineDataForFEValid && <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Range must be 0.5 to 20 with up to 1 decimal place
                              </FormHelperText>} */}
                          </FormGroup>
                        </FormControl>

                        {this.state.errorMessageFuelTank && (
                          <FormHelperText
                            id="name-error-text"
                            className="Error_msg"
                          >
                            {this.state.errorMessageFuelTank}
                          </FormHelperText>
                        )}

                        {this.state.vehicleSegment != 'DG Set' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '-10px' }}
                          >
                            <FormGroup className="form-input">
                              <TextField
                                label="Adblue Capacity"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                name="adblueCapacity"
                                value={this.state.adblueCapacity}
                                onChange={e => {
                                  this.setState(
                                    { adblueCapacity: e.target.value },
                                    this.checkAdblueCapacityValidity
                                  )
                                }}
                                type="number"
                                inputProps={{ step: '1' }} // Allow decimal values
                                // disabled={this.state.adblueCapacityFromApi}
                                required={
                                  this.state.deviceType &&
                                  this.state.deviceType.toLowerCase() === 'obd'
                                }
                              />
                            </FormGroup>
                          </FormControl>
                        )}

                        {this.state.vehicleSegment != 'DG Set' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '20px' }}
                          >
                            <FormGroup className="form-input">
                              <label>No. Of Gears</label>
                              <SelectReact
                                style={{ marginTop: '5px' }}
                                // options={this.state.noOfGears}
                                options={
                                  Array.isArray(this.state.noofgears) &&
                                  this.state.noofgears.map(option => ({
                                    label: option,
                                    value: option
                                  }))
                                }
                                value={this.state.noOfGears}
                                onChange={selectedOption => {
                                  this.setState({
                                    noOfGears: selectedOption
                                      ? selectedOption.value
                                      : null
                                  })
                                }}
                                placeholder="No. Of Gears"
                              />
                            </FormGroup>
                          </FormControl>
                        )}

                        {this.state.vehicleSegment != 'DG Set' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '10px' }}
                            // shrink={this.state.gearRatio}
                          >
                            <FormGroup className="form-input">
                              <InputLabel
                                htmlFor="gearRatio"
                                // style={{ marginTop: '-10px' }}
                                shrink={this.state.gearRatio}
                              >
                                Gear Ratio
                              </InputLabel>
                              <TextField
                                // label="Gear Ratio"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                name="gearRatio"
                                value={this.state.gearRatio}
                                onChange={this.handleInputChange('gearRatio')}
                                // type="number"
                                // inputProps={{ step: '1' }}
                                // disabled={this.state.adblueCapacityFromApi}
                              />
                            </FormGroup>
                          </FormControl>
                        )}
                   



<FormControl
  className="selectbox"
  style={{ marginTop: '5px' }}
>
  <FormGroup className="form-input">

    {/* ✅ Label + Info Icon with Tooltip */}
    <div
      style={{
        marginTop: '20px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px'
      }}
    >
      <span>Solution Type *</span>

      <Tooltip title="These fields are disabled" arrow>
        <span
          style={{
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          ℹ️
        </span>
      </Tooltip>
    </div>

    {/* ✅ Dropdown */}
    <div style={{ marginTop: '5px' }}>
      <Query query={GET_SOLUTION_TYPES}>
        {({ loading, error, data }) => {
          if (loading) return <CircularProgress size={24} />
          if (error) return <div>Error loading solution types</div>

          const solutionTypeMultiOptions = data.getAllMasterSolutionType.map(
            type => {
              const code =  type.id
              return {
                value: code,
                label: type.solutionTypeName
              }
            }
          )

          const selectedMultiValue =
            solutionTypeMultiOptions.filter(option =>
              this.state.solution_type &&
              this.state.solution_type.includes(option.value)
            )

          return (
            <Fragment>
              <SelectReact
                id="solution_type"
                name="solution_type"
                classes={classes}
                options={solutionTypeMultiOptions}
                value={selectedMultiValue}
                multi
                disabled={!this.isAdmin()}
                optionComponent={SolutionTypeOption}
                closeOnSelect={false}
                removeSelected={false}
                onChange={this.handleInputChange('solution_type')}
                placeholder="Solution Type *"
              />
            </Fragment>
          )
        }}
      </Query>
          {/* If reverse camera is part of solution_type, show RCS serial dropdown */}
          {this.state.solution_type && this.state.solution_type.includes('reverse_camera_screen') && (
            <div style={{ marginTop: '12px' }}>
              <Query query={gql`
                query GetReverseCameraAndScreenInventory {
                  getReverseCameraAndScreenInventory {
                    data {
                      rcs_serial_number
                    }
                  }
                }
              `} fetchPolicy="network-only">
                {({ loading, error, data }) => {
                  if (loading) return <CircularProgress size={20} />
                  if (error) return <div>Error loading RCS inventory</div>

                  const options = (data && data.getReverseCameraAndScreenInventory && data.getReverseCameraAndScreenInventory.data) ? data.getReverseCameraAndScreenInventory.data.map(item => ({ value: item.rcs_serial_number, label: item.rcs_serial_number })) : []

                  return (
                    <div style={{ marginTop: '8px' }}>
                      <div style={{ marginBottom: '6px' }}>RCS Serial Number</div>
                      <SelectReact
                        options={options}
                        value={options.find(o => o.value === this.state.rcsSerialNumber) || null}
                        onChange={this.handleInputChange('rcsSerialNumber')}
                        placeholder="Select RCS Serial Number"
                        isClearable
                      />
                    </div>
                  )
                }}
              </Query>
            </div>
          )}
          

    </div>

  </FormGroup>
</FormControl>
                        {this.state.vehicleSegment != 'DG Set' && (
                          <Grid xs={12} sm={12} style={{ marginTop: '20px' }}>
                            Ported Vehicle *
                          </Grid>
                        )}

                        {this.state.vehicleSegment != 'DG Set' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '5px' }}
                          >
                            <FormGroup className="form-input">
                              <SelectReact
                                id="portedVehicle"
                                name="portedVehicle"
                                classes={classes}
                                options={[
                                  {
                                    value: true,
                                    label: 'Yes'
                                  },
                                  {
                                    value: false,
                                    label: 'No'
                                  }
                                ]}
                                // components={components}
                                value={this.state.portedVehicle}
                                onChange={this.handleInputChange(
                                  'portedVehicle'
                                )}
                                placeholder="Ported Vehicle *"
                              />
                            </FormGroup>
                          </FormControl>
                        )}

                        {this.state.vehicleSegment != 'DG Set' && (
                          <Grid xs={12} sm={12} style={{ marginTop: '20px' }}>
                            isTesting Vehicle *
                          </Grid>
                        )}

                        {this.state.vehicleSegment != 'DG Set' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '5px' }}
                          >
                            <FormGroup className="form-input">
                              <SelectReact
                                id="isTestingVehicle"
                                name="isTestingVehicle"
                                classes={classes}
                                options={[
                                  {
                                    value: true,
                                    label: 'Testing'
                                  },
                                  {
                                    value: false,
                                    label: 'Active'
                                  }
                                ]}
                                // components={components}
                                value={this.state.isTestingVehicle}
                                onChange={this.handleInputChange(
                                  'isTestingVehicle'
                                )}
                                placeholder="isTesting Vehicle *"
                              />
                            </FormGroup>
                          </FormControl>
                        )}

                        {this.state.errorMessageNew && (
                          <FormHelperText
                            id="name-error-text"
                            className="Error_msg"
                          >
                            {this.state.errorMessageNew}
                          </FormHelperText>
                        )}

                        {this.state.vehicleSegment != 'DG Set' && (
                          <Grid
                            xs={12}
                            sm={12}
                            mt={4}
                            style={{ marginTop: '20px' }}
                          >
                            Speed Sensor *
                          </Grid>
                        )}
                        {this.state.vehicleSegment != 'DG Set' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '5px' }}
                          >
                            <FormGroup className="form-input">
                              {/* <InputLabel htmlFor="selectLabel">
                              Select Speed Sensor
                            </InputLabel> */}

                              <SelectReact
                                classes={classes}
                                options={allSpeedSensor}
                                // components={components}
                                value={this.state.speedSensor}
                                onChange={this.handleChangeSpeedSensor}
                                onBlur={this.checkSpeedSensorValidity}
                                placeholder="Select Speed Sensor *"
                              />
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                {!this.state.isSpeedSensorValid
                                  ? 'Invalid Selection'
                                  : ''}
                              </FormHelperText>
                            </FormGroup>
                          </FormControl>
                        )}

                        {this.state.vehicleSegment != 'DG Set' && (
                          <FormControl className="selectbox">
                            <FormGroup className="form-input">
                              <TextField
                                id="speedLimit"
                                name="speedLimit"
                                className="textfield"
                                margin="dense"
                                label="Maximum Speed Limit"
                                value={this.state.speedLimit}
                                required
                                onChange={this.handleInputChange('speedLimit')}
                                error={!this.state.isSpeedLimitValid}
                                onBlur={this.checkSpeedLimitValidity}
                                type="number"
                                inputProps={{ pattern: '[0-9]*' }}
                                onKeyDown={e => {
                                  const isCopyKeyCombination =
                                    (e.ctrlKey || e.metaKey) &&
                                    (e.key === 'c' ||
                                      e.key === 'x' ||
                                      e.key === 'v')
                                  const isSelectAll =
                                    (e.ctrlKey || e.metaKey) && e.key === 'a'
                                  const isTabKey = e.key === 'Tab'
                                  if (
                                    !isCopyKeyCombination &&
                                    !isSelectAll &&
                                    !isTabKey
                                  ) {
                                    const isNumber = /^[0-9]*$/.test(e.key)
                                    const isAllowedKey =
                                      e.key === 'Delete' ||
                                      e.key === 'Backspace' ||
                                      e.key === 'ArrowLeft' ||
                                      e.key === 'ArrowRight'
                                    if (!isNumber && !isAllowedKey) {
                                      e.preventDefault()
                                    }
                                  }
                                }}
                                onPaste={e => {
                                  const pastedText = e.clipboardData.getData(
                                    'text/plain'
                                  )
                                  if (!/^\d*$/.test(pastedText)) {
                                    e.preventDefault()
                                  }
                                }}
                              />
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                {!this.state.isSpeedLimitValid
                                  ? 'Maximum speed limit 10-160'
                                  : ''}
                              </FormHelperText>
                            </FormGroup>
                          </FormControl>
                        )}

                        {this.state.vehicleSegment != 'DG Set' && (
                          <Grid xs={12} sm={12} style={{ marginTop: '5px' }}>
                            Idling Speed:
                          </Grid>
                        )}
                        {this.state.vehicleSegment != 'DG Set' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '5px' }}
                          >
                            <FormGroup className="form-input">
                              {/* <InputLabel htmlFor="selectLabel">
                              Select Speed Sensor
                            </InputLabel> */}

                              <SelectReact
                                classes={classes}
                                options={allIdlingSpeed}
                                // components={components}
                                value={this.state.idlingSpeed}
                                onChange={this.handleChangeIdlingSpeed}
                                placeholder="Select Idling Speed "
                              />
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              />
                            </FormGroup>
                          </FormControl>
                        )}

                        <Grid xs={12} sm={12} style={{ marginTop: '10px' }}>
                          Timezone:
                        </Grid>
                        <FormControl
                          className="selectbox"
                          style={{ marginTop: '5px' }}
                        >
                          <FormGroup className="form-input">
                            <SelectReact
                              classes={classes}
                              options={this.state.timezoneList}
                              value={this.state.selectedTimezone}
                              onChange={this.handleTimezoneChange}
                              placeholder="Select Timezone (Default: Client Timezone)"
                              isClearable={true}
                            />
                          </FormGroup>
                        </FormControl>

                        {this.state.vehicleSegment !== 'DG Set' && (
                          <Grid xs={12} sm={12} style={{ marginTop: '5px' }}>
                            Asset Working Hours:
                          </Grid>
                        )}

                        {this.state.vehicleSegment !== 'DG Set' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '5px' }}
                          >
                            <FormGroup className="form-input">
                              <TextField
                                classes={classes}
                                type="number"
                                value={this.state.inputParameter || ''}
                                onChange={this.handleChangeInputParameter}
                                placeholder="Enter Asset Working Hours"
                                fullWidth
                                variant="outlined"
                                InputProps={{ inputProps: {} }}
                              />
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              />
                            </FormGroup>
                          </FormControl>
                        )}

                        {this.state.vehicleSegment !== 'DG Set' && (
                          <Grid xs={12} sm={12} style={{ marginTop: '5px' }}>
                            Asset Multiplication Factor:
                          </Grid>
                        )}

                        {this.state.vehicleSegment !== 'DG Set' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '5px' }}
                          >
                            <FormGroup className="form-input">
                              <TextField
                                classes={classes}
                                type="number"
                                value={this.state.multiplicationFactor || ''}
                                onChange={this.handleChangeMultiplicationFactor}
                                placeholder="Enter Asset Multiplication Factor"
                                fullWidth
                                variant="outlined"
                                InputProps={{ inputProps: {} }}
                              />
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              />
                            </FormGroup>
                          </FormControl>
                        )}

                        <FormControl
                          className="selectbox"
                          style={{ marginTop: '5px' }}
                        >
                          <FormGroup className="form-input">
                            <TextField
                              id="invoiceNumber"
                              name="invoiceNumber"
                              className="textfield"
                              margin="dense"
                              label={
                                this.state.customerType == 'Paid' ||
                                this.state.vehicleSegment == 'DG Set'
                                  ? 'Invoice Number *'
                                  : 'Invoice Number'
                              }
                              type="text"
                              // type="Multi-line"
                              value={this.state.invoiceNumber}
                              onChange={this.handleInputChange('invoiceNumber')}
                              error={!this.state.isInvoiceNoValid}
                            />
                            {!this.state.isInvoiceNoValid && (
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                Maximum length is 90 characters.
                              </FormHelperText>
                            )}
                          </FormGroup>
                        </FormControl>

                        <FormControl
                          className="selectbox"
                          style={{ marginTop: '10px' }}
                        >
                          <FormGroup className="form-input">
                            <DatePicker
                              format="DD/MM/YYYY"
                              maxDate={new Date()}
                              value={this.state.invoiceDate.date}
                              onChange={this.handleDateChange('invoiceDate')}
                              label={
                                this.state.customerType == 'Paid'
                                  ? 'Invoice Date *'
                                  : 'Invoice Date'
                              }
                            />
                          </FormGroup>
                        </FormControl>

                        {this.state.vehicleSegment !== 'DG Set' && (
                          <FormControl
                            className="selectbox"
                            style={{ marginTop: '25px' }}
                          >
                            <FormGroup className="form-input">
                              <label>Baseline Data Type FE</label>
                              <SelectReact
                                style={{ marginTop: '5px' }}
                                // options={this.state.baselineDataTypeFEOptions}
                                options={
                                  Array.isArray(
                                    this.state.baselinedatatypefe
                                  ) &&
                                  this.state.baselinedatatypefe.map(option => ({
                                    label: option,
                                    value: option.toLowerCase()
                                  }))
                                }
                                value={this.state.baselineDataType}
                                onChange={selectedOption => {
                                  this.setState({
                                    baselineDataType: selectedOption
                                      ? selectedOption.value
                                      : ''
                                  })
                                }}
                                placeholder="Baseline Data Type FE"
                              />
                            </FormGroup>
                          </FormControl>
                        )}

                        {this.state.baselineDataType &&
                          this.state.vehicleSegment != 'DG Set' && (
                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '6px' }}
                            >
                              <FormGroup className="form-input">
                                <TextField
                                  id="baselineDataForFE"
                                  name="baselineDataForFE"
                                  className="textfield"
                                  margin="dense"
                                  label={
                                    this.state.baselineDataType === 'kmpl'
                                      ? 'Baseline FE (KMPL):'
                                      : 'Baseline FE (LPH ):'
                                  }
                                  // label="Baseline FE (KMPL):"
                                  value={this.state.baselineDataForFE}
                                  onChange={this.handleInputChange(
                                    'baselineDataForFE'
                                  )}
                                  onBlur={this.checkBaselineDataForFEValidity}
                                  error={!this.state.isBaselineDataForFEValid}
                                  type="number"
                                  inputProps={{ step: '0.1' }} // Allow decimal values to one decimal place
                                  onKeyDown={e => {
                                    const isCopyKeyCombination =
                                      (e.ctrlKey || e.metaKey) &&
                                      (e.key === 'c' ||
                                        e.key === 'x' ||
                                        e.key === 'v')
                                    const isSelectAll =
                                      (e.ctrlKey || e.metaKey) && e.key === 'a'
                                    const isTabKey = e.key === 'Tab'
                                    if (
                                      !isCopyKeyCombination &&
                                      !isSelectAll &&
                                      !isTabKey
                                    ) {
                                      const isNumberOrDecimal = /^[0-9.]*$/.test(
                                        e.key
                                      )
                                      const isAllowedKey =
                                        e.key === 'Delete' ||
                                        e.key === 'Backspace' ||
                                        e.key === 'ArrowLeft' ||
                                        e.key === 'ArrowRight' ||
                                        e.key === '.'
                                      if (!isNumberOrDecimal && !isAllowedKey) {
                                        e.preventDefault()
                                      }
                                    }
                                  }}
                                  onPaste={e => {
                                    const pastedText = e.clipboardData.getData(
                                      'text/plain'
                                    )
                                    if (!/^\d*$/.test(pastedText)) {
                                      e.preventDefault()
                                    }
                                  }}
                                />

                                {!this.state.isBaselineDataForFEValid && (
                                  <FormHelperText
                                    id="name-error-text"
                                    className="Error_msg"
                                  >
                                    Range must be 0.5 to 20 with up to 2 decimal
                                    place
                                  </FormHelperText>
                                )}
                              </FormGroup>
                            </FormControl>
                          )}

                        {this.state.baselineDataType == 'kmpl' &&
                          this.state.vehicleSegment != 'DG Set' && (
                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '6px' }}
                            >
                              <FormGroup className="form-input">
                                <TextField
                                  id="baselineDistance"
                                  name="baselineDistance"
                                  className="textfield"
                                  margin="dense"
                                  label="Baseline Distance (KM):"
                                  value={this.state.baselineDistance}
                                  onChange={this.handleInputChange(
                                    'baselineDistance'
                                  )}
                                  onBlur={this.checkBaselineDistanceValidity}
                                  error={!this.state.isBaselineDistanceValid}
                                  type="number"
                                  inputProps={{ pattern: '[0-9]*' }}
                                  onKeyDown={e => {
                                    const isCopyKeyCombination =
                                      (e.ctrlKey || e.metaKey) &&
                                      (e.key === 'c' ||
                                        e.key === 'x' ||
                                        e.key === 'v')
                                    const isSelectAll =
                                      (e.ctrlKey || e.metaKey) && e.key === 'a'
                                    const isTabKey = e.key === 'Tab'
                                    if (
                                      !isCopyKeyCombination &&
                                      !isSelectAll &&
                                      !isTabKey
                                    ) {
                                      const isNumber = /^[0-9]*$/.test(e.key)
                                      const isAllowedKey =
                                        e.key === 'Delete' ||
                                        e.key === 'Backspace' ||
                                        e.key === 'ArrowLeft' ||
                                        e.key === 'ArrowRight'
                                      if (!isNumber && !isAllowedKey) {
                                        e.preventDefault()
                                      }
                                    }
                                  }}
                                  onPaste={e => {
                                    const pastedText = e.clipboardData.getData(
                                      'text/plain'
                                    )
                                    if (!/^\d*$/.test(pastedText)) {
                                      e.preventDefault()
                                    }
                                  }}
                                />
                                {!this.state.isBaselineDistanceValid && (
                                  <FormHelperText
                                    id="name-error-text"
                                    className="Error_msg"
                                  >
                                    Baseline Distance must be a positive integer
                                    between 1 and 2000000'
                                  </FormHelperText>
                                )}
                              </FormGroup>
                            </FormControl>
                          )}

                        {this.state.baselineDataType == 'lph' &&
                          this.state.vehicleSegment != 'DG Set' && (
                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '6px' }}
                            >
                              <FormGroup className="form-input">
                                <TextField
                                  id="baselineHours"
                                  name="baselineHours"
                                  className="textfield"
                                  margin="dense"
                                  label="Baseline Hours:"
                                  value={this.state.baselineHours}
                                  onChange={this.handleInputChange(
                                    'baselineHours'
                                  )}
                                  onBlur={this.checkBaselineHoursValidity}
                                  error={!this.state.isBaselineHoursValid}
                                  type="number"
                                  inputProps={{ pattern: '[0-9]*' }}
                                  onKeyDown={e => {
                                    const isCopyKeyCombination =
                                      (e.ctrlKey || e.metaKey) &&
                                      (e.key === 'c' ||
                                        e.key === 'x' ||
                                        e.key === 'v')
                                    const isSelectAll =
                                      (e.ctrlKey || e.metaKey) && e.key === 'a'
                                    const isTabKey = e.key === 'Tab'
                                    if (
                                      !isCopyKeyCombination &&
                                      !isSelectAll &&
                                      !isTabKey
                                    ) {
                                      const isNumber = /^[0-9]*$/.test(e.key)
                                      const isAllowedKey =
                                        e.key === 'Delete' ||
                                        e.key === 'Backspace' ||
                                        e.key === 'ArrowLeft' ||
                                        e.key === 'ArrowRight'
                                      if (!isNumber && !isAllowedKey) {
                                        e.preventDefault()
                                      }
                                    }
                                  }}
                                  onPaste={e => {
                                    const pastedText = e.clipboardData.getData(
                                      'text/plain'
                                    )
                                    if (!/^\d*$/.test(pastedText)) {
                                      e.preventDefault()
                                    }
                                  }}
                                />
                                {!this.state.isBaselineHoursValid && (
                                  <FormHelperText
                                    id="name-error-text"
                                    className="Error_msg"
                                  >
                                    Baseline Hours must be a positive integer
                                    between 1 and 24
                                  </FormHelperText>
                                )}
                              </FormGroup>
                            </FormControl>
                          )}
                      </div>

                      <InstallationImagesSection
                        client={this.props.client}
                        fileNames={this.state.fileNames}
                        documentUploadNewData={this.state.documentUploadNewData}
                        vehicleSolutionType={this.state.solutionType}
                        mode="edit"
                        onChange={imageState => this.setState(imageState)}
                        errorMessage={this.state.errorMessage}
                      />
                    </Grid>{' '}
                    <Grid item xs={6} sm={6}>
                      <Grid xs={12} sm={12} mt={4}>
                        Device *
                      </Grid>
                      <FormControl className="selectbox">
                        <FormGroup>
                          <TextField
                            id="serialNumber"
                            name="serialNumber"
                            className="textfield"
                            margin="dense"
                            // label="Serial Number"
                            type="text"
                            disabled={!this.isAdmin()}
                            value={this.state.uniqueDeviceId}
                          />
                        </FormGroup>
                      </FormControl>
                      <FormControl className="selectbox">
                        <FormGroup className="form-input">
                          <TextField
                            id="modelName"
                            name="modelName"
                            className="textfield"
                            margin="dense"
                            label="Model Name"
                            type="text"
                            disabled={!this.isAdmin()}
                            value={this.state.modelName}
                            onChange={this.handleInputChange('modelName')}
                          />
                        </FormGroup>
                      </FormControl>
                      <FormControl
                        className="selectbox"
                        style={{ marginTop: '10px' }}
                      >
                        <FormGroup className="form-input">
                          <TextField
                            id="deviceType"
                            name="deviceType"
                            className="textfield"
                            margin="dense"
                            label="Device Type"
                            type="text"
                            disabled={!this.isAdmin()}
                            value={this.state.deviceType}
                            onChange={this.handleInputChange('deviceType')}
                          />
                        </FormGroup>
                      </FormControl>
                      <FormControl
                        className="selectbox"
                        style={{ marginTop: '22px' }}
                      >
                        <FormGroup className="form-input">
                          <TextField
                            id="phoneNumber"
                            name="phoneNumber"
                            className="textfield"
                            margin="dense"
                            label="Phone Number"
                            type="text"
                            disabled={!this.isAdmin()}
                            value={this.state.phoneNumber}
                          />
                        </FormGroup>
                      </FormControl>
                      <FormControl
                        className="selectbox"
                        style={{ marginTop: '5px' }}
                      >
                        <FormGroup className="form-input">
                          <TextField
                            id="simProvider"
                            name="simProvider"
                            className="textfield"
                            margin="dense"
                            label="Service Provider"
                            type="text"
                            disabled={!this.isAdmin()}
                            value={this.state.simProvider}
                            onChange={this.handleInputChange('simProvider')}
                          />
                        </FormGroup>
                      </FormControl>
                      <FormControl
                        className="selectbox"
                        style={{ marginTop: '20px' }}
                      >
                        <FormGroup className="form-input">
                          <TextField
                            id="simNumber"
                            name="simNumber"
                            className="textfield"
                            margin="dense"
                            label="SIM Number"
                            // type="Multi-line"
                            value={this.state.simNumber}
                            disabled={!this.isAdmin()}
                            onChange={this.handleInputChange('simNumber')}
                          />
                        </FormGroup>

                        <FormGroup className="form-input">
                          <TextField
                            id="engineOnHours"
                            name="engineOnHours"
                            className="textfield"
                            margin="dense"
                            label="Engine On Hours"
                            value={this.state.engineOnHours}
                            onChange={this.handleInputChange('engineOnHours')}
                            error={!this.state.isengineOnHoursValid}
                            onBlur={this.checkItemValidity('engineOnHours')}
                            inputProps={{ pattern: '[0-9]*' }}
                            onKeyDown={e => {
                              const isCopyKeyCombination =
                                (e.ctrlKey || e.metaKey) &&
                                (e.key === 'c' ||
                                  e.key === 'x' ||
                                  e.key === 'v')
                              const isSelectAll =
                                (e.ctrlKey || e.metaKey) && e.key === 'a'
                              const isTabKey = e.key === 'Tab'
                              if (
                                !isCopyKeyCombination &&
                                !isSelectAll &&
                                !isTabKey
                              ) {
                                const isNumber = /^[0-9]*$/.test(e.key)
                                const isAllowedKey =
                                  e.key === 'Delete' ||
                                  e.key === 'Backspace' ||
                                  e.key === 'ArrowLeft' ||
                                  e.key === 'ArrowRight'
                                if (!isNumber && !isAllowedKey) {
                                  e.preventDefault()
                                }
                              }
                            }}
                            onPaste={e => {
                              const pastedText = e.clipboardData.getData(
                                'text/plain'
                              )
                              if (!/^\d*$/.test(pastedText)) {
                                e.preventDefault()
                              }
                            }}
                          />
                          <FormHelperText
                            id="name-error-text"
                            className="Error_msg"
                          >
                            {!this.state.isengineOnHoursValid
                              ? 'Invalid Engine On Hours'
                              : ''}
                          </FormHelperText>
                        </FormGroup>

                        <FormGroup className="form-input">
                          <TextField
                            id="odometerDistance"
                            name="odometerDistance"
                            className="textfield"
                            margin="dense"
                            label="Odometer Distance"
                            value={this.state.odometerDistance}
                            onChange={this.handleInputChange(
                              'odometerDistance'
                            )}
                            error={!this.state.isOdometerDistanceValid}
                            onBlur={this.checkItemValidity('odometerDistance')}
                            inputProps={{ pattern: '[0-9]*' }}
                            onKeyDown={e => {
                              const isCopyKeyCombination =
                                (e.ctrlKey || e.metaKey) &&
                                (e.key === 'c' ||
                                  e.key === 'x' ||
                                  e.key === 'v')
                              const isSelectAll =
                                (e.ctrlKey || e.metaKey) && e.key === 'a'
                              const isTabKey = e.key === 'Tab'
                              if (
                                !isCopyKeyCombination &&
                                !isSelectAll &&
                                !isTabKey
                              ) {
                                const isNumber = /^[0-9]*$/.test(e.key)
                                const isAllowedKey =
                                  e.key === 'Delete' ||
                                  e.key === 'Backspace' ||
                                  e.key === 'ArrowLeft' ||
                                  e.key === 'ArrowRight'
                                if (!isNumber && !isAllowedKey) {
                                  e.preventDefault()
                                }
                              }
                            }}
                            onPaste={e => {
                              const pastedText = e.clipboardData.getData(
                                'text/plain'
                              )
                              if (!/^\d*$/.test(pastedText)) {
                                e.preventDefault()
                              }
                            }}
                          />
                          <FormHelperText
                            id="name-error-text"
                            className="Error_msg"
                          >
                            {!this.state.isOdometerDistanceValid
                              ? 'Invalid Odometer Distance'
                              : ''}
                          </FormHelperText>
                        </FormGroup>

                        {(this.state.deviceType === 'obd' ||
                          this.state.deviceType === 'OBD') &&
                          this.state.vehicleSegment !== 'DG Set' && (
                            <Grid>
                              <h3>Gear Related Info</h3>
                              <Grid xs={12} sm={12} mt={4}>
                                Select Make *
                              </Grid>
                              <FormControl className="selectbox">
                                <FormGroup className="form-input">
                                  <SelectReact
                                    id="vehicleMake"
                                    name="vehicleMake"
                                    classes={classes}
                                    options={this.state.makesList.map(item => ({
                                      value: item.id,
                                      label: item.make
                                    }))}
                                    value={
                                      this.state.vehicleMakeId
                                        ? {
                                            value: this.state.vehicleMakeId,
                                            label: this.state.vehicleMake
                                          }
                                        : null
                                    }
                                    onChange={this.handleChangeMake}
                                    placeholder="Select"
                                  />
                                  <FormHelperText
                                    id="name-error-text"
                                    className="Error_msg"
                                  >
                                    {!this.state.isVehicleMakeValid
                                      ? 'Invalid Vehicle Make'
                                      : ''}
                                  </FormHelperText>
                                </FormGroup>
                              </FormControl>
                              <Grid xs={12} sm={12} mt={4}>
                                Select Model *
                              </Grid>
                              <FormControl className="selectbox">
                                <FormGroup className="form-input">
                                  <SelectReact
                                    id="vehicleModel"
                                    name="vehicleModel"
                                    classes={classes}
                                    options={this.state.modelsList.map(
                                      item => ({
                                        value: item.id,
                                        label: item.model
                                      })
                                    )}
                                    value={
                                      this.state.vehicleModel
                                        ? {
                                            value: this.state.vehicleModelId,
                                            label: this.state.vehicleModel
                                          }
                                        : null
                                    }
                                    onChange={this.handleChangeModelNew}
                                    placeholder="Select"
                                    error={!this.state.isVehicleModelValid}
                                  />
                                  <FormHelperText
                                    id="name-error-text"
                                    className="Error_msg"
                                  >
                                    {!this.state.isVehicleModelValid
                                      ? 'Invalid Vehicle Model'
                                      : ''}
                                  </FormHelperText>
                                </FormGroup>
                              </FormControl>
                            </Grid>
                          )}
                      </FormControl>
                      {/* <Grid xs={12} sm={12} style={{ marginTop: '20px' }}>
                        Accessories
                      </Grid>
                      <FormControl className="selectbox">
                        <FormGroup className="form-input">
                          <SelectReact
                            classes={classes}
                            options={this.state.accessoryDetails}
                            value={this.state.accessories}
                            onChange={this.handleChangeAccessories}
                            placeholder="Select Accessories"
                          />
                          <FormHelperText
                            id="name-error-text"
                            className="Error_msg"
                          >
                            {!this.state.isSpeedSensorValid
                              ? 'Invalid Selection'
                              : ''}
                          </FormHelperText>
                        </FormGroup>
                      </FormControl>


                        <Grid xs={12} sm={12} style={{ marginTop: '5px' }}>
                        Subscription(SoftwareQty-Charges) *
                        </Grid>
                      <FormControl className="selectbox">
                        <FormGroup className="form-input">

                          <SelectReact
                            classes={classes}
                            options={this.state.subscriptionDetails}
                            value={this.state.subscriptionId}
                            onChange={this.handleChangeSubscription}
                            placeholder="Select Subscription(SoftwareQty-Charges) *"
                          />
                        </FormGroup>
                      </FormControl> */}
                      {/* Technician selection: choose category then pick technician from respective list */}
                      <Grid xs={12} sm={12} style={{ marginTop: '12px' }}>
                        Technician
                      </Grid>
                      <FormControl
                        className="selectbox"
                        style={{ marginTop: '5px' }}
                      >
                        <FormGroup className="form-input">
                          <SelectReact
                            classes={classes}
                            options={[
                              {
                                label: 'Technician - Taabi Personal',
                                value: 'Technician - Taabi Personal'
                              },
                              {
                                label: 'Technician - Freelancer',
                                value: 'Technician - Freelancer'
                              }
                            ]}
                            value={
                              this.state.technicianCategory
                                ? {
                                    label: this.state.technicianCategory,
                                    value: this.state.technicianCategory
                                  }
                                : null
                            }
                            onChange={this.handleTechnicianCategoryChange}
                            placeholder="Select Technician Category"
                            isSearchable
                          />
                        </FormGroup>
                      </FormControl>
                      {this.state.technicianCategory ===
                        'Technician - Taabi Personal' && (
                        <FormControl
                          className="selectbox"
                          style={{ marginTop: '8px' }}
                        >
                          <FormGroup className="form-input">
                            <SelectReact
                              classes={classes}
                              options={this.state.assignedTechniciansTaabi}
                              value={this.state.selectedTaabiTechnician}
                              onChange={this.handleTaabiSelectChange}
                              placeholder="Select Technician - Taabi Personal"
                              isSearchable
                            />
                          </FormGroup>
                        </FormControl>
                      )}
                      {this.state.technicianCategory ===
                        'Technician - Freelancer' && (
                        <FormControl
                          className="selectbox"
                          style={{ marginTop: '8px' }}
                        >
                          <FormGroup className="form-input">
                            <SelectReact
                              classes={classes}
                              options={this.state.assignedTechniciansFreelancer}
                              value={this.state.selectedFreelancerTechnician}
                              onChange={this.handleFreelancerSelectChange}
                              placeholder="Select Technician - Freelancer"
                              isSearchable
                            />
                          </FormGroup>
                        </FormControl>
                      )}
                      <Button
                        variant="contained"
                        component="span"
                        onClick={() => this.handleGenerate()}
                        style={{ marginTop: '20px' }}
                      >
                        Generate Certificate
                      </Button>&nbsp;&nbsp;&nbsp;&nbsp;
                      <Button
                        variant="contained"
                        component="span"
                        onClick={() => this.downloadCertificate()}
                        style={{ marginTop: '20px' }}
                      >
                        Download Certificate
                      </Button>
                    </Grid>{' '}
                  </Grid>

                  <Grid
                    container
                    fullwidth
                    style={{
                      marginTop: '20px'
                    }}
                  >
                    <Grid item xs={12} sm={6}>
                      <Grid item xs={12} sm={12}>
                        {this.state.status !== 2 && (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={this.state.installStatus}
                                onChange={this.handleChange('installStatus')}
                                value="installStatus"
                                color="primary"
                                disabled={this.state.installStatus}
                              />
                            }
                            label="Installation Completed"
                          />
                        )}
                        {this.state.status === 2 && (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={this.state.installStatus}
                                onClick={this.handleChange('installStatus')}
                                value="installStatus"
                                color="primary"
                                // disabled={this.state.installStatus}
                              />
                            }
                            label="Installation Completed"
                          />
                        )}
                      </Grid>
                      {this.state.vehicleSegment != 'DG Set' && (
                        <Grid item xs={12} sm={12}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={this.state.immobilize}
                                onClick={this.handleImmobilizeChange(
                                  'immobilize'
                                )}
                                value="immobilize"
                                color="primary"
                                // disabled={this.state.installStatus}
                              />
                            }
                            label="Immobilizable"
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
                <FormGroup className="form-input">
                  {this.state.vtValidationError && (
                    <p
                      style={{
                        color: 'red',
                        textAlign: 'center',
                        marginBottom: '8px',
                        fontWeight: 500
                      }}
                    >
                      {this.state.vtValidationError}
                    </p>
                  )}
                  <Grid justify="center" container>
                    <Button
                      color="default"
                      variant="outlined"
                      size="medium"
                      margin="normal"
                      className="btn"
                      href="../../VehcileDashboard/Dashboard"
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      size="medium"
                      margin="normal"
                      className="btn"
                      type="button"
                      onClick={this.handleSubmit(this.props.client)}
                      disabled={this.isSubmitFormInvalid()}
                      // disabled={
                      //   this.state.errorMessage !== null ||
                      //   this.state.errorMessageNew !== null ||
                      //   this.state.errorMessageFuelTank !== null ||
                      //   this.state.isUploading ||
                      //   !this.state.isBaselineDataForFEValid ||
                      //   !this.state.isBaselineDistanceValid ||
                      //   !this.state.isDepartmentValid ||
                      //   !this.state.isContractorNameValid ||
                      //   !this.state.isEquipmentNameValid ||
                      //   !this.state.isEquipmentValid ||
                      //   !this.state.isInvoiceNoValid ||
                      //   !this.state.invoiceNumber||
                      //   !this.state.invoiceDate.date||
                      //   !(
                      //     this.state.isVlpnValid &&
                      //     this.state.vlpn !== '' &&
                      //     this.state.isSpeedLimitValid &&
                      //     this.state.isVehicleModelValid &&
                      //     this.state.isVehicleMakeValid &&
                      //     this.state.isVehicleTypeValid &&
                      //     this.state.isSpeedSensorValid &&
                      //     this.state.speedSensorType !== '' &&
                      //     this.state.speedLimit !== '' &&
                      //     this.state.vehicleType !== '' &&
                      //     this.state.vehicleModel &&
                      //     this.state.vehicleMake &&
                      //     this.state.isBaselineDataForFEValid

                      //   ) ||
                      //   this.state.portedVehicle ==='' ||
                      //    this.state.portedVehicle ===null||
                      //   this.state.isTestingVehicle ==='' ||
                      //    this.state.isTestingVehicle ===null||
                      //   this.state.solutionType === '' ||
                      //   (this.state.throughChannelPartner &&
                      //     this.state.channelPartnerName === '') ||
                      //   (this.state.throughChannelPartner &&
                      //     this.state.channelPartnerName === null) ||
                      //   this.state.zmId === '' ||
                      //   this.state.zmId === null ||
                      //   this.state.kamId === '' ||
                      //   this.state.kamId === null ||
                      //   (this.state.vehicleSegment === null ||
                      //     this.state.vehicleSegment === '') ||
                      //   (this.state.vehicleSegment === 'Transportation' &&
                      //     (!this.state.application ||
                      //       !['M&HCV', 'LM', 'PC', '2W', '3W', 'LCV'].includes(
                      //         this.state.equipmentTypeClass
                      //       ) ||
                      //       !this.state.vehicleWheeler)) ||
                      //   (this.state.vehicleSegment === 'EVs' &&
                      //     !this.state.equipmentTypeClassText) ||
                      //   (this.state.vehicleSegment === 'Construction' &&
                      //     !['Excavator', 'Crane', 'Gantry', 'Grader'].includes(
                      //       this.state.equipmentTypeClass
                      //     )) ||
                      //   (
                      //     this.state.vehicleSegment == 'DG Set' && !this.state.fuelTankCapacity
                      //   ) ||
                      //   (
                      //     this.state.vehicleSegment == 'DG Set' && !this.state.kvaRating
                      //   ) ||
                      //   (
                      //     this.state.vehicleSegment == 'DG Set' && !this.state.dgSetType

                      //   ) ||
                      //   (this.state.selectedVTM && !this.state.videoTelematicsId)
                      // }
                    >
                      Submit
                    </Button>
                    {/* <Button
                      color="primary"
                      variant="contained"
                      size="medium"
                      margin="normal"
                      className="btn"
                      onClick={event => this.handleClickOpen()}
                    >
                      {this.state.status === 0 || this.state.status === 3
                        ? 'Activate'
                        : 'De-Activate/Service'}
                    </Button> */}
                    {/* <Button
                      color="default"
                      variant="contained"
                      size="medium"
                      margin="normal"
                      className="btn"
                      onClick={event => this.handleDecoupleOpen()}
                    >
                      Decouple
                    </Button> */}
                  </Grid>

                  <Dialog
                    open={this.state.open}
                    keepMounted
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                  >
                    <ChangeVehicleStatus
                      handleClose={this.handleClose}
                      vehicleStatus={this.state.status}
                      uniqueDeviceId={this.state.uniqueDeviceId}
                    />
                  </Dialog>
                  <Dialog
                    open={this.state.open3}
                    onClose={
                      this.handleMailClose // keepMounted
                    }
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                  >
                    <div>
                      <DialogTitle id="alert-dialog-title">
                        {'Enter Your Mail Address'}
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                          <TextField
                            id="email"
                            name="email"
                            className="textfield"
                            margin="dense"
                            label="Email"
                            onChange={this.handleMailChange}
                            error={!this.state.ismailValid}
                            onBlur={this.checkMail}
                            value={this.state.mail}
                          />
                          <FormHelperText
                            id="name-error-text"
                            className="Error_msg"
                          >
                            {!this.state.ismailValid ? 'Mail is not Valid' : ''}
                          </FormHelperText>
                          {/* <h2>{this.state.PDFLink}</h2> */}
                          <DialogActions>
                            <Button
                              onClick={this.handleMailClose}
                              color="default"
                              variant="contained"
                            >
                              Cancel
                            </Button>
                            <Button
                              type="submit"
                              color="primary"
                              variant="contained"
                              disabled={
                                !(
                                  this.state.mail !== '' &&
                                  this.state.ismailValid
                                )
                              }
                              onClick={() => this.handleSendMail()}
                            >
                              Submit
                            </Button>
                          </DialogActions>
                        </DialogContentText>
                      </DialogContent>
                    </div>
                  </Dialog>
                  <Dialog
                    open={this.state.open2}
                    onClose={this.handleDecoupleClose}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                  >
                    <DecoupleDevices
                      handleClose={this.handleDecoupleClose}
                      vehicleStatus={this.state.status}
                      uniqueDeviceId={this.state.uniqueDeviceId}
                      simId={this.state.simId}
                      clientLoginId={this.state.clientLoginId}
                    />
                  </Dialog>
                  <Dialog
                    open={this.state.swapOpen}
                    keepMounted
                    onClose={this.handleSwapClose}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                  >
                    <SwapClient
                      handleClose={this.handleSwapClose}
                      clientLoginId={this.state.clientLoginId}
                      clientName={this.state.clientName}
                      vlpn={this.state.vlpn}
                    />
                  </Dialog>
                  <Dialog
                    open={this.state.deleteOpen}
                    keepMounted
                    onClose={this.handleDeleteClose}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                  >
                    <DeleteVehicle
                      handleClose={this.handleDeleteClose}
                      uniqueDeviceId={this.state.uniqueDeviceId}
                      handleSucessDeleteClose={this.handleSucessDeleteClose}
                    />
                  </Dialog>
                </FormGroup>
              </div>
            </form>
            {/* </ItemCard> */}
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default withStyles(styles)(
  withApollo(withSharedSnackbar(VehicleRegistration))
)



// WEBPACK FOOTER //
// ./src/components/Modules/VehicleRegistartion/VehicleEdit/index.jsx